//#region ../../../node_modules/tslib/tslib.es6.mjs
var e = function(t, n) {
	return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
		e.__proto__ = t;
	} || function(e, t) {
		for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
	}, e(t, n);
};
function t(t, n) {
	if (typeof n != "function" && n !== null) throw TypeError("Class extends value " + String(n) + " is not a constructor or null");
	e(t, n);
	function r() {
		this.constructor = t;
	}
	t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
}
var n = function() {
	return n = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, n.apply(this, arguments);
};
function r(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function i(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
function a(e, t) {
	var n = {
		label: 0,
		sent: function() {
			if (a[0] & 1) throw a[1];
			return a[1];
		},
		trys: [],
		ops: []
	}, r, i, a, o;
	return o = {
		next: s(0),
		throw: s(1),
		return: s(2)
	}, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
		return this;
	}), o;
	function s(e) {
		return function(t) {
			return c([e, t]);
		};
	}
	function c(s) {
		if (r) throw TypeError("Generator is already executing.");
		for (; o && (o = 0, s[0] && (n = 0)), n;) try {
			if (r = 1, i && (a = s[0] & 2 ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
			switch (i = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
				case 0:
				case 1:
					a = s;
					break;
				case 4: return n.label++, {
					value: s[1],
					done: !1
				};
				case 5:
					n.label++, i = s[1], s = [0];
					continue;
				case 7:
					s = n.ops.pop(), n.trys.pop();
					continue;
				default:
					if ((a = n.trys, !(a = a.length > 0 && a[a.length - 1])) && (s[0] === 6 || s[0] === 2)) {
						n = 0;
						continue;
					}
					if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
						n.label = s[1];
						break;
					}
					if (s[0] === 6 && n.label < a[1]) {
						n.label = a[1], a = s;
						break;
					}
					if (a && n.label < a[2]) {
						n.label = a[2], n.ops.push(s);
						break;
					}
					a[2] && n.ops.pop(), n.trys.pop();
					continue;
			}
			s = t.call(e, n);
		} catch (e) {
			s = [6, e], i = 0;
		} finally {
			r = a = 0;
		}
		if (s[0] & 5) throw s[1];
		return {
			value: s[0] ? s[1] : void 0,
			done: !0
		};
	}
}
function o(e) {
	var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
	if (n) return n.call(e);
	if (e && typeof e.length == "number") return { next: function() {
		return e && r >= e.length && (e = void 0), {
			value: e && e[r++],
			done: !e
		};
	} };
	throw TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function s(e, t) {
	var n = typeof Symbol == "function" && e[Symbol.iterator];
	if (!n) return e;
	var r = n.call(e), i, a = [], o;
	try {
		for (; (t === void 0 || t-- > 0) && !(i = r.next()).done;) a.push(i.value);
	} catch (e) {
		o = { error: e };
	} finally {
		try {
			i && !i.done && (n = r.return) && n.call(r);
		} finally {
			if (o) throw o.error;
		}
	}
	return a;
}
function c(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
function l(e) {
	return this instanceof l ? (this.v = e, this) : new l(e);
}
function u(e, t, n) {
	if (!Symbol.asyncIterator) throw TypeError("Symbol.asyncIterator is not defined.");
	var r = n.apply(e, t || []), i, a = [];
	return i = {}, o("next"), o("throw"), o("return"), i[Symbol.asyncIterator] = function() {
		return this;
	}, i;
	function o(e) {
		r[e] && (i[e] = function(t) {
			return new Promise(function(n, r) {
				a.push([
					e,
					t,
					n,
					r
				]) > 1 || s(e, t);
			});
		});
	}
	function s(e, t) {
		try {
			c(r[e](t));
		} catch (e) {
			f(a[0][3], e);
		}
	}
	function c(e) {
		e.value instanceof l ? Promise.resolve(e.value.v).then(u, d) : f(a[0][2], e);
	}
	function u(e) {
		s("next", e);
	}
	function d(e) {
		s("throw", e);
	}
	function f(e, t) {
		e(t), a.shift(), a.length && s(a[0][0], a[0][1]);
	}
}
function d(e) {
	if (!Symbol.asyncIterator) throw TypeError("Symbol.asyncIterator is not defined.");
	var t = e[Symbol.asyncIterator], n;
	return t ? t.call(e) : (e = typeof o == "function" ? o(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
		return this;
	}, n);
	function r(t) {
		n[t] = e[t] && function(n) {
			return new Promise(function(r, a) {
				n = e[t](n), i(r, a, n.done, n.value);
			});
		};
	}
	function i(e, t, n, r) {
		Promise.resolve(r).then(function(t) {
			e({
				value: t,
				done: n
			});
		}, t);
	}
}
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/types/messages.js
var f = "Event tracked successfully", p = "Unexpected error occurred", m = "Event rejected due to exceeded retry count", h = "Event skipped due to optOut config", g = "Event rejected due to missing API key", _ = "Client not initialized", v;
(function(e) {
	e.Unknown = "unknown", e.Skipped = "skipped", e.Success = "success", e.RateLimit = "rate_limit", e.PayloadTooLarge = "payload_too_large", e.Invalid = "invalid", e.Failed = "failed", e.Timeout = "Timeout", e.SystemError = "SystemError";
})(v ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/utils/result-builder.js
var y = function(e, t, n) {
	return t === void 0 && (t = 0), n === void 0 && (n = v.Unknown), {
		event: e,
		code: t,
		message: n
	};
}, b = function(e) {
	return e ? (e ^ Math.random() * 16 >> e / 4).toString(16) : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, b);
}, x = function() {
	function e(e) {
		this.client = e, this.queue = [], this.applying = !1, this.plugins = [];
	}
	return e.prototype.register = function(e, t) {
		return i(this, void 0, void 0, function() {
			return a(this, function(n) {
				switch (n.label) {
					case 0: return this.plugins.some(function(t) {
						return t.name === e.name;
					}) ? (t.loggerProvider.warn(`Plugin with name ${e.name} already exists, skipping registration`), [2]) : (e.name === void 0 && (e.name = b(), t.loggerProvider.warn(`Plugin name is undefined. 
      Generating a random UUID for plugin name: ${e.name}. 
      Set a name for the plugin to prevent it from being added multiple times.`)), e.type = e.type ?? "enrichment", [4, e.setup?.call(e, t, this.client)]);
					case 1: return n.sent(), this.plugins.push(e), [2];
				}
			});
		});
	}, e.prototype.deregister = function(e, t) {
		return i(this, void 0, void 0, function() {
			var n, r;
			return a(this, function(i) {
				switch (i.label) {
					case 0: return n = this.plugins.findIndex(function(t) {
						return t.name === e;
					}), n === -1 ? (t.loggerProvider.warn(`Plugin with name ${e} does not exist, skipping deregistration`), [2]) : (r = this.plugins[n], this.plugins.splice(n, 1), [4, r.teardown?.call(r)]);
					case 1: return i.sent(), [2];
				}
			});
		});
	}, e.prototype.reset = function(e) {
		this.applying = !1, this.plugins.map(function(e) {
			return e.teardown?.call(e);
		}), this.plugins = [], this.client = e;
	}, e.prototype.push = function(e) {
		var t = this;
		return new Promise(function(n) {
			t.queue.push([e, n]), t.scheduleApply(0);
		});
	}, e.prototype.scheduleApply = function(e) {
		var t = this;
		this.applying || (this.applying = !0, setTimeout(function() {
			t.apply(t.queue.shift()).then(function() {
				t.applying = !1, t.queue.length > 0 && t.scheduleApply(0);
			});
		}, e));
	}, e.prototype.apply = function(e) {
		return i(this, void 0, void 0, function() {
			var t, r, i, c, l, u, d, f, p, m, h, g, _, f, p, v, b, x, S, C, w, T;
			return a(this, function(a) {
				switch (a.label) {
					case 0:
						if (!e) return [2];
						t = s(e, 1), r = t[0], i = s(e, 2), c = i[1], l = this.plugins.filter(function(e) {
							return e.type === "before";
						}), a.label = 1;
					case 1: a.trys.push([
						1,
						6,
						7,
						8
					]), u = o(l), d = u.next(), a.label = 2;
					case 2: return d.done ? [3, 5] : (f = d.value, f.execute ? [4, f.execute(n({}, r))] : [3, 4]);
					case 3:
						if (p = a.sent(), p === null) return c({
							event: r,
							code: 0,
							message: ""
						}), [2];
						r = p, a.label = 4;
					case 4: return d = u.next(), [3, 2];
					case 5: return [3, 8];
					case 6: return m = a.sent(), S = { error: m }, [3, 8];
					case 7:
						try {
							d && !d.done && (C = u.return) && C.call(u);
						} finally {
							if (S) throw S.error;
						}
						return [7];
					case 8: h = this.plugins.filter(function(e) {
						return e.type === "enrichment" || e.type === void 0;
					}), a.label = 9;
					case 9: a.trys.push([
						9,
						14,
						15,
						16
					]), g = o(h), _ = g.next(), a.label = 10;
					case 10: return _.done ? [3, 13] : (f = _.value, f.execute ? [4, f.execute(n({}, r))] : [3, 12]);
					case 11:
						if (p = a.sent(), p === null) return c({
							event: r,
							code: 0,
							message: ""
						}), [2];
						r = p, a.label = 12;
					case 12: return _ = g.next(), [3, 10];
					case 13: return [3, 16];
					case 14: return v = a.sent(), w = { error: v }, [3, 16];
					case 15:
						try {
							_ && !_.done && (T = g.return) && T.call(g);
						} finally {
							if (w) throw w.error;
						}
						return [7];
					case 16: return b = this.plugins.filter(function(e) {
						return e.type === "destination";
					}), x = b.map(function(e) {
						var t = n({}, r);
						return e.execute(t).catch(function(e) {
							return y(t, 0, String(e));
						});
					}), Promise.all(x).then(function(e) {
						var t = s(e, 1)[0] || y(r, 100, "Event not tracked, no destination plugins on the instance");
						c(t);
					}), [2];
				}
			});
		});
	}, e.prototype.flush = function() {
		return i(this, void 0, void 0, function() {
			var e, t, n, r = this;
			return a(this, function(i) {
				switch (i.label) {
					case 0: return e = this.queue, this.queue = [], [4, Promise.all(e.map(function(e) {
						return r.apply(e);
					}))];
					case 1: return i.sent(), t = this.plugins.filter(function(e) {
						return e.type === "destination";
					}), n = t.map(function(e) {
						return e.flush && e.flush();
					}), [4, Promise.all(n)];
					case 2: return i.sent(), [2];
				}
			});
		});
	}, e;
}(), S = "AMP_unsent", C = "https://api2.amplitude.com/2/httpapi", w = "https://api.eu.amplitude.com/2/httpapi", T = "https://api2.amplitude.com/batch", ee = "https://api.eu.amplitude.com/batch", te = 1e3, E = function(e) {
	if (Object.keys(e).length > te) return !1;
	for (var t in e) {
		var n = e[t];
		if (!D(t, n)) return !1;
	}
	return !0;
}, D = function(e, t) {
	var n, r;
	if (typeof e != "string") return !1;
	if (Array.isArray(t)) {
		var i = !0;
		try {
			for (var a = o(t), s = a.next(); !s.done; s = a.next()) {
				var c = s.value;
				if (Array.isArray(c)) return !1;
				if (typeof c == "object") i &&= E(c);
				else if (!["number", "string"].includes(typeof c)) return !1;
				if (!i) return !1;
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				s && !s.done && (r = a.return) && r.call(a);
			} finally {
				if (n) throw n.error;
			}
		}
	} else if (t == null) return !1;
	else if (typeof t == "object") return E(t);
	else if (![
		"number",
		"string",
		"boolean"
	].includes(typeof t)) return !1;
	return !0;
}, O = function() {
	function e() {
		this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
	}
	return e.prototype.getUserProperties = function() {
		return n({}, this._properties);
	}, e.prototype.set = function(e, t) {
		return this._safeSet(k.SET, e, t), this;
	}, e.prototype.setOnce = function(e, t) {
		return this._safeSet(k.SET_ONCE, e, t), this;
	}, e.prototype.append = function(e, t) {
		return this._safeSet(k.APPEND, e, t), this;
	}, e.prototype.prepend = function(e, t) {
		return this._safeSet(k.PREPEND, e, t), this;
	}, e.prototype.postInsert = function(e, t) {
		return this._safeSet(k.POSTINSERT, e, t), this;
	}, e.prototype.preInsert = function(e, t) {
		return this._safeSet(k.PREINSERT, e, t), this;
	}, e.prototype.remove = function(e, t) {
		return this._safeSet(k.REMOVE, e, t), this;
	}, e.prototype.add = function(e, t) {
		return this._safeSet(k.ADD, e, t), this;
	}, e.prototype.unset = function(e) {
		return this._safeSet(k.UNSET, e, "-"), this;
	}, e.prototype.clearAll = function() {
		return this._properties = {}, this._properties[k.CLEAR_ALL] = "-", this;
	}, e.prototype._safeSet = function(e, t, n) {
		if (this._validate(e, t, n)) {
			var r = this._properties[e];
			return r === void 0 && (r = {}, this._properties[e] = r), r[t] = n, this._propertySet.add(t), !0;
		}
		return !1;
	}, e.prototype._validate = function(e, t, n) {
		return this._properties[k.CLEAR_ALL] !== void 0 || this._propertySet.has(t) ? !1 : e === k.ADD ? typeof n == "number" : e !== k.UNSET && e !== k.REMOVE ? D(t, n) : !0;
	}, e;
}(), k;
(function(e) {
	e.SET = "$set", e.SET_ONCE = "$setOnce", e.ADD = "$add", e.APPEND = "$append", e.PREPEND = "$prepend", e.REMOVE = "$remove", e.PREINSERT = "$preInsert", e.POSTINSERT = "$postInsert", e.UNSET = "$unset", e.CLEAR_ALL = "$clearAll";
})(k ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/types/event/event.js
var ne;
(function(e) {
	e.SET = "$set", e.SET_ONCE = "$setOnce", e.ADD = "$add", e.APPEND = "$append", e.PREPEND = "$prepend", e.REMOVE = "$remove", e.PREINSERT = "$preInsert", e.POSTINSERT = "$postInsert", e.UNSET = "$unset", e.CLEAR_ALL = "$clearAll";
})(ne ||= {});
var A;
(function(e) {
	e.IDENTIFY = "$identify", e.GROUP_IDENTIFY = "$groupidentify", e.REVENUE = "revenue_amount";
})(A ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/utils/event-builder.js
var re = function(e, t, r) {
	return n(n(n({}, typeof e == "string" ? { event_type: e } : e), r), t && { event_properties: t });
}, j = function(e, t) {
	return n(n({}, t), {
		event_type: A.IDENTIFY,
		user_properties: e.getUserProperties()
	});
}, ie = function(e, t, r, i) {
	var a;
	return n(n({}, i), {
		event_type: A.GROUP_IDENTIFY,
		group_properties: r.getUserProperties(),
		groups: (a = {}, a[e] = t, a)
	});
}, ae = function(e, t, r) {
	var i, a = new O();
	return a.set(e, t), n(n({}, r), {
		event_type: A.IDENTIFY,
		user_properties: a.getUserProperties(),
		groups: (i = {}, i[e] = t, i)
	});
}, oe = function(e, t) {
	return n(n({}, t), {
		event_type: A.REVENUE,
		event_properties: e.getEventProperties()
	});
}, M = function(e) {
	return { promise: e || Promise.resolve() };
}, se = function() {
	function e(e) {
		e === void 0 && (e = "$default"), this.initializing = !1, this.isReady = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new x(this), this.name = e;
	}
	return e.prototype._init = function(e) {
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				switch (t.label) {
					case 0: return this.config = e, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
					case 1: return t.sent(), this.isReady = !0, [2];
				}
			});
		});
	}, e.prototype.runQueuedFunctions = function(e) {
		return i(this, void 0, void 0, function() {
			var t, n, r, i, s, c, l, u;
			return a(this, function(a) {
				switch (a.label) {
					case 0: t = this[e], this[e] = [], a.label = 1;
					case 1: a.trys.push([
						1,
						8,
						9,
						10
					]), n = o(t), r = n.next(), a.label = 2;
					case 2: return r.done ? [3, 7] : (i = r.value, s = i(), s && "promise" in s ? [4, s.promise] : [3, 4]);
					case 3: return a.sent(), [3, 6];
					case 4: return [4, s];
					case 5: a.sent(), a.label = 6;
					case 6: return r = n.next(), [3, 2];
					case 7: return [3, 10];
					case 8: return c = a.sent(), l = { error: c }, [3, 10];
					case 9:
						try {
							r && !r.done && (u = n.return) && u.call(n);
						} finally {
							if (l) throw l.error;
						}
						return [7];
					case 10: return this[e].length ? [4, this.runQueuedFunctions(e)] : [3, 12];
					case 11: a.sent(), a.label = 12;
					case 12: return [2];
				}
			});
		});
	}, e.prototype.track = function(e, t, n) {
		var r = re(e, t, n);
		return M(this.dispatch(r));
	}, e.prototype.identify = function(e, t) {
		var n = j(e, t);
		return M(this.dispatch(n));
	}, e.prototype.groupIdentify = function(e, t, n, r) {
		var i = ie(e, t, n, r);
		return M(this.dispatch(i));
	}, e.prototype.setGroup = function(e, t, n) {
		var r = ae(e, t, n);
		return M(this.dispatch(r));
	}, e.prototype.revenue = function(e, t) {
		var n = oe(e, t);
		return M(this.dispatch(n));
	}, e.prototype.add = function(e) {
		return this.isReady ? this._addPlugin(e) : (this.q.push(this._addPlugin.bind(this, e)), M());
	}, e.prototype._addPlugin = function(e) {
		return M(this.timeline.register(e, this.config));
	}, e.prototype.remove = function(e) {
		return this.isReady ? this._removePlugin(e) : (this.q.push(this._removePlugin.bind(this, e)), M());
	}, e.prototype._removePlugin = function(e) {
		return M(this.timeline.deregister(e, this.config));
	}, e.prototype.dispatchWithCallback = function(e, t) {
		if (!this.isReady) return t(y(e, 0, _));
		this.process(e).then(t);
	}, e.prototype.dispatch = function(e) {
		return i(this, void 0, void 0, function() {
			var t = this;
			return a(this, function(n) {
				return this.isReady ? [2, this.process(e)] : [2, new Promise(function(n) {
					t.dispatchQ.push(t.dispatchWithCallback.bind(t, e, n));
				})];
			});
		});
	}, e.prototype.process = function(e) {
		return i(this, void 0, void 0, function() {
			var t, n, r, t;
			return a(this, function(i) {
				switch (i.label) {
					case 0: return i.trys.push([
						0,
						2,
						,
						3
					]), this.config.optOut ? [2, y(e, 0, h)] : [4, this.timeline.push(e)];
					case 1: return t = i.sent(), t.code === 200 ? this.config.loggerProvider.log(t.message) : t.code === 100 ? this.config.loggerProvider.warn(t.message) : this.config.loggerProvider.error(t.message), [2, t];
					case 2: return n = i.sent(), r = String(n), this.config.loggerProvider.error(r), t = y(e, 0, r), [2, t];
					case 3: return [2];
				}
			});
		});
	}, e.prototype.setOptOut = function(e) {
		if (!this.isReady) {
			this.q.push(this._setOptOut.bind(this, !!e));
			return;
		}
		this._setOptOut(e);
	}, e.prototype._setOptOut = function(e) {
		this.config.optOut = !!e;
	}, e.prototype.flush = function() {
		return M(this.timeline.flush());
	}, e;
}(), ce = function() {
	function e() {
		this.productId = "", this.quantity = 1, this.price = 0;
	}
	return e.prototype.setProductId = function(e) {
		return this.productId = e, this;
	}, e.prototype.setQuantity = function(e) {
		return e > 0 && (this.quantity = e), this;
	}, e.prototype.setPrice = function(e) {
		return this.price = e, this;
	}, e.prototype.setRevenueType = function(e) {
		return this.revenueType = e, this;
	}, e.prototype.setCurrency = function(e) {
		return this.currency = e, this;
	}, e.prototype.setRevenue = function(e) {
		return this.revenue = e, this;
	}, e.prototype.setReceipt = function(e) {
		return this.receipt = e, this;
	}, e.prototype.setReceiptSig = function(e) {
		return this.receiptSig = e, this;
	}, e.prototype.setEventProperties = function(e) {
		return E(e) && (this.properties = e), this;
	}, e.prototype.getEventProperties = function() {
		var e = this.properties ? n({}, this.properties) : {};
		return e[N.REVENUE_PRODUCT_ID] = this.productId, e[N.REVENUE_QUANTITY] = this.quantity, e[N.REVENUE_PRICE] = this.price, e[N.REVENUE_TYPE] = this.revenueType, e[N.REVENUE_CURRENCY] = this.currency, e[N.REVENUE] = this.revenue, e[N.RECEIPT] = this.receipt, e[N.RECEIPT_SIG] = this.receiptSig, e;
	}, e;
}(), N;
(function(e) {
	e.REVENUE_PRODUCT_ID = "$productId", e.REVENUE_QUANTITY = "$quantity", e.REVENUE_PRICE = "$price", e.REVENUE_TYPE = "$revenueType", e.REVENUE_CURRENCY = "$currency", e.REVENUE = "$revenue", e.RECEIPT = "$receipt", e.RECEIPT_SIG = "$receiptSig";
})(N ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/utils/chunk.js
var le = function(e, t) {
	var n = Math.max(t, 1);
	return e.reduce(function(e, t, r) {
		var i = Math.floor(r / n);
		return e[i] || (e[i] = []), e[i].push(t), e;
	}, []);
}, P;
(function(e) {
	e[e.None = 0] = "None", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Verbose = 3] = "Verbose", e[e.Debug = 4] = "Debug";
})(P ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/logger.js
var ue = "Amplitude Logger ", de = function() {
	function e() {
		this.logLevel = P.None;
	}
	return e.prototype.disable = function() {
		this.logLevel = P.None;
	}, e.prototype.enable = function(e) {
		e === void 0 && (e = P.Warn), this.logLevel = e;
	}, e.prototype.log = function() {
		var e = [...arguments];
		this.logLevel < P.Verbose || console.log(`${ue}[Log]: ${e.join(" ")}`);
	}, e.prototype.warn = function() {
		var e = [...arguments];
		this.logLevel < P.Warn || console.warn(`${ue}[Warn]: ${e.join(" ")}`);
	}, e.prototype.error = function() {
		var e = [...arguments];
		this.logLevel < P.Error || console.error(`${ue}[Error]: ${e.join(" ")}`);
	}, e.prototype.debug = function() {
		var e = [...arguments];
		this.logLevel < P.Debug || console.log(`${ue}[Debug]: ${e.join(" ")}`);
	}, e;
}(), fe = function() {
	return {
		flushMaxRetries: 12,
		flushQueueSize: 200,
		flushIntervalMillis: 1e4,
		instanceName: "$default_instance",
		logLevel: P.Warn,
		loggerProvider: new de(),
		offline: !1,
		optOut: !1,
		serverUrl: C,
		serverZone: "US",
		useBatch: !1
	};
}, pe = function() {
	function e(e) {
		this._optOut = !1;
		var t = fe();
		this.apiKey = e.apiKey, this.flushIntervalMillis = e.flushIntervalMillis ?? t.flushIntervalMillis, this.flushMaxRetries = e.flushMaxRetries || t.flushMaxRetries, this.flushQueueSize = e.flushQueueSize || t.flushQueueSize, this.instanceName = e.instanceName || t.instanceName, this.loggerProvider = e.loggerProvider || t.loggerProvider, this.logLevel = e.logLevel ?? t.logLevel, this.minIdLength = e.minIdLength, this.plan = e.plan, this.ingestionMetadata = e.ingestionMetadata, this.offline = e.offline === void 0 ? t.offline : e.offline, this.optOut = e.optOut ?? t.optOut, this.serverUrl = e.serverUrl, this.serverZone = e.serverZone || t.serverZone, this.storageProvider = e.storageProvider, this.transportProvider = e.transportProvider, this.useBatch = e.useBatch ?? t.useBatch, this.loggerProvider.enable(this.logLevel);
		var n = he(e.serverUrl, e.serverZone, e.useBatch);
		this.serverZone = n.serverZone, this.serverUrl = n.serverUrl;
	}
	return Object.defineProperty(e.prototype, "optOut", {
		get: function() {
			return this._optOut;
		},
		set: function(e) {
			this._optOut = e;
		},
		enumerable: !1,
		configurable: !0
	}), e;
}(), me = function(e, t) {
	return e === "EU" ? t ? ee : w : t ? T : C;
}, he = function(e, t, n) {
	if (e === void 0 && (e = ""), t === void 0 && (t = fe().serverZone), n === void 0 && (n = fe().useBatch), e) return {
		serverUrl: e,
		serverZone: void 0
	};
	var r = ["US", "EU"].includes(t) ? t : fe().serverZone;
	return {
		serverZone: r,
		serverUrl: me(r, n)
	};
}, ge = function() {
	function e() {
		this.sdk = { metrics: { histogram: {} } };
	}
	return e.prototype.recordHistogram = function(e, t) {
		this.sdk.metrics.histogram[e] = t;
	}, e;
}();
//#endregion
//#region ../../../node_modules/@amplitude/analytics-core/lib/esm/plugins/destination.js
function _e(e) {
	return e instanceof Error ? e.message : String(e);
}
function ve(e) {
	var t = "";
	try {
		"body" in e && (t = JSON.stringify(e.body, null, 2));
	} catch {}
	return t;
}
var ye = function() {
	function e() {
		this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduleId = null, this.scheduledTimeout = 0, this.flushId = null, this.queue = [];
	}
	return e.prototype.setup = function(e) {
		return i(this, void 0, void 0, function() {
			var t, n = this;
			return a(this, function(r) {
				switch (r.label) {
					case 0: return this.config = e, this.storageKey = `${S}_${this.config.apiKey.substring(0, 10)}`, [4, this.config.storageProvider?.get(this.storageKey)];
					case 1: return t = r.sent(), t && t.length > 0 && Promise.all(t.map(function(e) {
						return n.execute(e);
					})).catch(), [2, Promise.resolve(void 0)];
				}
			});
		});
	}, e.prototype.execute = function(e) {
		var t = this;
		return e.insert_id ||= b(), new Promise(function(n) {
			var r = {
				event: e,
				attempts: 0,
				callback: function(e) {
					return n(e);
				},
				timeout: 0
			};
			t.queue.push(r), t.schedule(t.config.flushIntervalMillis), t.saveEvents();
		});
	}, e.prototype.removeEventsExceedFlushMaxRetries = function(e) {
		var t = this;
		return e.filter(function(e) {
			return e.attempts += 1, e.attempts < t.config.flushMaxRetries ? !0 : (t.fulfillRequest([e], 500, m), !1);
		});
	}, e.prototype.scheduleEvents = function(e) {
		var t = this;
		e.forEach(function(e) {
			t.schedule(e.timeout === 0 ? t.config.flushIntervalMillis : e.timeout);
		});
	}, e.prototype.schedule = function(e) {
		var t = this;
		if (!this.config.offline && (this.scheduleId === null || this.scheduleId && e > this.scheduledTimeout)) {
			this.scheduleId && clearTimeout(this.scheduleId), this.scheduledTimeout = e, this.scheduleId = setTimeout(function() {
				t.queue = t.queue.map(function(e) {
					return e.timeout = 0, e;
				}), t.flush(!0);
			}, e);
			return;
		}
	}, e.prototype.resetSchedule = function() {
		this.scheduleId = null, this.scheduledTimeout = 0;
	}, e.prototype.flush = function(e) {
		return e === void 0 && (e = !1), i(this, void 0, void 0, function() {
			var t, n, r, o = this;
			return a(this, function(s) {
				switch (s.label) {
					case 0: return this.config.offline ? (this.resetSchedule(), this.config.loggerProvider.debug("Skipping flush while offline."), [2]) : this.flushId ? (this.resetSchedule(), this.config.loggerProvider.debug("Skipping flush because previous flush has not resolved."), [2]) : (this.flushId = this.scheduleId, this.resetSchedule(), t = [], n = [], this.queue.forEach(function(e) {
						return e.timeout === 0 ? t.push(e) : n.push(e);
					}), r = le(t, this.config.flushQueueSize), [4, r.reduce(function(t, n) {
						return i(o, void 0, void 0, function() {
							return a(this, function(r) {
								switch (r.label) {
									case 0: return [4, t];
									case 1: return r.sent(), [4, this.send(n, e)];
									case 2: return [2, r.sent()];
								}
							});
						});
					}, Promise.resolve())]);
					case 1: return s.sent(), this.flushId = null, this.scheduleEvents(this.queue), [2];
				}
			});
		});
	}, e.prototype.send = function(e, t) {
		return t === void 0 && (t = !0), i(this, void 0, void 0, function() {
			var n, i, o, s, c;
			return a(this, function(a) {
				switch (a.label) {
					case 0:
						if (!this.config.apiKey) return [2, this.fulfillRequest(e, 400, g)];
						n = {
							api_key: this.config.apiKey,
							events: e.map(function(e) {
								var t = e.event;
								return t.extra, r(t, ["extra"]);
							}),
							options: { min_id_length: this.config.minIdLength },
							client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
							request_metadata: this.config.requestMetadata
						}, this.config.requestMetadata = new ge(), a.label = 1;
					case 1: return a.trys.push([
						1,
						3,
						,
						4
					]), i = he(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(i, n)];
					case 2: return o = a.sent(), o === null ? (this.fulfillRequest(e, 0, p), [2]) : t ? (this.handleResponse(o, e), [3, 4]) : ("body" in o ? this.fulfillRequest(e, o.statusCode, `${o.status}: ${ve(o)}`) : this.fulfillRequest(e, o.statusCode, o.status), [2]);
					case 3: return s = a.sent(), c = _e(s), this.config.loggerProvider.error(c), this.handleResponse({
						status: v.Failed,
						statusCode: 0
					}, e), [3, 4];
					case 4: return [2];
				}
			});
		});
	}, e.prototype.handleResponse = function(e, t) {
		var n = e.status;
		switch (n) {
			case v.Success:
				this.handleSuccessResponse(e, t);
				break;
			case v.Invalid:
				this.handleInvalidResponse(e, t);
				break;
			case v.PayloadTooLarge:
				this.handlePayloadTooLargeResponse(e, t);
				break;
			case v.RateLimit:
				this.handleRateLimitResponse(e, t);
				break;
			default:
				this.config.loggerProvider.warn(`{code: 0, error: "Status '${n}' provided for ${t.length} events"}`), this.handleOtherResponse(t);
				break;
		}
	}, e.prototype.handleSuccessResponse = function(e, t) {
		this.fulfillRequest(t, e.statusCode, f);
	}, e.prototype.handleInvalidResponse = function(e, t) {
		var n = this;
		if (e.body.missingField || e.body.error.startsWith("Invalid API key")) {
			this.fulfillRequest(t, e.statusCode, e.body.error);
			return;
		}
		var r = c(c(c(c([], s(Object.values(e.body.eventsWithInvalidFields)), !1), s(Object.values(e.body.eventsWithMissingFields)), !1), s(Object.values(e.body.eventsWithInvalidIdLengths)), !1), s(e.body.silencedEvents), !1).flat(), i = new Set(r), a = t.filter(function(t, r) {
			if (i.has(r)) {
				n.fulfillRequest([t], e.statusCode, e.body.error);
				return;
			}
			return !0;
		});
		a.length > 0 && this.config.loggerProvider.warn(ve(e));
		var o = this.removeEventsExceedFlushMaxRetries(a);
		this.scheduleEvents(o);
	}, e.prototype.handlePayloadTooLargeResponse = function(e, t) {
		if (t.length === 1) {
			this.fulfillRequest(t, e.statusCode, e.body.error);
			return;
		}
		this.config.loggerProvider.warn(ve(e)), this.config.flushQueueSize /= 2;
		var n = this.removeEventsExceedFlushMaxRetries(t);
		this.scheduleEvents(n);
	}, e.prototype.handleRateLimitResponse = function(e, t) {
		var n = this, r = Object.keys(e.body.exceededDailyQuotaUsers), i = Object.keys(e.body.exceededDailyQuotaDevices), a = e.body.throttledEvents, o = new Set(r), s = new Set(i), c = new Set(a), l = t.filter(function(t, r) {
			if (t.event.user_id && o.has(t.event.user_id) || t.event.device_id && s.has(t.event.device_id)) {
				n.fulfillRequest([t], e.statusCode, e.body.error);
				return;
			}
			return c.has(r) && (t.timeout = n.throttleTimeout), !0;
		});
		l.length > 0 && this.config.loggerProvider.warn(ve(e));
		var u = this.removeEventsExceedFlushMaxRetries(l);
		this.scheduleEvents(u);
	}, e.prototype.handleOtherResponse = function(e) {
		var t = this, n = e.map(function(e) {
			return e.timeout = e.attempts * t.retryTimeout, e;
		}), r = this.removeEventsExceedFlushMaxRetries(n);
		this.scheduleEvents(r);
	}, e.prototype.fulfillRequest = function(e, t, n) {
		this.removeEvents(e), e.forEach(function(e) {
			return e.callback(y(e.event, t, n));
		});
	}, e.prototype.saveEvents = function() {
		if (this.config.storageProvider) {
			var e = this.queue.map(function(e) {
				return e.event;
			});
			this.config.storageProvider.set(this.storageKey, e);
		}
	}, e.prototype.removeEvents = function(e) {
		this.queue = this.queue.filter(function(t) {
			return !e.some(function(e) {
				return e.event.insert_id === t.event.insert_id;
			});
		}), this.saveEvents();
	}, e;
}(), be = function() {
	function e() {}
	return e.prototype.getApplicationContext = function() {
		return {
			versionName: this.versionName,
			language: xe(),
			platform: "Web",
			os: void 0,
			deviceModel: void 0
		};
	}, e;
}(), xe = function() {
	return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, Se = function() {
	function e() {
		this.queue = [];
	}
	return e.prototype.logEvent = function(e) {
		this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
	}, e.prototype.setEventReceiver = function(e) {
		this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function(t) {
			e(t);
		}), this.queue = []);
	}, e;
}(), F = function() {
	return F = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, F.apply(this, arguments);
}, Ce = function(e, t) {
	var n = [
		"string",
		"number",
		"boolean",
		"undefined"
	], r = typeof e;
	if (r !== typeof t) return !1;
	for (var i = 0, a = n; i < a.length; i++) if (a[i] === r) return e === t;
	if (e == null && t == null) return !0;
	if (e == null || t == null || e.length !== t.length) return !1;
	var o = Array.isArray(e), s = Array.isArray(t);
	if (o !== s) return !1;
	if (o && s) {
		for (var c = 0; c < e.length; c++) if (!Ce(e[c], t[c])) return !1;
	} else {
		if (!Ce(Object.keys(e).sort(), Object.keys(t).sort())) return !1;
		var l = !0;
		return Object.keys(e).forEach(function(n) {
			Ce(e[n], t[n]) || (l = !1);
		}), l;
	}
	return !0;
}, we = "$set", Te = "$unset", Ee = "$clearAll";
Object.entries || (Object.entries = function(e) {
	for (var t = Object.keys(e), n = t.length, r = Array(n); n--;) r[n] = [t[n], e[t[n]]];
	return r;
});
var De = function() {
	function e() {
		this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
	}
	return e.prototype.editIdentity = function() {
		var e = this, t = F({}, this.identity.userProperties), n = F(F({}, this.identity), { userProperties: t });
		return {
			setUserId: function(e) {
				return n.userId = e, this;
			},
			setDeviceId: function(e) {
				return n.deviceId = e, this;
			},
			setUserProperties: function(e) {
				return n.userProperties = e, this;
			},
			setOptOut: function(e) {
				return n.optOut = e, this;
			},
			updateUserProperties: function(e) {
				for (var t = n.userProperties || {}, r = 0, i = Object.entries(e); r < i.length; r++) {
					var a = i[r], o = a[0], s = a[1];
					switch (o) {
						case we:
							for (var c = 0, l = Object.entries(s); c < l.length; c++) {
								var u = l[c], d = u[0], f = u[1];
								t[d] = f;
							}
							break;
						case Te:
							for (var p = 0, m = Object.keys(s); p < m.length; p++) {
								var d = m[p];
								delete t[d];
							}
							break;
						case Ee:
							t = {};
							break;
					}
				}
				return n.userProperties = t, this;
			},
			commit: function() {
				return e.setIdentity(n), this;
			}
		};
	}, e.prototype.getIdentity = function() {
		return F({}, this.identity);
	}, e.prototype.setIdentity = function(e) {
		var t = F({}, this.identity);
		this.identity = F({}, e), Ce(t, this.identity) || this.listeners.forEach(function(t) {
			t(e);
		});
	}, e.prototype.addIdentityListener = function(e) {
		this.listeners.add(e);
	}, e.prototype.removeIdentityListener = function(e) {
		this.listeners.delete(e);
	}, e;
}(), Oe = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : self, ke = function() {
	function e() {
		this.identityStore = new De(), this.eventBridge = new Se(), this.applicationContextProvider = new be();
	}
	return e.getInstance = function(t) {
		return Oe.analyticsConnectorInstances ||= {}, Oe.analyticsConnectorInstances[t] || (Oe.analyticsConnectorInstances[t] = new e()), Oe.analyticsConnectorInstances[t];
	}, e;
}(), Ae = function(e) {
	return e === void 0 && (e = "$default_instance"), ke.getInstance(e);
}, je = function(e, t) {
	Ae(t).identityStore.editIdentity().setUserId(e).commit();
}, Me = function(e, t) {
	Ae(t).identityStore.editIdentity().setDeviceId(e).commit();
}, Ne = function() {
	function e() {
		this.name = "identity", this.type = "before", this.identityStore = Ae().identityStore;
	}
	return e.prototype.execute = function(e) {
		return i(this, void 0, void 0, function() {
			var t;
			return a(this, function(n) {
				return t = e.user_properties, t && this.identityStore.editIdentity().updateUserProperties(t).commit(), [2, e];
			});
		});
	}, e.prototype.setup = function(e) {
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				return e.instanceName && (this.identityStore = Ae(e.instanceName).identityStore), [2];
			});
		});
	}, e;
}(), I = function() {
	var e = "ampIntegrationContext";
	if (typeof globalThis < "u" && globalThis[e] !== void 0) return globalThis[e];
	if (typeof globalThis < "u") return globalThis;
	if (typeof window < "u") return window;
	if (typeof self < "u") return self;
	if (typeof global < "u") return global;
}, Pe = function(e, t) {
	return t === void 0 && (t = Date.now()), Date.now() - t > e;
}, Fe = function(e, t, n) {
	return t === void 0 && (t = ""), n === void 0 && (n = 10), [
		"AMP",
		t,
		e.substring(0, n)
	].filter(Boolean).join("_");
}, Ie = function(e) {
	return `amp_${e.substring(0, 6)}`;
}, Le = function() {
	if (typeof navigator > "u") return "";
	var e = navigator.userLanguage;
	return navigator.languages?.[0] ?? navigator.language ?? e ?? "";
}, Re = function() {
	var e = I();
	return e?.location?.search ? e.location.search.substring(1).split("&").filter(Boolean).reduce(function(e, t) {
		var n = t.split("=", 2), r = ze(n[0]), i = ze(n[1]);
		return i && (e[r] = i), e;
	}, {}) : {};
}, ze = function(e) {
	e === void 0 && (e = "");
	try {
		return decodeURIComponent(e);
	} catch {
		return "";
	}
}, Be = function(e) {
	return e === void 0 && (e = 0), ((/* @__PURE__ */ Error()).stack || "").split("\n").slice(2 + e).map(function(e) {
		return e.trim();
	});
}, L = function(e) {
	return function() {
		var t = n({}, e.config);
		return {
			logger: t.loggerProvider,
			logLevel: t.logLevel
		};
	};
}, Ve = function(e, t) {
	var n, r;
	t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
	try {
		for (var i = o(t.split(".")), a = i.next(); !a.done; a = i.next()) {
			var s = a.value;
			if (s in e) e = e[s];
			else return;
		}
	} catch (e) {
		n = { error: e };
	} finally {
		try {
			a && !a.done && (r = i.return) && r.call(i);
		} finally {
			if (n) throw n.error;
		}
	}
	return e;
}, R = function(e, t) {
	return function() {
		var n, r, i = {};
		try {
			for (var a = o(t), s = a.next(); !s.done; s = a.next()) {
				var c = s.value;
				i[c] = Ve(e, c);
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				s && !s.done && (r = a.return) && r.call(a);
			} finally {
				if (n) throw n.error;
			}
		}
		return i;
	};
}, z = function(e, t, n, r, i) {
	return i === void 0 && (i = null), function() {
		var a = [...arguments], o = n(), s = o.logger, c = o.logLevel;
		if (c && c < P.Debug || !c || !s) return e.apply(i, a);
		var l = {
			type: "invoke public method",
			name: t,
			args: a,
			stacktrace: Be(1),
			time: { start: (/* @__PURE__ */ new Date()).toISOString() },
			states: {}
		};
		r && l.states && (l.states.before = r());
		var u = e.apply(i, a);
		return u && u.promise ? u.promise.then(function() {
			r && l.states && (l.states.after = r()), l.time && (l.time.end = (/* @__PURE__ */ new Date()).toISOString()), s.debug(JSON.stringify(l, null, 2));
		}) : (r && l.states && (l.states.after = r()), l.time && (l.time.end = (/* @__PURE__ */ new Date()).toISOString()), s.debug(JSON.stringify(l, null, 2))), u;
	};
}, He = function() {
	function e() {
		this.memoryStorage = /* @__PURE__ */ new Map();
	}
	return e.prototype.isEnabled = function() {
		return i(this, void 0, void 0, function() {
			return a(this, function(e) {
				return [2, !0];
			});
		});
	}, e.prototype.get = function(e) {
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				return [2, this.memoryStorage.get(e)];
			});
		});
	}, e.prototype.getRaw = function(e) {
		return i(this, void 0, void 0, function() {
			var t;
			return a(this, function(n) {
				switch (n.label) {
					case 0: return [4, this.get(e)];
					case 1: return t = n.sent(), [2, t ? JSON.stringify(t) : void 0];
				}
			});
		});
	}, e.prototype.set = function(e, t) {
		return i(this, void 0, void 0, function() {
			return a(this, function(n) {
				return this.memoryStorage.set(e, t), [2];
			});
		});
	}, e.prototype.remove = function(e) {
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				return this.memoryStorage.delete(e), [2];
			});
		});
	}, e.prototype.reset = function() {
		return i(this, void 0, void 0, function() {
			return a(this, function(e) {
				return this.memoryStorage.clear(), [2];
			});
		});
	}, e;
}(), Ue = function() {
	function e(e) {
		this.options = n({}, e);
	}
	return e.prototype.isEnabled = function() {
		return i(this, void 0, void 0, function() {
			var t, n, r;
			return a(this, function(i) {
				switch (i.label) {
					case 0:
						/* istanbul ignore if */
						if (!I()) return [2, !1];
						e.testValue = String(Date.now()), t = new e(this.options), n = "AMP_TEST", i.label = 1;
					case 1: return i.trys.push([
						1,
						4,
						5,
						7
					]), [4, t.set(n, e.testValue)];
					case 2: return i.sent(), [4, t.get(n)];
					case 3: return r = i.sent(), [2, r === e.testValue];
					case 4:
 /* istanbul ignore next */
					return i.sent(), [2, !1];
					case 5: return [4, t.remove(n)];
					case 6: return i.sent(), [7];
					case 7: return [2];
				}
			});
		});
	}, e.prototype.get = function(e) {
		return i(this, void 0, void 0, function() {
			var t, n;
			return a(this, function(r) {
				switch (r.label) {
					case 0: return [4, this.getRaw(e)];
					case 1:
						if (t = r.sent(), !t) return [2, void 0];
						try {
							return n = We(t) ?? Ge(t), n === void 0 ? (console.error(`Amplitude Logger [Error]: Failed to decode cookie value for key: ${e}, value: ${t}`), [2, void 0]) : [2, JSON.parse(n)];
						} catch {
							return console.error(`Amplitude Logger [Error]: Failed to parse cookie value for key: ${e}, value: ${t}`), [2, void 0];
						}
						return [2];
				}
			});
		});
	}, e.prototype.getRaw = function(e) {
		return i(this, void 0, void 0, function() {
			var t, n, r;
			return a(this, function(i) {
				return t = I(), n = (t?.document)?.cookie.split("; ") ?? [], r = n.find(function(t) {
					return t.indexOf(e + "=") === 0;
				}), r ? [2, r.substring(e.length + 1)] : [2, void 0];
			});
		});
	}, e.prototype.set = function(e, t) {
		return i(this, void 0, void 0, function() {
			var n, r, i, o, s, c, l;
			return a(this, function(a) {
				try {
					n = this.options.expirationDays ?? 0, r = t === null ? -1 : n, i = void 0, r && (o = /* @__PURE__ */ new Date(), o.setTime(o.getTime() + r * 24 * 60 * 60 * 1e3), i = o), s = `${e}=${btoa(encodeURIComponent(JSON.stringify(t)))}`, i && (s += `; expires=${i.toUTCString()}`), s += "; path=/", this.options.domain && (s += `; domain=${this.options.domain}`), this.options.secure && (s += "; Secure"), this.options.sameSite && (s += `; SameSite=${this.options.sameSite}`), c = I(), c && (c.document.cookie = s);
				} catch (t) {
					l = t instanceof Error ? t.message : String(t), console.error(`Amplitude Logger [Error]: Failed to set cookie for key: ${e}. Error: ${l}`);
				}
				return [2];
			});
		});
	}, e.prototype.remove = function(e) {
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				switch (t.label) {
					case 0: return [4, this.set(e, null)];
					case 1: return t.sent(), [2];
				}
			});
		});
	}, e.prototype.reset = function() {
		return i(this, void 0, void 0, function() {
			return a(this, function(e) {
				return [2];
			});
		});
	}, e;
}(), We = function(e) {
	try {
		return decodeURIComponent(atob(e));
	} catch {
		return;
	}
}, Ge = function(e) {
	try {
		return decodeURIComponent(atob(decodeURIComponent(e)));
	} catch {
		return;
	}
}, Ke = function(e, t, n) {
	return t === void 0 && (t = ""), n === void 0 && (n = 10), [
		"AMP",
		t,
		e.substring(0, n)
	].filter(Boolean).join("_");
}, qe = function() {
	function e() {}
	return e.prototype.send = function(e, t) {
		return Promise.resolve(null);
	}, e.prototype.buildResponse = function(e) {
		if (typeof e != "object") return null;
		var t = e.code || 0, n = this.buildStatus(t);
		switch (n) {
			case v.Success: return {
				status: n,
				statusCode: t,
				body: {
					eventsIngested: e.events_ingested ?? 0,
					payloadSizeBytes: e.payload_size_bytes ?? 0,
					serverUploadTime: e.server_upload_time ?? 0
				}
			};
			case v.Invalid: return {
				status: n,
				statusCode: t,
				body: {
					error: e.error ?? "",
					missingField: e.missing_field ?? "",
					eventsWithInvalidFields: e.events_with_invalid_fields ?? {},
					eventsWithMissingFields: e.events_with_missing_fields ?? {},
					eventsWithInvalidIdLengths: e.events_with_invalid_id_lengths ?? {},
					epsThreshold: e.eps_threshold ?? 0,
					exceededDailyQuotaDevices: e.exceeded_daily_quota_devices ?? {},
					silencedDevices: e.silenced_devices ?? [],
					silencedEvents: e.silenced_events ?? [],
					throttledDevices: e.throttled_devices ?? {},
					throttledEvents: e.throttled_events ?? []
				}
			};
			case v.PayloadTooLarge: return {
				status: n,
				statusCode: t,
				body: { error: e.error ?? "" }
			};
			case v.RateLimit: return {
				status: n,
				statusCode: t,
				body: {
					error: e.error ?? "",
					epsThreshold: e.eps_threshold ?? 0,
					throttledDevices: e.throttled_devices ?? {},
					throttledUsers: e.throttled_users ?? {},
					exceededDailyQuotaDevices: e.exceeded_daily_quota_devices ?? {},
					exceededDailyQuotaUsers: e.exceeded_daily_quota_users ?? {},
					throttledEvents: e.throttled_events ?? []
				}
			};
			case v.Timeout:
			default: return {
				status: n,
				statusCode: t
			};
		}
	}, e.prototype.buildStatus = function(e) {
		return e >= 200 && e < 300 ? v.Success : e === 429 ? v.RateLimit : e === 413 ? v.PayloadTooLarge : e === 408 ? v.Timeout : e >= 400 && e < 500 ? v.Invalid : e >= 500 ? v.Failed : v.Unknown;
	}, e;
}(), Je = function(e) {
	t(n, e);
	function n() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return n.prototype.send = function(e, t) {
		return i(this, void 0, void 0, function() {
			var n, r, i;
			return a(this, function(a) {
				switch (a.label) {
					case 0:
						/* istanbul ignore if */
						if (typeof fetch > "u") throw Error("FetchTransport is not supported");
						return n = {
							headers: {
								"Content-Type": "application/json",
								Accept: "*/*"
							},
							body: JSON.stringify(t),
							method: "POST"
						}, [4, fetch(e, n)];
					case 1: return r = a.sent(), [4, r.text()];
					case 2:
						i = a.sent();
						try {
							return [2, this.buildResponse(JSON.parse(i))];
						} catch {
							return [2, this.buildResponse({ code: r.status })];
						}
						return [2];
				}
			});
		});
	}, n;
}(qe), Ye = [
	"a",
	"button",
	"input",
	"select",
	"textarea",
	"label",
	"video",
	"audio",
	"[contenteditable=\"true\" i]",
	"[data-amp-default-track]",
	".amp-default-track"
], Xe = "data-amp-track-", Ze = [
	"div",
	"span",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6"
], Qe = function(e, t) {
	return typeof e == "boolean" ? e : e?.[t] !== !1;
}, $e = function(e) {
	return Qe(e, "attribution");
}, et = function(e) {
	return Qe(e, "fileDownloads");
}, tt = function(e) {
	return Qe(e, "formInteractions");
}, nt = function(e) {
	return Qe(e, "pageViews");
}, rt = function(e) {
	return Qe(e, "sessions");
}, it = function(e) {
	return typeof e == "boolean" ? e : typeof e == "object" && (e.elementInteractions === !0 || typeof e.elementInteractions == "object");
}, at = function(e) {
	if (it(e.autocapture) && typeof e.autocapture == "object" && typeof e.autocapture.elementInteractions == "object") return e.autocapture.elementInteractions;
}, ot = function(e) {
	var t = function() {
		return !1;
	}, n = void 0, r, i = e.pageCounter;
	return nt(e.defaultTracking) && (t = void 0, r = void 0, e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.pageViews && typeof e.defaultTracking.pageViews == "object" && ("trackOn" in e.defaultTracking.pageViews && (t = e.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in e.defaultTracking.pageViews && (n = e.defaultTracking.pageViews.trackHistoryChanges), "eventType" in e.defaultTracking.pageViews && e.defaultTracking.pageViews.eventType && (r = e.defaultTracking.pageViews.eventType))), {
		trackOn: t,
		trackHistoryChanges: n,
		eventType: r,
		pageCounter: i
	};
}, st = function(e) {
	return $e(e.defaultTracking) && e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.attribution && typeof e.defaultTracking.attribution == "object" ? n({}, e.defaultTracking.attribution) : {};
}, ct = function(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n], i = r.name, a = r.args, o = r.resolve, s = e && e[i];
		if (typeof s == "function") {
			var c = s.apply(e, a);
			typeof o == "function" && o(c?.promise);
		}
	}
	return e;
}, lt = function(e) {
	var t = e;
	return t && t._q !== void 0;
}, ut = "2.12.2", dt = "amplitude-ts", ft = "Web", pt = "$remote", mt = function() {
	function e() {
		/* istanbul ignore else */
		this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = `${dt}/${ut}`, typeof navigator < "u" && (this.userAgent = navigator.userAgent);
	}
	return e.prototype.setup = function(e) {
		return this.config = e, Promise.resolve(void 0);
	}, e.prototype.execute = function(e) {
		return i(this, void 0, void 0, function() {
			var t, r, i, o;
			return a(this, function(a) {
				return t = (/* @__PURE__ */ new Date()).getTime(), r = this.config.lastEventId ?? -1, i = e.event_id ?? r + 1, this.config.lastEventId = i, e.time || (this.config.lastEventTime = t), o = n(n(n(n(n(n(n(n({
					user_id: this.config.userId,
					device_id: this.config.deviceId,
					session_id: this.config.sessionId,
					time: t
				}, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: ft }), this.config.trackingOptions.language && { language: Le() }), this.config.trackingOptions.ipAddress && { ip: pt }), {
					insert_id: b(),
					partner_id: this.config.partnerId,
					plan: this.config.plan
				}), this.config.ingestionMetadata && { ingestion_metadata: {
					source_name: this.config.ingestionMetadata.sourceName,
					source_version: this.config.ingestionMetadata.sourceVersion
				} }), e), {
					event_id: i,
					library: this.library,
					user_agent: this.userAgent
				}), [2, o];
			});
		});
	}, e;
}(), ht = function() {
	function e(e) {
		this.storage = e;
	}
	return e.prototype.isEnabled = function() {
		return i(this, void 0, void 0, function() {
			var t, n, r, i;
			return a(this, function(a) {
				switch (a.label) {
					case 0:
						/* istanbul ignore if */
						if (!this.storage) return [2, !1];
						t = String(Date.now()), n = new e(this.storage), r = "AMP_TEST", a.label = 1;
					case 1: return a.trys.push([
						1,
						4,
						5,
						7
					]), [4, n.set(r, t)];
					case 2: return a.sent(), [4, n.get(r)];
					case 3: return i = a.sent(), [2, i === t];
					case 4:
 /* istanbul ignore next */
					return a.sent(), [2, !1];
					case 5: return [4, n.remove(r)];
					case 6: return a.sent(), [7];
					case 7: return [2];
				}
			});
		});
	}, e.prototype.get = function(e) {
		return i(this, void 0, void 0, function() {
			var t;
			return a(this, function(n) {
				switch (n.label) {
					case 0: return n.trys.push([
						0,
						2,
						,
						3
					]), [4, this.getRaw(e)];
					case 1: return t = n.sent(), t ? [2, JSON.parse(t)] : [2, void 0];
					case 2: return n.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
					case 3: return [2];
				}
			});
		});
	}, e.prototype.getRaw = function(e) {
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				return [2, this.storage?.getItem(e) || void 0];
			});
		});
	}, e.prototype.set = function(e, t) {
		var n;
		return i(this, void 0, void 0, function() {
			return a(this, function(r) {
				try {
					(n = this.storage) == null || n.setItem(e, JSON.stringify(t));
				} catch {}
				return [2];
			});
		});
	}, e.prototype.remove = function(e) {
		var t;
		return i(this, void 0, void 0, function() {
			return a(this, function(n) {
				try {
					(t = this.storage) == null || t.removeItem(e);
				} catch {}
				return [2];
			});
		});
	}, e.prototype.reset = function() {
		var e;
		return i(this, void 0, void 0, function() {
			return a(this, function(t) {
				try {
					(e = this.storage) == null || e.clear();
				} catch {}
				return [2];
			});
		});
	}, e;
}(), gt = 1e3, _t = function(e) {
	t(n, e);
	function n(t) {
		var n = this;
		return n = e.call(this, I()?.localStorage) || this, n.loggerProvider = t?.loggerProvider, n;
	}
	return n.prototype.set = function(t, n) {
		var r;
		return i(this, void 0, void 0, function() {
			var i;
			return a(this, function(a) {
				switch (a.label) {
					case 0: return Array.isArray(n) && n.length > gt ? (i = n.length - gt, [4, e.prototype.set.call(this, t, n.slice(0, gt))]) : [3, 2];
					case 1: return a.sent(), (r = this.loggerProvider) == null || r.error(`Failed to save ${i} events because the queue length exceeded ${gt}.`), [3, 4];
					case 2: return [4, e.prototype.set.call(this, t, n)];
					case 3: a.sent(), a.label = 4;
					case 4: return [2];
				}
			});
		});
	}, n;
}(ht), vt = function(e) {
	t(n, e);
	function n() {
		return e.call(this, I()?.sessionStorage) || this;
	}
	return n;
}(ht), yt = function(e) {
	t(n, e);
	function n() {
		var t = e !== null && e.apply(this, arguments) || this;
		return t.state = { done: 4 }, t;
	}
	return n.prototype.send = function(e, t) {
		return i(this, void 0, void 0, function() {
			var n = this;
			return a(this, function(r) {
				return [2, new Promise(function(r, i) {
					/* istanbul ignore if */
					typeof XMLHttpRequest > "u" && i(/* @__PURE__ */ Error("XHRTransport is not supported."));
					var a = new XMLHttpRequest();
					a.open("POST", e, !0), a.onreadystatechange = function() {
						if (a.readyState === n.state.done) {
							var e = a.responseText;
							try {
								r(n.buildResponse(JSON.parse(e)));
							} catch {
								r(n.buildResponse({ code: a.status }));
							}
						}
					}, a.setRequestHeader("Content-Type", "application/json"), a.setRequestHeader("Accept", "*/*"), a.send(JSON.stringify(t));
				})];
			});
		});
	}, n;
}(qe), bt = function(e) {
	t(n, e);
	function n() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return n.prototype.send = function(e, t) {
		return i(this, void 0, void 0, function() {
			var n = this;
			return a(this, function(r) {
				return [2, new Promise(function(r, i) {
					var a = I();
					/* istanbul ignore if */
					if (!a?.navigator.sendBeacon) throw Error("SendBeaconTransport is not supported");
					try {
						var o = JSON.stringify(t);
						return a.navigator.sendBeacon(e, JSON.stringify(t)) ? r(n.buildResponse({
							code: 200,
							events_ingested: t.events.length,
							payload_size_bytes: o.length,
							server_upload_time: Date.now()
						})) : r(n.buildResponse({ code: 500 }));
					} catch (e) {
						i(e);
					}
				})];
			});
		});
	}, n;
}(qe), xt = function(e, t, n) {
	return n === void 0 && (n = !0), i(void 0, void 0, void 0, function() {
		var r, i, o, c, l, u, d, f, p;
		return a(this, function(a) {
			switch (a.label) {
				case 0: return r = Ie(e), [4, t.getRaw(r)];
				case 1: return i = a.sent(), i ? n ? [4, t.remove(r)] : [3, 3] : [2, { optOut: !1 }];
				case 2: a.sent(), a.label = 3;
				case 3: return o = s(i.split("."), 6), c = o[0], l = o[1], u = o[2], d = o[3], f = o[4], p = o[5], [2, {
					deviceId: c,
					userId: Ct(l),
					sessionId: St(d),
					lastEventId: St(p),
					lastEventTime: St(f),
					optOut: !!u
				}];
			}
		});
	});
}, St = function(e) {
	var t = parseInt(e, 32);
	if (!isNaN(t)) return t;
}, Ct = function(e) {
	if (!(!atob || !escape || !e)) try {
		return decodeURIComponent(escape(atob(e)));
	} catch {
		return;
	}
}, B = "[Amplitude]";
`${B}`;
var wt = `${B} Form Started`, Tt = `${B} Form Submitted`, Et = `${B} File Downloaded`, Dt = "session_start", Ot = "session_end", kt = `${B} File Extension`, At = `${B} File Name`, jt = `${B} Link ID`, Mt = `${B} Link Text`, Nt = `${B} Link URL`, Pt = `${B} Form ID`, Ft = `${B} Form Name`, It = `${B} Form Destination`, Lt = "cookie", Rt = function(e) {
	t(n, e);
	function n(t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, ee, te, E, D, O, k, ne, A, re) {
		r === void 0 && (r = new He()), i === void 0 && (i = {
			domain: "",
			expiration: 365,
			sameSite: "Lax",
			secure: !1,
			upgrade: !0
		}), c === void 0 && (c = 1e3), l === void 0 && (l = 5), u === void 0 && (u = 30), d === void 0 && (d = Lt), g === void 0 && (g = new de()), _ === void 0 && (_ = P.Warn), y === void 0 && (y = !1), b === void 0 && (b = !1), C === void 0 && (C = ""), w === void 0 && (w = "US"), ee === void 0 && (ee = 1800 * 1e3), te === void 0 && (te = new _t({ loggerProvider: g })), E === void 0 && (E = {
			ipAddress: !0,
			language: !0,
			platform: !0
		}), D === void 0 && (D = "fetch"), O === void 0 && (O = !1), k === void 0 && (k = !1);
		var j = e.call(this, {
			apiKey: t,
			storageProvider: te,
			transportProvider: Vt(D)
		}) || this;
		return j.apiKey = t, j.appVersion = n, j.cookieOptions = i, j.defaultTracking = a, j.autocapture = o, j.flushIntervalMillis = c, j.flushMaxRetries = l, j.flushQueueSize = u, j.identityStorage = d, j.ingestionMetadata = f, j.instanceName = p, j.loggerProvider = g, j.logLevel = _, j.minIdLength = v, j.offline = y, j.partnerId = x, j.plan = S, j.serverUrl = C, j.serverZone = w, j.sessionTimeout = ee, j.storageProvider = te, j.trackingOptions = E, j.transport = D, j.useBatch = O, j.fetchRemoteConfig = k, j.version = ut, j._optOut = !1, j._cookieStorage = r, j.deviceId = s, j.lastEventId = m, j.lastEventTime = h, j.optOut = b, j.sessionId = T, j.pageCounter = A, j.userId = ne, j.debugLogsEnabled = re, j.loggerProvider.enable(re ? P.Debug : j.logLevel), j;
	}
	return Object.defineProperty(n.prototype, "cookieStorage", {
		get: function() {
			return this._cookieStorage;
		},
		set: function(e) {
			this._cookieStorage !== e && (this._cookieStorage = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "deviceId", {
		get: function() {
			return this._deviceId;
		},
		set: function(e) {
			this._deviceId !== e && (this._deviceId = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "userId", {
		get: function() {
			return this._userId;
		},
		set: function(e) {
			this._userId !== e && (this._userId = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "sessionId", {
		get: function() {
			return this._sessionId;
		},
		set: function(e) {
			this._sessionId !== e && (this._sessionId = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "optOut", {
		get: function() {
			return this._optOut;
		},
		set: function(e) {
			this._optOut !== e && (this._optOut = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "lastEventTime", {
		get: function() {
			return this._lastEventTime;
		},
		set: function(e) {
			this._lastEventTime !== e && (this._lastEventTime = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "lastEventId", {
		get: function() {
			return this._lastEventId;
		},
		set: function(e) {
			this._lastEventId !== e && (this._lastEventId = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "pageCounter", {
		get: function() {
			return this._pageCounter;
		},
		set: function(e) {
			this._pageCounter !== e && (this._pageCounter = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(n.prototype, "debugLogsEnabled", {
		set: function(e) {
			this._debugLogsEnabled !== e && (this._debugLogsEnabled = e, this.updateStorage());
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype.updateStorage = function() {
		var e = {
			deviceId: this._deviceId,
			userId: this._userId,
			sessionId: this._sessionId,
			optOut: this._optOut,
			lastEventTime: this._lastEventTime,
			lastEventId: this._lastEventId,
			pageCounter: this._pageCounter,
			debugLogsEnabled: this._debugLogsEnabled
		};
		this.cookieStorage.set(Fe(this.apiKey), e);
	}, n;
}(pe), zt = function(e, t, r) {
	return t === void 0 && (t = {}), i(void 0, void 0, void 0, function() {
		var i, o, s, c, l, u, d, f, p, m, h, g, _, v, y, x, S, C, w, T;
		return a(this, function(a) {
			switch (a.label) {
				case 0: return i = t.identityStorage || "cookie", w = {}, i === "cookie" ? [3, 1] : (s = "", [3, 5]);
				case 1: return (T = t.cookieOptions?.domain) == null ? [3, 2] : (c = T, [3, 4]);
				case 2: return [4, Ht()];
				case 3: c = a.sent(), a.label = 4;
				case 4: s = c, a.label = 5;
				case 5: return o = n.apply(void 0, [(w.domain = s, w.expiration = 365, w.sameSite = "Lax", w.secure = !1, w.upgrade = !0, w), t.cookieOptions]), l = Bt(t.identityStorage, o), [4, xt(e, l, t.cookieOptions?.upgrade ?? !0)];
				case 6: return u = a.sent(), [4, l.get(Fe(e))];
				case 7: return d = a.sent(), f = Re(), p = t.deviceId ?? f.ampDeviceId ?? f.deviceId ?? d?.deviceId ?? u.deviceId ?? b(), m = d?.lastEventId ?? u.lastEventId, h = d?.lastEventTime ?? u.lastEventTime, g = t.optOut ?? d?.optOut ?? u.optOut, _ = d?.sessionId ?? u.sessionId, v = t.userId ?? d?.userId ?? u.userId, r.previousSessionDeviceId = d?.deviceId ?? u.deviceId, r.previousSessionUserId = d?.userId ?? u.userId, y = {
					ipAddress: t.trackingOptions?.ipAddress ?? !0,
					language: t.trackingOptions?.language ?? !0,
					platform: t.trackingOptions?.platform ?? !0
				}, x = d?.pageCounter, S = d?.debugLogsEnabled, t.autocapture !== void 0 && (t.defaultTracking = t.autocapture), C = new Rt(e, t.appVersion, l, o, t.defaultTracking, t.autocapture, p, t.flushIntervalMillis, t.flushMaxRetries, t.flushQueueSize, i, t.ingestionMetadata, t.instanceName, m, h, t.loggerProvider, t.logLevel, t.minIdLength, t.offline, g, t.partnerId, t.plan, t.serverUrl, t.serverZone, _, t.sessionTimeout, t.storageProvider, y, t.transport, t.useBatch, t.fetchRemoteConfig, v, x, S), [4, C.storageProvider.isEnabled()];
				case 8: return a.sent() || (C.loggerProvider.warn(`Storage provider ${C.storageProvider.constructor.name} is not enabled. Falling back to MemoryStorage.`), C.storageProvider = new He()), [2, C];
			}
		});
	});
}, Bt = function(e, t) {
	switch (e === void 0 && (e = Lt), t === void 0 && (t = {}), e) {
		case "localStorage": return new _t();
		case "sessionStorage": return new vt();
		case "none": return new He();
		default: return new Ue(n(n({}, t), { expirationDays: t.expiration }));
	}
}, Vt = function(e) {
	return e === "xhr" ? new yt() : e === "beacon" ? new bt() : new Je();
}, Ht = function(e) {
	return i(void 0, void 0, void 0, function() {
		var t, n, r, i, o, o, s, c, l, u;
		return a(this, function(a) {
			switch (a.label) {
				case 0: return [4, new Ue().isEnabled()];
				case 1:
					if (!a.sent() || !e && (typeof location > "u" || !location.hostname)) return [2, ""];
					for (t = e ?? location.hostname, n = t.split("."), r = [], i = "AMP_TLDTEST", o = n.length - 2; o >= 0; --o) r.push(n.slice(o).join("."));
					o = 0, a.label = 2;
				case 2: return o < r.length ? (s = r[o], c = { domain: "." + s }, l = new Ue(c), [4, l.set(i, 1)]) : [3, 7];
				case 3: return a.sent(), [4, l.get(i)];
				case 4: return u = a.sent(), u ? [4, l.remove(i)] : [3, 6];
				case 5: return a.sent(), [2, "." + s];
				case 6: return o++, [3, 2];
				case 7: return [2, ""];
			}
		});
	});
}, Ut = function() {
	var e = "ampIntegrationContext";
	if (typeof globalThis < "u" && globalThis[e] !== void 0) return globalThis[e];
	if (typeof globalThis < "u") return globalThis;
	if (typeof window < "u") return window;
	if (typeof self < "u") return self;
	if (typeof global < "u") return global;
}, Wt = function() {
	var e = Ut();
	return e?.location?.search ? e.location.search.substring(1).split("&").filter(Boolean).reduce(function(e, t) {
		var n = t.split("=", 2), r = Gt(n[0]), i = Gt(n[1]);
		return i && (e[r] = i), e;
	}, {}) : {};
}, Gt = function(e) {
	e === void 0 && (e = "");
	try {
		return decodeURIComponent(e);
	} catch {
		return "";
	}
}, Kt = "utm_campaign", qt = "utm_content", Jt = "utm_id", Yt = "utm_medium", Xt = "utm_source", Zt = "utm_term", Qt = "dclid", $t = "fbclid", en = "gbraid", tn = "gclid", nn = "ko_click_id", rn = "li_fat_id", an = "msclkid", on = "rtd_cid", sn = "ttclid", cn = "twclid", ln = "wbraid", un = {
	utm_campaign: void 0,
	utm_content: void 0,
	utm_id: void 0,
	utm_medium: void 0,
	utm_source: void 0,
	utm_term: void 0,
	referrer: void 0,
	referring_domain: void 0,
	dclid: void 0,
	gbraid: void 0,
	gclid: void 0,
	fbclid: void 0,
	ko_click_id: void 0,
	li_fat_id: void 0,
	msclkid: void 0,
	rtd_cid: void 0,
	ttclid: void 0,
	twclid: void 0,
	wbraid: void 0
}, dn = function() {
	function e() {}
	return e.prototype.parse = function() {
		return i(this, void 0, void 0, function() {
			return a(this, function(e) {
				return [2, n(n(n(n({}, un), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
			});
		});
	}, e.prototype.getUtmParam = function() {
		var e = Wt();
		return {
			utm_campaign: e[Kt],
			utm_content: e[qt],
			utm_id: e[Jt],
			utm_medium: e[Yt],
			utm_source: e[Xt],
			utm_term: e[Zt]
		};
	}, e.prototype.getReferrer = function() {
		var e = {
			referrer: void 0,
			referring_domain: void 0
		};
		try {
			e.referrer = document.referrer || void 0, e.referring_domain = e.referrer?.split("/")[2] ?? void 0;
		} catch {}
		return e;
	}, e.prototype.getClickIds = function() {
		var e, t = Wt();
		return e = {}, e[Qt] = t[Qt], e[$t] = t[$t], e[en] = t[en], e[tn] = t[tn], e[nn] = t[nn], e[rn] = t[rn], e[an] = t[an], e[on] = t[on], e[sn] = t[sn], e[cn] = t[cn], e[ln] = t[ln], e;
	}, e;
}(), fn;
(function(e) {
	e.SET = "$set", e.SET_ONCE = "$setOnce", e.ADD = "$add", e.APPEND = "$append", e.PREPEND = "$prepend", e.REMOVE = "$remove", e.PREINSERT = "$preInsert", e.POSTINSERT = "$postInsert", e.UNSET = "$unset", e.CLEAR_ALL = "$clearAll";
})(fn ||= {});
var pn;
(function(e) {
	e.REVENUE_PRODUCT_ID = "$productId", e.REVENUE_QUANTITY = "$quantity", e.REVENUE_PRICE = "$price", e.REVENUE_TYPE = "$revenueType", e.REVENUE_CURRENCY = "$currency", e.REVENUE = "$revenue";
})(pn ||= {});
var mn;
(function(e) {
	e.IDENTIFY = "$identify", e.GROUP_IDENTIFY = "$groupidentify", e.REVENUE = "revenue_amount";
})(mn ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-types/lib/esm/server-zone.js
var hn;
(function(e) {
	e.US = "US", e.EU = "EU";
})(hn ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/analytics-types/lib/esm/status.js
var gn;
(function(e) {
	e.Unknown = "unknown", e.Skipped = "skipped", e.Success = "success", e.RateLimit = "rate_limit", e.PayloadTooLarge = "payload_too_large", e.Invalid = "invalid", e.Failed = "failed", e.Timeout = "Timeout", e.SystemError = "SystemError";
})(gn ||= {});
//#endregion
//#region ../../../node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/utils.js
var _n = function(e) {
	var t = {};
	for (var n in e) {
		var r = e[n];
		r && (t[n] = r);
	}
	return t;
}, vn = "[Amplitude] Page Viewed", yn = function(e) {
	e === void 0 && (e = {});
	var t, r = Ut(), o = void 0, c, l, u = e.trackOn, d = e.trackHistoryChanges, f = e.eventType, p = f === void 0 ? vn : f, m = function(e) {
		var t = e;
		try {
			t = decodeURI(e);
		} catch (e) {
			/* istanbul ignore next */
			o?.error("Malformed URI sequence: ", e);
		}
		return t;
	}, h = function() {
		return i(void 0, void 0, void 0, function() {
			var e, t, r;
			return a(this, function(i) {
				switch (i.label) {
					case 0: return e = m(typeof location < "u" && location.href || ""), r = { event_type: p }, t = [{}], [4, bn()];
					case 1: return [2, (r.event_properties = n.apply(void 0, [n.apply(void 0, t.concat([i.sent()])), {
						"[Amplitude] Page Domain": typeof location < "u" && location.hostname || "",
						"[Amplitude] Page Location": e,
						"[Amplitude] Page Path": typeof location < "u" && m(location.pathname) || "",
						"[Amplitude] Page Title": typeof document < "u" && document.title || "",
						"[Amplitude] Page URL": e.split("?")[0]
					}]), r)];
				}
			});
		});
	}, g = function() {
		return u === void 0 || typeof u == "function" && u();
	}, _ = typeof location < "u" ? location.href : null, v = function() {
		return i(void 0, void 0, void 0, function() {
			var e, n, r, i;
			return a(this, function(a) {
				switch (a.label) {
					case 0: return e = location.href, n = Sn(d, e, _ || "") && g(), _ = e, n ? (o?.log("Tracking page view event"), t == null ? [3, 3] : [3, 1]) : [3, 4];
					case 1: return i = (r = t).track, [4, h()];
					case 2: i.apply(r, [a.sent()]), a.label = 3;
					case 3: a.label = 4;
					case 4: return [2];
				}
			});
		});
	}, y = function() {
		v();
	};
	return {
		name: "@amplitude/plugin-page-view-tracking-browser",
		type: "enrichment",
		setup: function(e, n) {
			return i(void 0, void 0, void 0, function() {
				var i, u;
				return a(this, function(a) {
					switch (a.label) {
						case 0: return t = n, l = e, o = e.loggerProvider, o.log("Installing @amplitude/plugin-page-view-tracking-browser"), r && (r.addEventListener("popstate", y), c = r.history.pushState, r.history.pushState = new Proxy(r.history.pushState, { apply: function(e, t, n) {
							var r = s(n, 3), i = r[0], a = r[1], o = r[2];
							e.apply(t, [
								i,
								a,
								o
							]), v();
						} })), g() ? (o.log("Tracking page view event"), u = (i = t).track, [4, h()]) : [3, 2];
						case 1: u.apply(i, [a.sent()]), a.label = 2;
						case 2: return [2];
					}
				});
			});
		},
		execute: function(e) {
			return i(void 0, void 0, void 0, function() {
				var t;
				return a(this, function(r) {
					switch (r.label) {
						case 0: return u === "attribution" && xn(e) ? (o?.log("Enriching campaign event to page view event with campaign parameters"), [4, h()]) : [3, 2];
						case 1: t = r.sent(), e.event_type = t.event_type, e.event_properties = n(n({}, e.event_properties), t.event_properties), r.label = 2;
						case 2: return l && e.event_type === p && (l.pageCounter = l.pageCounter ? l.pageCounter + 1 : 1, e.event_properties = n(n({}, e.event_properties), { "[Amplitude] Page Counter": l.pageCounter })), [2, e];
					}
				});
			});
		},
		teardown: function() {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(e) {
					return r && (r.removeEventListener("popstate", y), c && (r.history.pushState = c)), [2];
				});
			});
		}
	};
}, bn = function() {
	return i(void 0, void 0, void 0, function() {
		var e;
		return a(this, function(t) {
			switch (t.label) {
				case 0: return e = _n, [4, new dn().parse()];
				case 1: return [2, e.apply(void 0, [t.sent()])];
			}
		});
	});
}, xn = function(e) {
	if (e.event_type === "$identify" && e.user_properties) {
		var t = e.user_properties, n = t[fn.SET] || {}, r = t[fn.UNSET] || {}, i = c(c([], s(Object.keys(n)), !1), s(Object.keys(r)), !1);
		return Object.keys(un).every(function(e) {
			return i.includes(e);
		});
	}
	return !1;
}, Sn = function(e, t, n) {
	switch (e) {
		case "pathOnly":
			if (n == "") return !0;
			var r = new URL(t), i = new URL(n);
			return r.origin + r.pathname !== i.origin + i.pathname;
		default: return t !== n;
	}
}, Cn = function() {
	var e, t = [], n = function(e, n, r) {
		e.addEventListener(n, r), t.push({
			element: e,
			type: n,
			handler: r
		});
	}, r = function() {
		t.forEach(function(e) {
			var t = e.element, n = e.type, r = e.handler;
			/* istanbul ignore next */
			t?.removeEventListener(n, r);
		}), t = [];
	};
	return {
		name: "@amplitude/plugin-form-interaction-tracking-browser",
		type: "enrichment",
		setup: function(t, r) {
			return i(void 0, void 0, void 0, function() {
				var i, o;
				return a(this, function(a) {
					return i = function() {
						/* istanbul ignore if */
						if (!r) {
							t.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
							return;
						}
						if (!(typeof document > "u")) {
							var i = function(e) {
								var t = !1;
								n(e, "change", function() {
									var n, i = wn(e);
									t || r.track(wt, (n = {}, n[Pt] = V(e.id), n[Ft] = V(e.name), n[It] = i, n)), t = !0;
								}), n(e, "submit", function() {
									var n, i, a = wn(e);
									t || r.track(wt, (n = {}, n[Pt] = V(e.id), n[Ft] = V(e.name), n[It] = a, n)), r.track(Tt, (i = {}, i[Pt] = V(e.id), i[Ft] = V(e.name), i[It] = a, i)), t = !1;
								});
							};
							/* istanbul ignore else */
							Array.from(document.getElementsByTagName("form")).forEach(i), typeof MutationObserver < "u" && (e = new MutationObserver(function(e) {
								e.forEach(function(e) {
									e.addedNodes.forEach(function(e) {
										e.nodeName === "FORM" && i(e), "querySelectorAll" in e && typeof e.querySelectorAll == "function" && Array.from(e.querySelectorAll("form")).map(i);
									});
								});
							}), e.observe(document.body, {
								subtree: !0,
								childList: !0
							}));
						}
					}, document.readyState === "complete" ? i() : (o = I(), o ? o.addEventListener("load", i) : t.loggerProvider.debug("Form interaction tracking is not installed because global is undefined.")), [2];
				});
			});
		},
		execute: function(e) {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(t) {
					return [2, e];
				});
			});
		},
		teardown: function() {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(t) {
					return e?.disconnect(), r(), [2];
				});
			});
		}
	};
}, V = function(e) {
	if (typeof e == "string") return e;
}, wn = function(e) {
	var t = e.getAttribute("action");
	try {
		t = new URL(encodeURI(t ?? ""), window.location.href).href;
	} catch {}
	return t;
}, Tn = function() {
	var e, t = [], n = function(e, n, r) {
		e.addEventListener(n, r), t.push({
			element: e,
			type: n,
			handler: r
		});
	}, r = function() {
		t.forEach(function(e) {
			var t = e.element, n = e.type, r = e.handler;
			/* istanbul ignore next */
			t?.removeEventListener(n, r);
		}), t = [];
	};
	return {
		name: "@amplitude/plugin-file-download-tracking-browser",
		type: "enrichment",
		setup: function(t, r) {
			return i(void 0, void 0, void 0, function() {
				var i, o;
				return a(this, function(a) {
					return i = function() {
						/* istanbul ignore if */
						if (!r) {
							t.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
							return;
						}
						if (!(typeof document > "u")) {
							var i = function(e) {
								var t;
								try {
									t = new URL(e.href, window.location.href);
								} catch {
									/* istanbul ignore next */
									return;
								}
								var i = a.exec(t.href)?.[1];
								i && n(e, "click", function() {
									var n;
									i && r.track(Et, (n = {}, n[kt] = i, n[At] = t.pathname, n[jt] = e.id, n[Mt] = e.text, n[Nt] = e.href, n));
								});
							}, a = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
							/* istanbul ignore else */
							Array.from(document.getElementsByTagName("a")).forEach(i), typeof MutationObserver < "u" && (e = new MutationObserver(function(e) {
								e.forEach(function(e) {
									e.addedNodes.forEach(function(e) {
										e.nodeName === "A" && i(e), "querySelectorAll" in e && typeof e.querySelectorAll == "function" && Array.from(e.querySelectorAll("a")).map(i);
									});
								});
							}), e.observe(document.body, {
								subtree: !0,
								childList: !0
							}));
						}
					}, document.readyState === "complete" ? i() : (o = I(), o ? o.addEventListener("load", i) : t.loggerProvider.debug("File download tracking is not installed because global is undefined.")), [2];
				});
			});
		},
		execute: function(e) {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(t) {
					return [2, e];
				});
			});
		},
		teardown: function() {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(t) {
					return e?.disconnect(), r(), [2];
				});
			});
		}
	};
}, En = !1, Dn = function(e) {
	En || e.defaultTracking !== void 0 || (e.loggerProvider.warn("`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details."), En = !0);
}, On = function() {
	var e = "@amplitude/plugin-network-checker-browser", t = "before", n = I(), r = [], o = function(e, t) {
		n && (n.addEventListener(e, t), r.push({
			type: e,
			handler: t
		}));
	}, s = function() {
		r.forEach(function(e) {
			var t = e.type, r = e.handler;
			n && n.removeEventListener(t, r);
		}), r = [];
	};
	return {
		name: e,
		type: t,
		setup: function(e, t) {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(n) {
					return typeof navigator > "u" ? (e.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available."), e.offline = !1, [2]) : (e.offline = !navigator.onLine, o("online", function() {
						e.loggerProvider.debug("Network connectivity changed to online."), e.offline = !1, setTimeout(function() {
							t.flush();
						}, e.flushIntervalMillis);
					}), o("offline", function() {
						e.loggerProvider.debug("Network connectivity changed to offline."), e.offline = !0;
					}), [2]);
				});
			});
		},
		teardown: function() {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(e) {
					return s(), [2];
				});
			});
		}
	};
}, kn = "Network error occurred, remote config fetch failed", An = "Remote config successfully fetched", jn = "Remote config fetch rejected due to exceeded retry count", Mn = "Remote config fetch rejected due to timeout after 5 seconds", Nn = "Unexpected error occurred", Pn = "https://sr-client-cfg.amplitude.com/config", Fn = "https://sr-client-cfg.stag2.amplitude.com/config", In = "https://sr-client-cfg.eu.amplitude.com/config", Ln = function() {
	function e(e) {
		var t = e.localConfig, r = e.configKeys, s = this;
		this.retryTimeout = 1e3, this.attempts = 0, this.sessionTargetingMatch = !1, this.metrics = {}, this.getRemoteConfig = function(e, t, n) {
			return i(s, void 0, void 0, function() {
				var r, i, o;
				return a(this, function(a) {
					switch (a.label) {
						case 0: return r = Date.now(), [4, this.fetchWithTimeout(n)];
						case 1: return i = a.sent(), i && (o = i.configs && i.configs[e], o) ? (this.metrics.fetchTimeAPISuccess = Date.now() - r, [2, o[t]]) : (this.metrics.fetchTimeAPIFail = Date.now() - r, [2, void 0]);
					}
				});
			});
		}, this.fetchWithTimeout = function(e) {
			return i(s, void 0, void 0, function() {
				var t, n, r;
				return a(this, function(i) {
					switch (i.label) {
						case 0: return t = new AbortController(), n = setTimeout(function() {
							return t.abort();
						}, 5e3), [4, this.fetchRemoteConfig(t.signal, e)];
						case 1: return r = i.sent(), clearTimeout(n), [2, r];
					}
				});
			});
		}, this.fetchRemoteConfig = function(e, t) {
			return i(s, void 0, void 0, function() {
				var r, i, s, c, l, u, d, f, p, m, h, g;
				return a(this, function(a) {
					switch (a.label) {
						case 0:
							if (t === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) return [2, this.completeRequest({ err: jn })];
							if (e.aborted) return [2, this.completeRequest({ err: Mn })];
							t !== this.lastFetchedSessionId && (this.lastFetchedSessionId = t, this.attempts = 0), a.label = 1;
						case 1:
							a.trys.push([
								1,
								3,
								,
								4
							]), r = new URLSearchParams({ api_key: this.localConfig.apiKey });
							try {
								for (i = o(this.configKeys), s = i.next(); !s.done; s = i.next()) c = s.value, r.append("config_keys", c);
							} catch (e) {
								h = { error: e };
							} finally {
								try {
									s && !s.done && (g = i.return) && g.call(i);
								} finally {
									if (h) throw h.error;
								}
							}
							return t && r.set("session_id", String(t)), l = {
								headers: { Accept: "*/*" },
								method: "GET"
							}, u = `${this.getServerUrl()}?${r.toString()}`, this.attempts += 1, [4, fetch(u, n(n({}, l), { signal: e }))];
						case 2:
							if (d = a.sent(), d === null) return [2, this.completeRequest({ err: Nn })];
							switch (f = new qe().buildStatus(d.status), f) {
								case gn.Success: return this.attempts = 0, [2, this.parseAndStoreConfig(d)];
								case gn.Failed: return [2, this.retryFetch(e, t)];
								default: return [2, this.completeRequest({ err: kn })];
							}
							return [3, 4];
						case 3: return p = a.sent(), m = p, e.aborted ? [2, this.completeRequest({ err: Mn })] : [2, this.completeRequest({ err: m.message ?? Nn })];
						case 4: return [2];
					}
				});
			});
		}, this.retryFetch = function(e, t) {
			return i(s, void 0, void 0, function() {
				var n = this;
				return a(this, function(r) {
					switch (r.label) {
						case 0: return [4, new Promise(function(e) {
							return setTimeout(e, n.attempts * n.retryTimeout);
						})];
						case 1: return r.sent(), [2, this.fetchRemoteConfig(e, t)];
					}
				});
			});
		}, this.parseAndStoreConfig = function(e) {
			return i(s, void 0, void 0, function() {
				var t;
				return a(this, function(n) {
					switch (n.label) {
						case 0: return [4, e.json()];
						case 1: return t = n.sent(), this.completeRequest({ success: An }), [2, t];
					}
				});
			});
		}, this.localConfig = t, this.configKeys = r;
	}
	return e.prototype.getServerUrl = function() {
		return this.localConfig.serverZone === hn.STAGING ? Fn : this.localConfig.serverZone === hn.EU ? In : Pn;
	}, e.prototype.completeRequest = function(e) {
		var t = e.err, n = e.success;
		if (t) throw Error(t);
		n && this.localConfig.loggerProvider.log(n);
	}, e;
}(), Rn = function(e) {
	var t = e.localConfig, n = e.configKeys;
	return i(void 0, void 0, void 0, function() {
		return a(this, function(e) {
			return [2, new Ln({
				localConfig: t,
				configKeys: n
			})];
		});
	});
}, zn = function() {
	function e(e) {
		this.config = e, this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
	}
	return e.prototype.initialize = function() {
		return i(this, void 0, void 0, function() {
			var e;
			return a(this, function(t) {
				switch (t.label) {
					case 0: return e = this, [4, Rn({
						localConfig: this.config,
						configKeys: ["analyticsSDK"]
					})];
					case 1: return e.remoteConfigFetch = t.sent(), [2];
				}
			});
		});
	}, e.prototype.generateJoinedConfig = function() {
		var e;
		return i(this, void 0, void 0, function() {
			var t, r, i;
			return a(this, function(a) {
				switch (a.label) {
					case 0: return a.trys.push([
						0,
						3,
						,
						4
					]), r = this.remoteConfigFetch, r ? [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)] : [3, 2];
					case 1: r = a.sent(), a.label = 2;
					case 2: return t = r, this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(t, null, 2)), t && "autocapture" in t && (typeof t.autocapture == "boolean" && (this.config.autocapture = t.autocapture), typeof t.autocapture == "object" && (this.config.autocapture === void 0 && (this.config.autocapture = t.autocapture), typeof this.config.autocapture == "boolean" && (this.config.autocapture = n({
						attribution: this.config.autocapture,
						fileDownloads: this.config.autocapture,
						formInteractions: this.config.autocapture,
						pageViews: this.config.autocapture,
						sessions: this.config.autocapture,
						elementInteractions: this.config.autocapture
					}, t.autocapture)), typeof this.config.autocapture == "object" && (this.config.autocapture = n(n({}, this.config.autocapture), t.autocapture))), this.config.defaultTracking = this.config.autocapture), this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2)), (e = this.config).requestMetadata ?? (e.requestMetadata = new ge()), this.remoteConfigFetch?.metrics.fetchTimeAPISuccess && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess), this.remoteConfigFetch?.metrics.fetchTimeAPIFail && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail), [3, 4];
					case 3: return i = a.sent(), this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", i), [3, 4];
					case 4: return [2, this.config];
				}
			});
		});
	}, e;
}(), Bn = function(e) {
	return i(void 0, void 0, void 0, function() {
		var t;
		return a(this, function(n) {
			switch (n.label) {
				case 0: return t = new zn(e), [4, t.initialize()];
				case 1: return n.sent(), [2, t];
			}
		});
	});
}, Vn = "@amplitude/plugin-autocapture-browser", Hn = "[Amplitude] Element Clicked", Un = "[Amplitude] Element ID", Wn = "[Amplitude] Element Class", Gn = "[Amplitude] Element Tag", Kn = "[Amplitude] Element Text", qn = "[Amplitude] Element Hierarchy", Jn = "[Amplitude] Element Href", Yn = "[Amplitude] Element Position Left", Xn = "[Amplitude] Element Position Top", Zn = "[Amplitude] Element Aria Label", Qn = "[Amplitude] Element Attributes", $n = "[Amplitude] Element Parent Label", er = "[Amplitude] Page URL", tr = "[Amplitude] Page Title", nr = "[Amplitude] Viewport Height", rr = "[Amplitude] Viewport Width", ir = "https://app.amplitude.com", ar = {
	US: ir,
	EU: "https://app.eu.amplitude.com",
	STAGING: "https://apps.stag2.amplitude.com"
}, or = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz", sr = "amp-visual-tagging-selector-highlight";
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isFunction.js
function H(e) {
	return typeof e == "function";
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/createErrorClass.js
function cr(e) {
	var t = e(function(e) {
		Error.call(e), e.stack = (/* @__PURE__ */ Error()).stack;
	});
	return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/UnsubscriptionError.js
var lr = cr(function(e) {
	return function(t) {
		e(this), this.message = t ? t.length + " errors occurred during unsubscription:\n" + t.map(function(e, t) {
			return t + 1 + ") " + e.toString();
		}).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = t;
	};
});
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/arrRemove.js
function ur(e, t) {
	if (e) {
		var n = e.indexOf(t);
		0 <= n && e.splice(n, 1);
	}
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/Subscription.js
var dr = function() {
	function e(e) {
		this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
	}
	return e.prototype.unsubscribe = function() {
		var e, t, n, r, i;
		if (!this.closed) {
			this.closed = !0;
			var a = this._parentage;
			if (a) if (this._parentage = null, Array.isArray(a)) try {
				for (var l = o(a), u = l.next(); !u.done; u = l.next()) u.value.remove(this);
			} catch (t) {
				e = { error: t };
			} finally {
				try {
					u && !u.done && (t = l.return) && t.call(l);
				} finally {
					if (e) throw e.error;
				}
			}
			else a.remove(this);
			var d = this.initialTeardown;
			if (H(d)) try {
				d();
			} catch (e) {
				i = e instanceof lr ? e.errors : [e];
			}
			var f = this._finalizers;
			if (f) {
				this._finalizers = null;
				try {
					for (var p = o(f), m = p.next(); !m.done; m = p.next()) {
						var h = m.value;
						try {
							mr(h);
						} catch (e) {
							i ??= [], e instanceof lr ? i = c(c([], s(i)), s(e.errors)) : i.push(e);
						}
					}
				} catch (e) {
					n = { error: e };
				} finally {
					try {
						m && !m.done && (r = p.return) && r.call(p);
					} finally {
						if (n) throw n.error;
					}
				}
			}
			if (i) throw new lr(i);
		}
	}, e.prototype.add = function(t) {
		if (t && t !== this) if (this.closed) mr(t);
		else {
			if (t instanceof e) {
				if (t.closed || t._hasParent(this)) return;
				t._addParent(this);
			}
			(this._finalizers = this._finalizers ?? []).push(t);
		}
	}, e.prototype._hasParent = function(e) {
		var t = this._parentage;
		return t === e || Array.isArray(t) && t.includes(e);
	}, e.prototype._addParent = function(e) {
		var t = this._parentage;
		this._parentage = Array.isArray(t) ? (t.push(e), t) : t ? [t, e] : e;
	}, e.prototype._removeParent = function(e) {
		var t = this._parentage;
		t === e ? this._parentage = null : Array.isArray(t) && ur(t, e);
	}, e.prototype.remove = function(t) {
		var n = this._finalizers;
		n && ur(n, t), t instanceof e && t._removeParent(this);
	}, e.EMPTY = (function() {
		var t = new e();
		return t.closed = !0, t;
	})(), e;
}(), fr = dr.EMPTY;
function pr(e) {
	return e instanceof dr || e && "closed" in e && H(e.remove) && H(e.add) && H(e.unsubscribe);
}
function mr(e) {
	H(e) ? e() : e.unsubscribe();
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/config.js
var U = {
	onUnhandledError: null,
	onStoppedNotification: null,
	Promise: void 0,
	useDeprecatedSynchronousErrorHandling: !1,
	useDeprecatedNextContext: !1
}, hr = {
	setTimeout: function(e, t) {
		var n = [...arguments].slice(2), r = hr.delegate;
		return r?.setTimeout ? r.setTimeout.apply(r, c([e, t], s(n))) : setTimeout.apply(void 0, c([e, t], s(n)));
	},
	clearTimeout: function(e) {
		return (hr.delegate?.clearTimeout || clearTimeout)(e);
	},
	delegate: void 0
};
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/reportUnhandledError.js
function gr(e) {
	hr.setTimeout(function() {
		var t = U.onUnhandledError;
		if (t) t(e);
		else throw e;
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/noop.js
function _r() {}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/NotificationFactories.js
var vr = (function() {
	return xr("C", void 0, void 0);
})();
function yr(e) {
	return xr("E", void 0, e);
}
function br(e) {
	return xr("N", e, void 0);
}
function xr(e, t, n) {
	return {
		kind: e,
		value: t,
		error: n
	};
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/errorContext.js
var W = null;
function Sr(e) {
	if (U.useDeprecatedSynchronousErrorHandling) {
		var t = !W;
		if (t && (W = {
			errorThrown: !1,
			error: null
		}), e(), t) {
			var n = W, r = n.errorThrown, i = n.error;
			if (W = null, r) throw i;
		}
	} else e();
}
function Cr(e) {
	U.useDeprecatedSynchronousErrorHandling && W && (W.errorThrown = !0, W.error = e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/Subscriber.js
var wr = function(e) {
	t(n, e);
	function n(t) {
		var n = e.call(this) || this;
		return n.isStopped = !1, t ? (n.destination = t, pr(t) && t.add(n)) : n.destination = Mr, n;
	}
	return n.create = function(e, t, n) {
		return new Or(e, t, n);
	}, n.prototype.next = function(e) {
		this.isStopped ? jr(br(e), this) : this._next(e);
	}, n.prototype.error = function(e) {
		this.isStopped ? jr(yr(e), this) : (this.isStopped = !0, this._error(e));
	}, n.prototype.complete = function() {
		this.isStopped ? jr(vr, this) : (this.isStopped = !0, this._complete());
	}, n.prototype.unsubscribe = function() {
		this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
	}, n.prototype._next = function(e) {
		this.destination.next(e);
	}, n.prototype._error = function(e) {
		try {
			this.destination.error(e);
		} finally {
			this.unsubscribe();
		}
	}, n.prototype._complete = function() {
		try {
			this.destination.complete();
		} finally {
			this.unsubscribe();
		}
	}, n;
}(dr), Tr = Function.prototype.bind;
function Er(e, t) {
	return Tr.call(e, t);
}
var Dr = function() {
	function e(e) {
		this.partialObserver = e;
	}
	return e.prototype.next = function(e) {
		var t = this.partialObserver;
		if (t.next) try {
			t.next(e);
		} catch (e) {
			kr(e);
		}
	}, e.prototype.error = function(e) {
		var t = this.partialObserver;
		if (t.error) try {
			t.error(e);
		} catch (e) {
			kr(e);
		}
		else kr(e);
	}, e.prototype.complete = function() {
		var e = this.partialObserver;
		if (e.complete) try {
			e.complete();
		} catch (e) {
			kr(e);
		}
	}, e;
}(), Or = function(e) {
	t(n, e);
	function n(t, n, r) {
		var i = e.call(this) || this, a;
		if (H(t) || !t) a = {
			next: t ?? void 0,
			error: n ?? void 0,
			complete: r ?? void 0
		};
		else {
			var o;
			i && U.useDeprecatedNextContext ? (o = Object.create(t), o.unsubscribe = function() {
				return i.unsubscribe();
			}, a = {
				next: t.next && Er(t.next, o),
				error: t.error && Er(t.error, o),
				complete: t.complete && Er(t.complete, o)
			}) : a = t;
		}
		return i.destination = new Dr(a), i;
	}
	return n;
}(wr);
function kr(e) {
	U.useDeprecatedSynchronousErrorHandling ? Cr(e) : gr(e);
}
function Ar(e) {
	throw e;
}
function jr(e, t) {
	var n = U.onStoppedNotification;
	n && hr.setTimeout(function() {
		return n(e, t);
	});
}
var Mr = {
	closed: !0,
	next: _r,
	error: Ar,
	complete: _r
}, Nr = (function() {
	return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/identity.js
function Pr(e) {
	return e;
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/pipe.js
function Fr(e) {
	return e.length === 0 ? Pr : e.length === 1 ? e[0] : function(t) {
		return e.reduce(function(e, t) {
			return t(e);
		}, t);
	};
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/Observable.js
var G = function() {
	function e(e) {
		e && (this._subscribe = e);
	}
	return e.prototype.lift = function(t) {
		var n = new e();
		return n.source = this, n.operator = t, n;
	}, e.prototype.subscribe = function(e, t, n) {
		var r = this, i = Rr(e) ? e : new Or(e, t, n);
		return Sr(function() {
			var e = r, t = e.operator, n = e.source;
			i.add(t ? t.call(i, n) : n ? r._subscribe(i) : r._trySubscribe(i));
		}), i;
	}, e.prototype._trySubscribe = function(e) {
		try {
			return this._subscribe(e);
		} catch (t) {
			e.error(t);
		}
	}, e.prototype.forEach = function(e, t) {
		var n = this;
		return t = Ir(t), new t(function(t, r) {
			var i = new Or({
				next: function(t) {
					try {
						e(t);
					} catch (e) {
						r(e), i.unsubscribe();
					}
				},
				error: r,
				complete: t
			});
			n.subscribe(i);
		});
	}, e.prototype._subscribe = function(e) {
		return this.source?.subscribe(e);
	}, e.prototype[Nr] = function() {
		return this;
	}, e.prototype.pipe = function() {
		return Fr([...arguments])(this);
	}, e.prototype.toPromise = function(e) {
		var t = this;
		return e = Ir(e), new e(function(e, n) {
			var r;
			t.subscribe(function(e) {
				return r = e;
			}, function(e) {
				return n(e);
			}, function() {
				return e(r);
			});
		});
	}, e.create = function(t) {
		return new e(t);
	}, e;
}();
function Ir(e) {
	return e ?? U.Promise ?? Promise;
}
function Lr(e) {
	return e && H(e.next) && H(e.error) && H(e.complete);
}
function Rr(e) {
	return e && e instanceof wr || Lr(e) && pr(e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/lift.js
function zr(e) {
	return H(e?.lift);
}
function K(e) {
	return function(t) {
		if (zr(t)) return t.lift(function(t) {
			try {
				return e(t, this);
			} catch (e) {
				this.error(e);
			}
		});
		throw TypeError("Unable to lift unknown Observable type");
	};
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/OperatorSubscriber.js
function q(e, t, n, r, i) {
	return new Br(e, t, n, r, i);
}
var Br = function(e) {
	t(n, e);
	function n(t, n, r, i, a, o) {
		var s = e.call(this, t) || this;
		return s.onFinalize = a, s.shouldUnsubscribe = o, s._next = n ? function(e) {
			try {
				n(e);
			} catch (e) {
				t.error(e);
			}
		} : e.prototype._next, s._error = i ? function(e) {
			try {
				i(e);
			} catch (e) {
				t.error(e);
			} finally {
				this.unsubscribe();
			}
		} : e.prototype._error, s._complete = r ? function() {
			try {
				r();
			} catch (e) {
				t.error(e);
			} finally {
				this.unsubscribe();
			}
		} : e.prototype._complete, s;
	}
	return n.prototype.unsubscribe = function() {
		var t;
		if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
			var n = this.closed;
			e.prototype.unsubscribe.call(this), !n && ((t = this.onFinalize) == null || t.call(this));
		}
	}, n;
}(wr), Vr = cr(function(e) {
	return function() {
		e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
	};
}), Hr = function(e) {
	t(n, e);
	function n() {
		var t = e.call(this) || this;
		return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
	}
	return n.prototype.lift = function(e) {
		var t = new Ur(this, this);
		return t.operator = e, t;
	}, n.prototype._throwIfClosed = function() {
		if (this.closed) throw new Vr();
	}, n.prototype.next = function(e) {
		var t = this;
		Sr(function() {
			var n, r;
			if (t._throwIfClosed(), !t.isStopped) {
				t.currentObservers ||= Array.from(t.observers);
				try {
					for (var i = o(t.currentObservers), a = i.next(); !a.done; a = i.next()) a.value.next(e);
				} catch (e) {
					n = { error: e };
				} finally {
					try {
						a && !a.done && (r = i.return) && r.call(i);
					} finally {
						if (n) throw n.error;
					}
				}
			}
		});
	}, n.prototype.error = function(e) {
		var t = this;
		Sr(function() {
			if (t._throwIfClosed(), !t.isStopped) {
				t.hasError = t.isStopped = !0, t.thrownError = e;
				for (var n = t.observers; n.length;) n.shift().error(e);
			}
		});
	}, n.prototype.complete = function() {
		var e = this;
		Sr(function() {
			if (e._throwIfClosed(), !e.isStopped) {
				e.isStopped = !0;
				for (var t = e.observers; t.length;) t.shift().complete();
			}
		});
	}, n.prototype.unsubscribe = function() {
		this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
	}, Object.defineProperty(n.prototype, "observed", {
		get: function() {
			return this.observers?.length > 0;
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype._trySubscribe = function(t) {
		return this._throwIfClosed(), e.prototype._trySubscribe.call(this, t);
	}, n.prototype._subscribe = function(e) {
		return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
	}, n.prototype._innerSubscribe = function(e) {
		var t = this, n = this, r = n.hasError, i = n.isStopped, a = n.observers;
		return r || i ? fr : (this.currentObservers = null, a.push(e), new dr(function() {
			t.currentObservers = null, ur(a, e);
		}));
	}, n.prototype._checkFinalizedStatuses = function(e) {
		var t = this, n = t.hasError, r = t.thrownError, i = t.isStopped;
		n ? e.error(r) : i && e.complete();
	}, n.prototype.asObservable = function() {
		var e = new G();
		return e.source = this, e;
	}, n.create = function(e, t) {
		return new Ur(e, t);
	}, n;
}(G), Ur = function(e) {
	t(n, e);
	function n(t, n) {
		var r = e.call(this) || this;
		return r.destination = t, r.source = n, r;
	}
	return n.prototype.next = function(e) {
		var t, n;
		(n = (t = this.destination)?.next) == null || n.call(t, e);
	}, n.prototype.error = function(e) {
		var t, n;
		(n = (t = this.destination)?.error) == null || n.call(t, e);
	}, n.prototype.complete = function() {
		var e, t;
		(t = (e = this.destination)?.complete) == null || t.call(e);
	}, n.prototype._subscribe = function(e) {
		return this.source?.subscribe(e) ?? fr;
	}, n;
}(Hr), Wr = {
	now: function() {
		return (Wr.delegate || Date).now();
	},
	delegate: void 0
}, Gr = function(e) {
	t(n, e);
	function n(t, n) {
		return e.call(this) || this;
	}
	return n.prototype.schedule = function(e, t) {
		return t === void 0 && (t = 0), this;
	}, n;
}(dr), Kr = {
	setInterval: function(e, t) {
		var n = [...arguments].slice(2), r = Kr.delegate;
		return r?.setInterval ? r.setInterval.apply(r, c([e, t], s(n))) : setInterval.apply(void 0, c([e, t], s(n)));
	},
	clearInterval: function(e) {
		return (Kr.delegate?.clearInterval || clearInterval)(e);
	},
	delegate: void 0
}, qr = function(e) {
	t(n, e);
	function n(t, n) {
		var r = e.call(this, t, n) || this;
		return r.scheduler = t, r.work = n, r.pending = !1, r;
	}
	return n.prototype.schedule = function(e, t) {
		if (t === void 0 && (t = 0), this.closed) return this;
		this.state = e;
		var n = this.id, r = this.scheduler;
		return n != null && (this.id = this.recycleAsyncId(r, n, t)), this.pending = !0, this.delay = t, this.id = this.id ?? this.requestAsyncId(r, this.id, t), this;
	}, n.prototype.requestAsyncId = function(e, t, n) {
		return n === void 0 && (n = 0), Kr.setInterval(e.flush.bind(e, this), n);
	}, n.prototype.recycleAsyncId = function(e, t, n) {
		if (n === void 0 && (n = 0), n != null && this.delay === n && this.pending === !1) return t;
		t != null && Kr.clearInterval(t);
	}, n.prototype.execute = function(e, t) {
		if (this.closed) return /* @__PURE__ */ Error("executing a cancelled action");
		this.pending = !1;
		var n = this._execute(e, t);
		if (n) return n;
		this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
	}, n.prototype._execute = function(e, t) {
		var n = !1, r;
		try {
			this.work(e);
		} catch (e) {
			n = !0, r = e || /* @__PURE__ */ Error("Scheduled action threw falsy error");
		}
		if (n) return this.unsubscribe(), r;
	}, n.prototype.unsubscribe = function() {
		if (!this.closed) {
			var t = this, n = t.id, r = t.scheduler, i = r.actions;
			this.work = this.state = this.scheduler = null, this.pending = !1, ur(i, this), n != null && (this.id = this.recycleAsyncId(r, n, null)), this.delay = null, e.prototype.unsubscribe.call(this);
		}
	}, n;
}(Gr), Jr = function() {
	function e(t, n) {
		n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
	}
	return e.prototype.schedule = function(e, t, n) {
		return t === void 0 && (t = 0), new this.schedulerActionCtor(this, e).schedule(n, t);
	}, e.now = Wr.now, e;
}(), Yr = new (function(e) {
	t(n, e);
	function n(t, n) {
		n === void 0 && (n = Jr.now);
		var r = e.call(this, t, n) || this;
		return r.actions = [], r._active = !1, r;
	}
	return n.prototype.flush = function(e) {
		var t = this.actions;
		if (this._active) {
			t.push(e);
			return;
		}
		var n;
		this._active = !0;
		do
			if (n = e.execute(e.state, e.delay)) break;
		while (e = t.shift());
		if (this._active = !1, n) {
			for (; e = t.shift();) e.unsubscribe();
			throw n;
		}
	}, n;
}(Jr))(qr), Xr = Yr, Zr = new G(function(e) {
	return e.complete();
});
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isScheduler.js
function Qr(e) {
	return e && H(e.schedule);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/args.js
function $r(e) {
	return e[e.length - 1];
}
function ei(e) {
	return Qr($r(e)) ? e.pop() : void 0;
}
function ti(e, t) {
	return typeof $r(e) == "number" ? e.pop() : t;
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isArrayLike.js
var ni = (function(e) {
	return e && typeof e.length == "number" && typeof e != "function";
});
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isPromise.js
function ri(e) {
	return H(e?.then);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isInteropObservable.js
function ii(e) {
	return H(e[Nr]);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isAsyncIterable.js
function ai(e) {
	return Symbol.asyncIterator && H(e?.[Symbol.asyncIterator]);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/throwUnobservableError.js
function oi(e) {
	return /* @__PURE__ */ TypeError("You provided " + (typeof e == "object" && e ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/symbol/iterator.js
function si() {
	return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var ci = si();
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isIterable.js
function li(e) {
	return H(e?.[ci]);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isReadableStreamLike.js
function ui(e) {
	return u(this, arguments, function() {
		var t, n, r, i;
		return a(this, function(a) {
			switch (a.label) {
				case 0: t = e.getReader(), a.label = 1;
				case 1: a.trys.push([
					1,
					,
					9,
					10
				]), a.label = 2;
				case 2: return [4, l(t.read())];
				case 3: return n = a.sent(), r = n.value, i = n.done, i ? [4, l(void 0)] : [3, 5];
				case 4: return [2, a.sent()];
				case 5: return [4, l(r)];
				case 6: return [4, a.sent()];
				case 7: return a.sent(), [3, 2];
				case 8: return [3, 10];
				case 9: return t.releaseLock(), [7];
				case 10: return [2];
			}
		});
	});
}
function di(e) {
	return H(e?.getReader);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/observable/innerFrom.js
function J(e) {
	if (e instanceof G) return e;
	if (e != null) {
		if (ii(e)) return fi(e);
		if (ni(e)) return pi(e);
		if (ri(e)) return mi(e);
		if (ai(e)) return gi(e);
		if (li(e)) return hi(e);
		if (di(e)) return _i(e);
	}
	throw oi(e);
}
function fi(e) {
	return new G(function(t) {
		var n = e[Nr]();
		if (H(n.subscribe)) return n.subscribe(t);
		throw TypeError("Provided object does not correctly implement Symbol.observable");
	});
}
function pi(e) {
	return new G(function(t) {
		for (var n = 0; n < e.length && !t.closed; n++) t.next(e[n]);
		t.complete();
	});
}
function mi(e) {
	return new G(function(t) {
		e.then(function(e) {
			t.closed || (t.next(e), t.complete());
		}, function(e) {
			return t.error(e);
		}).then(null, gr);
	});
}
function hi(e) {
	return new G(function(t) {
		var n, r;
		try {
			for (var i = o(e), a = i.next(); !a.done; a = i.next()) {
				var s = a.value;
				if (t.next(s), t.closed) return;
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				a && !a.done && (r = i.return) && r.call(i);
			} finally {
				if (n) throw n.error;
			}
		}
		t.complete();
	});
}
function gi(e) {
	return new G(function(t) {
		vi(e, t).catch(function(e) {
			return t.error(e);
		});
	});
}
function _i(e) {
	return gi(ui(e));
}
function vi(e, t) {
	var n, r, o, s;
	return i(this, void 0, void 0, function() {
		var i, c;
		return a(this, function(a) {
			switch (a.label) {
				case 0: a.trys.push([
					0,
					5,
					6,
					11
				]), n = d(e), a.label = 1;
				case 1: return [4, n.next()];
				case 2:
					if (r = a.sent(), r.done) return [3, 4];
					if (i = r.value, t.next(i), t.closed) return [2];
					a.label = 3;
				case 3: return [3, 1];
				case 4: return [3, 11];
				case 5: return c = a.sent(), o = { error: c }, [3, 11];
				case 6: return a.trys.push([
					6,
					,
					9,
					10
				]), r && !r.done && (s = n.return) ? [4, s.call(n)] : [3, 8];
				case 7: a.sent(), a.label = 8;
				case 8: return [3, 10];
				case 9:
					if (o) throw o.error;
					return [7];
				case 10: return [7];
				case 11: return t.complete(), [2];
			}
		});
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/executeSchedule.js
function Y(e, t, n, r, i) {
	r === void 0 && (r = 0), i === void 0 && (i = !1);
	var a = t.schedule(function() {
		n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
	}, r);
	if (e.add(a), !i) return a;
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/observeOn.js
function yi(e, t) {
	return t === void 0 && (t = 0), K(function(n, r) {
		n.subscribe(q(r, function(n) {
			return Y(r, e, function() {
				return r.next(n);
			}, t);
		}, function() {
			return Y(r, e, function() {
				return r.complete();
			}, t);
		}, function(n) {
			return Y(r, e, function() {
				return r.error(n);
			}, t);
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/subscribeOn.js
function bi(e, t) {
	return t === void 0 && (t = 0), K(function(n, r) {
		r.add(e.schedule(function() {
			return n.subscribe(r);
		}, t));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleObservable.js
function xi(e, t) {
	return J(e).pipe(bi(t), yi(t));
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/schedulePromise.js
function Si(e, t) {
	return J(e).pipe(bi(t), yi(t));
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleArray.js
function Ci(e, t) {
	return new G(function(n) {
		var r = 0;
		return t.schedule(function() {
			r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
		});
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleIterable.js
function wi(e, t) {
	return new G(function(n) {
		var r;
		return Y(n, t, function() {
			r = e[ci](), Y(n, t, function() {
				var e, t, i;
				try {
					e = r.next(), t = e.value, i = e.done;
				} catch (e) {
					n.error(e);
					return;
				}
				i ? n.complete() : n.next(t);
			}, 0, !0);
		}), function() {
			return H(r?.return) && r.return();
		};
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleAsyncIterable.js
function Ti(e, t) {
	if (!e) throw Error("Iterable cannot be null");
	return new G(function(n) {
		Y(n, t, function() {
			var r = e[Symbol.asyncIterator]();
			Y(n, t, function() {
				r.next().then(function(e) {
					e.done ? n.complete() : n.next(e.value);
				});
			}, 0, !0);
		});
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/scheduleReadableStreamLike.js
function Ei(e, t) {
	return Ti(ui(e), t);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/scheduled/scheduled.js
function Di(e, t) {
	if (e != null) {
		if (ii(e)) return xi(e, t);
		if (ni(e)) return Ci(e, t);
		if (ri(e)) return Si(e, t);
		if (ai(e)) return Ti(e, t);
		if (li(e)) return wi(e, t);
		if (di(e)) return Ei(e, t);
	}
	throw oi(e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/observable/from.js
function Oi(e, t) {
	return t ? Di(e, t) : J(e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/isDate.js
function ki(e) {
	return e instanceof Date && !isNaN(e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/timeout.js
var Ai = cr(function(e) {
	return function(t) {
		t === void 0 && (t = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = t;
	};
});
function ji(e, t) {
	var n = ki(e) ? { first: e } : typeof e == "number" ? { each: e } : e, r = n.first, i = n.each, a = n.with, o = a === void 0 ? Mi : a, s = n.scheduler, c = s === void 0 ? t ?? Yr : s, l = n.meta, u = l === void 0 ? null : l;
	if (r == null && i == null) throw TypeError("No timeout provided.");
	return K(function(e, t) {
		var n, a, s = null, l = 0, d = function(e) {
			a = Y(t, c, function() {
				try {
					n.unsubscribe(), J(o({
						meta: u,
						lastValue: s,
						seen: l
					})).subscribe(t);
				} catch (e) {
					t.error(e);
				}
			}, e);
		};
		n = e.subscribe(q(t, function(e) {
			a?.unsubscribe(), l++, t.next(s = e), i > 0 && d(i);
		}, void 0, void 0, function() {
			a?.closed || a?.unsubscribe(), s = null;
		})), !l && d(r == null ? i : typeof r == "number" ? r : +r - c.now());
	});
}
function Mi(e) {
	throw new Ai(e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/map.js
function X(e, t) {
	return K(function(n, r) {
		var i = 0;
		n.subscribe(q(r, function(n) {
			r.next(e.call(t, n, i++));
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/util/mapOneOrManyArgs.js
var Ni = Array.isArray;
function Pi(e, t) {
	return Ni(t) ? e.apply(void 0, c([], s(t))) : e(t);
}
function Fi(e) {
	return X(function(t) {
		return Pi(e, t);
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/mergeInternals.js
function Ii(e, t, n, r, i, a, o, s) {
	var c = [], l = 0, u = 0, d = !1, f = function() {
		d && !c.length && !l && t.complete();
	}, p = function(e) {
		return l < r ? m(e) : c.push(e);
	}, m = function(e) {
		a && t.next(e), l++;
		var s = !1;
		J(n(e, u++)).subscribe(q(t, function(e) {
			i?.(e), a ? p(e) : t.next(e);
		}, function() {
			s = !0;
		}, void 0, function() {
			if (s) try {
				l--;
				for (var e = function() {
					var e = c.shift();
					o ? Y(t, o, function() {
						return m(e);
					}) : m(e);
				}; c.length && l < r;) e();
				f();
			} catch (e) {
				t.error(e);
			}
		}));
	};
	return e.subscribe(q(t, p, function() {
		d = !0, f();
	})), function() {
		s?.();
	};
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/mergeMap.js
function Li(e, t, n) {
	return n === void 0 && (n = Infinity), H(t) ? Li(function(n, r) {
		return X(function(e, i) {
			return t(n, e, r, i);
		})(J(e(n, r)));
	}, n) : (typeof t == "number" && (n = t), K(function(t, r) {
		return Ii(t, r, e, n);
	}));
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/mergeAll.js
function Ri(e) {
	return e === void 0 && (e = Infinity), Li(Pr, e);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/concatAll.js
function zi() {
	return Ri(1);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/observable/concat.js
function Bi() {
	var e = [...arguments];
	return zi()(Oi(e, ei(e)));
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/observable/fromEvent.js
var Vi = ["addListener", "removeListener"], Hi = ["addEventListener", "removeEventListener"], Ui = ["on", "off"];
function Z(e, t, n, r) {
	if (H(n) && (r = n, n = void 0), r) return Z(e, t, n).pipe(Fi(r));
	var i = s(qi(e) ? Hi.map(function(r) {
		return function(i) {
			return e[r](t, i, n);
		};
	}) : Gi(e) ? Vi.map(Wi(e, t)) : Ki(e) ? Ui.map(Wi(e, t)) : [], 2), a = i[0], o = i[1];
	if (!a && ni(e)) return Li(function(e) {
		return Z(e, t, n);
	})(J(e));
	if (!a) throw TypeError("Invalid event target");
	return new G(function(e) {
		var t = function() {
			var t = [...arguments];
			return e.next(1 < t.length ? t : t[0]);
		};
		return a(t), function() {
			return o(t);
		};
	});
}
function Wi(e, t) {
	return function(n) {
		return function(r) {
			return e[n](t, r);
		};
	};
}
function Gi(e) {
	return H(e.addListener) && H(e.removeListener);
}
function Ki(e) {
	return H(e.on) && H(e.off);
}
function qi(e) {
	return H(e.addEventListener) && H(e.removeEventListener);
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/observable/timer.js
function Ji(e, t, n) {
	e === void 0 && (e = 0), n === void 0 && (n = Xr);
	var r = -1;
	return t != null && (Qr(t) ? n = t : r = t), new G(function(t) {
		var i = ki(e) ? +e - n.now() : e;
		i < 0 && (i = 0);
		var a = 0;
		return n.schedule(function() {
			t.closed || (t.next(a++), 0 <= r ? this.schedule(void 0, r) : t.complete());
		}, i);
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/observable/merge.js
function Yi() {
	var e = [...arguments], t = ei(e), n = ti(e, Infinity), r = e;
	return r.length ? r.length === 1 ? J(r[0]) : Ri(n)(Oi(r, t)) : Zr;
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/filter.js
function Q(e, t) {
	return K(function(n, r) {
		var i = 0;
		n.subscribe(q(r, function(n) {
			return e.call(t, n, i++) && r.next(n);
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/buffer.js
function Xi(e) {
	return K(function(t, n) {
		var r = [];
		return t.subscribe(q(n, function(e) {
			return r.push(e);
		}, function() {
			n.next(r), n.complete();
		})), J(e).subscribe(q(n, function() {
			var e = r;
			r = [], n.next(e);
		}, _r)), function() {
			r = null;
		};
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/debounceTime.js
function Zi(e, t) {
	return t === void 0 && (t = Yr), K(function(n, r) {
		var i = null, a = null, o = null, s = function() {
			if (i) {
				i.unsubscribe(), i = null;
				var e = a;
				a = null, r.next(e);
			}
		};
		function c() {
			var n = o + e, a = t.now();
			if (a < n) {
				i = this.schedule(void 0, n - a), r.add(i);
				return;
			}
			s();
		}
		n.subscribe(q(r, function(n) {
			a = n, o = t.now(), i || (i = t.schedule(c, e), r.add(i));
		}, function() {
			s(), r.complete();
		}, void 0, function() {
			a = i = null;
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/take.js
function Qi(e) {
	return e <= 0 ? function() {
		return Zr;
	} : K(function(t, n) {
		var r = 0;
		t.subscribe(q(n, function(t) {
			++r <= e && (n.next(t), e <= r && n.complete());
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/ignoreElements.js
function $i() {
	return K(function(e, t) {
		e.subscribe(q(t, _r));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/mapTo.js
function ea(e) {
	return X(function() {
		return e;
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/delayWhen.js
function ta(e, t) {
	return t ? function(n) {
		return Bi(t.pipe(Qi(1), $i()), n.pipe(ta(e)));
	} : Li(function(t, n) {
		return J(e(t, n)).pipe(Qi(1), ea(t));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/delay.js
function na(e, t) {
	t === void 0 && (t = Yr);
	var n = Ji(e, t);
	return ta(function() {
		return n;
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/pairwise.js
function ra() {
	return K(function(e, t) {
		var n, r = !1;
		e.subscribe(q(t, function(e) {
			var i = n;
			n = e, r && t.next([i, e]), r = !0;
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/share.js
function ia(e) {
	e === void 0 && (e = {});
	var t = e.connector, n = t === void 0 ? function() {
		return new Hr();
	} : t, r = e.resetOnError, i = r === void 0 || r, a = e.resetOnComplete, o = a === void 0 || a, s = e.resetOnRefCountZero, c = s === void 0 || s;
	return function(e) {
		var t, r, a, s = 0, l = !1, u = !1, d = function() {
			r?.unsubscribe(), r = void 0;
		}, f = function() {
			d(), t = a = void 0, l = u = !1;
		}, p = function() {
			var e = t;
			f(), e?.unsubscribe();
		};
		return K(function(e, m) {
			s++, !u && !l && d();
			var h = a ??= n();
			m.add(function() {
				s--, s === 0 && !u && !l && (r = aa(p, c));
			}), h.subscribe(m), !t && s > 0 && (t = new Or({
				next: function(e) {
					return h.next(e);
				},
				error: function(e) {
					u = !0, d(), r = aa(f, i, e), h.error(e);
				},
				complete: function() {
					l = !0, d(), r = aa(f, o), h.complete();
				}
			}), J(e).subscribe(t));
		})(e);
	};
}
function aa(e, t) {
	var n = [...arguments].slice(2);
	if (t === !0) {
		e();
		return;
	}
	if (t !== !1) {
		var r = new Or({ next: function() {
			r.unsubscribe(), e();
		} });
		return J(t.apply(void 0, c([], s(n)))).subscribe(r);
	}
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/node_modules/rxjs/dist/esm5/internal/operators/switchMap.js
function oa(e, t) {
	return K(function(n, r) {
		var i = null, a = 0, o = !1, s = function() {
			return o && !i && r.complete();
		};
		n.subscribe(q(r, function(n) {
			i?.unsubscribe();
			var o = 0, c = a++;
			J(e(n, c)).subscribe(i = q(r, function(e) {
				return r.next(t ? t(n, e, c, o++) : e);
			}, function() {
				i = null, s();
			}));
		}, function() {
			o = !0, s();
		}));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/lib/esm/helpers.js
var sa = [
	"input",
	"select",
	"textarea"
], ca = function(e, t) {
	return function(n, r) {
		var i, a = e.pageUrlAllowlist, o = e.shouldTrackEventResolver, s = ((i = r?.tagName)?.toLowerCase)?.call(i);
		if (!s) return !1;
		if (o) return o(n, r);
		if (!pa(window.location.href, a)) return !1;
		/* istanbul ignore next */
		var c = String(r?.getAttribute("type")) || "";
		if (typeof c == "string") switch (c.toLowerCase()) {
			case "hidden": return !1;
			case "password": return !1;
		}
		/* istanbul ignore if */
		if (t && !t.some(function(e) {
			return !!(r?.matches)?.call(r, e);
		})) return !1;
		switch (s) {
			case "input":
			case "select":
			case "textarea": return n === "change" || n === "click";
			default:
				/* istanbul ignore next */
				var l = (window == null ? void 0 : window.getComputedStyle)?.call(window, r);
				return l && l.getPropertyValue("cursor") === "pointer" && n === "click" ? !0 : n === "click";
		}
	};
}, la = function(e) {
	return !(e == null || typeof e == "string" && (/^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/.test((e || "").replace(/[- ]/g, "")) || /(^\d{3}-?\d{2}-?\d{4}$)/.test(e)));
}, ua = function(e) {
	return !!e && e.nodeType === 3;
}, da = function(e) {
	var t, n = ((t = e?.tagName)?.toLowerCase)?.call(t), r = e instanceof HTMLElement && e.getAttribute("contenteditable")?.toLowerCase() === "true";
	return !sa.includes(n) && !r;
}, fa = function(e) {
	var t = "";
	return da(e) && e.childNodes && e.childNodes.length && e.childNodes.forEach(function(e) {
		var n = "";
		ua(e) ? e.textContent && (n = e.textContent) : n = fa(e), t += n.split(/(\s+)/).filter(la).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
	}), t;
}, pa = function(e, t) {
	return !t || !t.length || t.some(function(t) {
		return typeof t == "string" ? e === t : e.match(t);
	});
}, ma = function(e, t) {
	return e.getAttributeNames().reduce(function(n, r) {
		if (r.startsWith(t)) {
			var i = r.replace(t, ""), a = e.getAttribute(r);
			i && (n[i] = a || "");
		}
		return n;
	}, {});
}, ha = function(e) {
	return e == null || typeof e == "object" && Object.keys(e).length === 0 || typeof e == "string" && e.trim().length === 0;
}, ga = function(e) {
	return Object.keys(e).reduce(function(t, n) {
		var r = e[n];
		return ha(r) || (t[n] = r), t;
	}, {});
}, _a = function(e) {
	var t = e.parentElement;
	if (!t) return "";
	var n;
	try {
		n = t.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
	} catch {
		n = null;
	}
	if (n) {
		/* istanbul ignore next */
		var r = n.textContent || "";
		return la(r) ? r : "";
	}
	return _a(t);
}, va = function(e, t) {
	/* istanbul ignore next */
	return e ? t.some(function(t) {
		return (e?.matches)?.call(e, t);
	}) ? e : va(e?.parentElement, t) : null;
}, ya = function(e) {
	var t, n;
	if (!e) return {};
	/* istanbul ignore next */
	var r = ((n = e?.tagName)?.toLowerCase)?.call(n);
	return ga((t = {}, t[Gn] = r, t[Kn] = fa(e), t[er] = window.location.href.split("?")[0], t));
}, ba = function(e) {
	return new Promise(function(t, n) {
		var r;
		try {
			var i = document.createElement("script");
			/* istanbul ignore next */
			i.type = "text/javascript", i.async = !0, i.src = e, i.addEventListener("load", function() {
				t({ status: !0 });
			}, { once: !0 }), i.addEventListener("error", function() {
				n({
					status: !1,
					message: `Failed to load the script ${e}`
				});
			}), (r = document.head) == null || r.appendChild(i);
		} catch (e) {
			/* istanbul ignore next */
			n(e);
		}
	});
};
function xa() {
	return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
var Sa = function(e) {
	return !(e.event.target === null || !e.closestTrackedAncestor);
}, Ca = function() {
	function e(e) {
		var t = (e === void 0 ? {} : e).origin, n = t === void 0 ? ir : t, r = this;
		this.endpoint = ir, this.requestCallbacks = {}, this.onSelect = function(e) {
			r.notify({
				action: "element-selected",
				data: e
			});
		}, this.onTrack = function(e, t) {
			e === "selector-mode-changed" ? r.notify({
				action: "track-selector-mode-changed",
				data: t
			}) : e === "selector-moved" && r.notify({
				action: "track-selector-moved",
				data: t
			});
		}, this.endpoint = n;
	}
	return e.prototype.notify = function(e) {
		var t, n, r, i;
		(n = (t = this.logger)?.debug) == null || n.call(t, "Message sent: ", JSON.stringify(e)), (i = (r = window.opener)?.postMessage) == null || i.call(r, e, this.endpoint);
	}, e.prototype.sendRequest = function(e, t, n) {
		var r = this;
		n === void 0 && (n = { timeout: 15e3 });
		var i = xa(), a = {
			id: i,
			action: e,
			args: t
		};
		return new Promise(function(t, o) {
			r.requestCallbacks[i] = {
				resolve: t,
				reject: o
			}, r.notify(a), n?.timeout > 0 && setTimeout(function() {
				o(/* @__PURE__ */ Error(`${e} timed out (id: ${i})`)), delete r.requestCallbacks[i];
			}, n.timeout);
		});
	}, e.prototype.handleResponse = function(e) {
		var t;
		if (!this.requestCallbacks[e.id]) {
			(t = this.logger) == null || t.warn(`No callback found for request id: ${e.id}`);
			return;
		}
		this.requestCallbacks[e.id].resolve(e.responseData), delete this.requestCallbacks[e.id];
	}, e.prototype.setup = function(e) {
		var t = this, n = e === void 0 ? {} : e, r = n.logger, i = n.endpoint, a = n.isElementSelectable, o = n.cssSelectorAllowlist, s = n.actionClickAllowlist;
		this.logger = r, i && this.endpoint === "https://app.amplitude.com" && (this.endpoint = i);
		var c = null;
		window.addEventListener("message", function(e) {
			var n, r, i, l, u;
			if ((r = (n = t.logger)?.debug) == null || r.call(n, "Message received: ", JSON.stringify(e)), t.endpoint === e.origin) {
				var d = e?.data, f = d?.action;
				if (f) if ("id" in d) (l = (i = t.logger)?.debug) == null || l.call(i, "Received Response to previous request: ", JSON.stringify(e)), t.handleResponse(d);
				else if (f === "ping") t.notify({ action: "pong" });
				else if (f === "initialize-visual-tagging-selector") {
					var p = d?.data;
					ba(or).then(function() {
						c = (window == null ? void 0 : window.amplitudeVisualTaggingSelector)?.call(window, {
							getEventTagProps: ya,
							isElementSelectable: function(e) {
								return !a || a(p?.actionType || "click", e);
							},
							onTrack: t.onTrack,
							onSelect: t.onSelect,
							visualHighlightClass: sr,
							messenger: t,
							cssSelectorAllowlist: o,
							actionClickAllowlist: s
						}), t.notify({ action: "selector-loaded" });
					}).catch(function() {
						var e;
						(e = t.logger) == null || e.warn("Failed to initialize visual tagging selector");
					});
				} else f === "close-visual-tagging-selector" && ((u = c?.close) == null || u.call(c));
			}
		}), this.notify({ action: "page-loaded" });
	}, e;
}(), wa = [
	"id",
	"class",
	"style",
	"value",
	"onclick",
	"onchange",
	"oninput",
	"onblur",
	"onsubmit",
	"onfocus",
	"onkeydown",
	"onkeyup",
	"onkeypress",
	"data-reactid",
	"data-react-checksum",
	"data-reactroot"
], Ta = ["type"], Ea = [
	"svg",
	"path",
	"g"
], Da = ["password", "hidden"], Oa = 128, ka = 1024;
function Aa(e) {
	var t, n;
	if (e === null) return null;
	var r = String(e.tagName).toLowerCase(), i = { tag: r }, a = Array.from(e.parentElement?.children ?? []);
	a.length && (i.index = a.indexOf(e), i.indexOfType = a.filter(function(t) {
		return t.tagName === e.tagName;
	}).indexOf(e));
	var s = (e.previousElementSibling?.tagName)?.toLowerCase();
	s && (i.prevSib = String(s));
	var c = e.getAttribute("id");
	c && (i.id = String(c));
	var l = Array.from(e.classList);
	l.length && (i.classes = l);
	var u = {}, d = Array.from(e.attributes).filter(function(e) {
		return !wa.includes(e.name);
	}), f = !da(e);
	if (!Da.includes(String(e.getAttribute("type"))) && !Ea.includes(r)) try {
		for (var p = o(d), m = p.next(); !m.done; m = p.next()) {
			var h = m.value;
			f && !Ta.includes(h.name) || (u[h.name] = String(h.value).substring(0, Oa));
		}
	} catch (e) {
		t = { error: e };
	} finally {
		try {
			m && !m.done && (n = p.return) && n.call(p);
		} finally {
			if (t) throw t.error;
		}
	}
	return Object.keys(u).length && (i.attrs = u), i;
}
function ja(e) {
	var t = [];
	if (!e) return t;
	t.push(e);
	for (var n = e.parentElement; n && n.tagName !== "HTML";) t.push(n), n = n.parentElement;
	return t;
}
var Ma = function(e) {
	var t = [];
	return e ? (t = Na(ja(e).map(function(e) {
		return Aa(e);
	}), ka), t) : [];
};
function Na(e, t) {
	for (var n = 0, r = 0; r < e.length; r++) {
		var i = e[r];
		if (i === null) n += 4;
		else {
			var a = Pa(i);
			n += a ? Array.from(a).length : 4;
		}
		if (n > t) return e.slice(0, r);
	}
	return e;
}
function Pa(e, t) {
	t === void 0 && (t = !1);
	try {
		if (e == null) return t ? "None" : null;
		if (typeof e == "string") return t ? (e = e.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r"), e.includes("\"") ? `'${e}'` : e.includes("'") ? `"${e.replace(/'/g, "\\'")}"` : `'${e}'`) : e;
		if (typeof e == "boolean") return e ? "True" : "False";
		if (Array.isArray(e)) return `[${e.map(function(e) {
			return Pa(e, !0);
		}).join(", ")}]`;
		if (typeof e == "object") {
			var n = `{${Object.entries(e).filter(function(e) {
				return s(e, 1)[0] != null;
			}).map(function(e) {
				var t = s(e, 2), n = t[0], r = t[1];
				return `${String(Pa(n, !0))}: ${String(Pa(r, !0))}`;
			}).join(", ")}}`;
			return n.includes("\\'") && (n = n.replace(/'/g, "'").replace(/'/g, "\\'")), n;
		}
		return e.toString();
	} catch {
		return null;
	}
}
function Fa(e) {
	var t = e.amplitude, n = e.allObservables, r = e.options, i = e.shouldTrackEvent, a = n.clickObservable, c = Yi(a.pipe(ra(), Q(function(e) {
		var t = s(e, 2), n = t[0], r = t[1], i = n.event.target !== r.event.target, a = Math.abs(r.event.screenX - n.event.screenX) <= 20 && Math.abs(r.event.screenY - n.event.screenY) <= 20;
		return i && !a;
	})), a.pipe(Zi(r.debounceTime), X(function() {
		return "timeout";
	})));
	return a.pipe(na(0), Q(Sa), Q(function(e) {
		return i("click", e.closestTrackedAncestor);
	}), Xi(c)).subscribe(function(e) {
		var n, r, i = (e.length, Hn);
		try {
			for (var a = o(e), s = a.next(); !s.done; s = a.next()) {
				var c = s.value;
				/* istanbul ignore next */
				t?.track(i, c.targetElementProperties);
			}
		} catch (e) {
			n = { error: e };
		} finally {
			try {
				s && !s.done && (r = a.return) && r.call(a);
			} finally {
				if (n) throw n.error;
			}
		}
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-change.js
function Ia(e) {
	var t = e.amplitude, n = e.allObservables, r = e.getEventProperties, i = e.shouldTrackEvent;
	return n.changeObservable.pipe(Q(Sa), Q(function(e) {
		return i("change", e.closestTrackedAncestor);
	})).subscribe(function(e) {
		/* istanbul ignore next */
		t?.track("[Amplitude] Element Changed", r("change", e.closestTrackedAncestor));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture/track-action-click.js
function La(e) {
	var t = e.amplitude, n = e.allObservables, r = e.options, i = e.getEventProperties, a = e.shouldTrackEvent, o = e.shouldTrackActionClick, l = n.clickObservable, u = n.mutationObservable, d = n.navigateObservable, f = l.pipe(Q(function(e) {
		return !a("click", e.closestTrackedAncestor);
	}), X(function(e) {
		return e.closestTrackedAncestor = va(e.event.target, r.actionClickAllowlist), e.closestTrackedAncestor !== null && (e.targetElementProperties = i(e.type, e.closestTrackedAncestor)), e;
	}), Q(Sa), Q(function(e) {
		return o("click", e.closestTrackedAncestor);
	})), p = [u];
	/* istanbul ignore next */
	d && p.push(d);
	var m = Yi.apply(void 0, c([], s(p), !1));
	return f.pipe(oa(function(e) {
		return m.pipe(Qi(1), ji({
			first: 500,
			with: function() {
				return Zr;
			}
		}), X(function() {
			return e;
		}));
	})).subscribe(function(e) {
		/* istanbul ignore next */
		t?.track("[Amplitude] Element Clicked", i("click", e.closestTrackedAncestor));
	});
}
//#endregion
//#region ../../../node_modules/@amplitude/plugin-autocapture-browser/lib/esm/autocapture-plugin.js
var Ra;
(function(e) {
	e.ClickObservable = "clickObservable", e.ChangeObservable = "changeObservable", e.NavigateObservable = "navigateObservable", e.MutationObservable = "mutationObservable";
})(Ra ||= {});
function za(e) {
	return e.type === "click" || e.type === "change";
}
var Ba = function(e) {
	e === void 0 && (e = {});
	var t = e.dataAttributePrefix, r = t === void 0 ? Xe : t, l = e.visualTaggingOptions, u = l === void 0 ? {
		enabled: !0,
		messenger: new Ca()
	} : l;
	e.cssSelectorAllowlist = e.cssSelectorAllowlist ?? Ye, e.actionClickAllowlist = e.actionClickAllowlist ?? Ze, e.debounceTime = e.debounceTime ?? 0;
	var d = Vn, f = "enrichment", p = [], m = function() {
		var e, t = Z(document, "click", { capture: !0 }).pipe(X(function(e) {
			return g(e, "click");
		}), ia()), n = Z(document, "change", { capture: !0 }).pipe(X(function(e) {
			return g(e, "change");
		}), ia()), r;
		/* istanbul ignore next */
		window.navigation && (r = Z(window.navigation, "navigate").pipe(X(function(e) {
			return g(e, "navigate");
		}), ia()));
		var i = new G(function(e) {
			var t = new MutationObserver(function(t) {
				e.next(t);
			});
			return t.observe(document.body, {
				childList: !0,
				attributes: !0,
				characterData: !0,
				subtree: !0
			}), function() {
				return t.disconnect();
			};
		}).pipe(X(function(e) {
			return g(e, "mutation");
		}), ia());
		return e = {}, e[Ra.ClickObservable] = t, e[Ra.ChangeObservable] = n, e[Ra.NavigateObservable] = r, e[Ra.MutationObservable] = i, e;
	}, h = function(e, t) {
		var n, i, a = ((i = t?.tagName)?.toLowerCase)?.call(i), o = typeof t.getBoundingClientRect == "function" ? t.getBoundingClientRect() : {
			left: null,
			top: null
		}, s = t.getAttribute("aria-label"), c = ma(t, r), l = _a(t), u = (n = {}, n[Un] = t.getAttribute("id") || "", n[Wn] = t.getAttribute("class"), n[qn] = Ma(t), n[Gn] = a, n[Kn] = fa(t), n[Yn] = o.left == null ? null : Math.round(o.left), n[Xn] = o.top == null ? null : Math.round(o.top), n[Zn] = s, n[Qn] = c, n[$n] = l, n[er] = window.location.href.split("?")[0], n[tr] = typeof document < "u" && document.title || "", n[nr] = window.innerHeight, n[rr] = window.innerWidth, n);
		return a === "a" && e === "click" && t instanceof HTMLAnchorElement && (u[Jn] = t.href), ga(u);
	}, g = function(t, n) {
		var r = {
			event: t,
			timestamp: Date.now(),
			type: n
		};
		if (za(r) && r.event.target !== null) {
			var i = va(r.event.target, e.cssSelectorAllowlist);
			return i && (r.closestTrackedAncestor = i, r.targetElementProperties = h(r.type, i)), r;
		}
		return r;
	};
	return {
		name: d,
		type: f,
		setup: function(t, r) {
			return i(void 0, void 0, void 0, function() {
				var i, o, l, f, g, _, v, y, b, x;
				return a(this, function(a) {
					return typeof document > "u" ? [2] : (i = ca(e, e.cssSelectorAllowlist), o = ca(e, e.actionClickAllowlist), l = m(), f = Fa({
						allObservables: l,
						options: e,
						amplitude: r,
						shouldTrackEvent: i
					}), p.push(f), g = Ia({
						allObservables: l,
						getEventProperties: h,
						amplitude: r,
						shouldTrackEvent: i
					}), p.push(g), _ = La({
						allObservables: l,
						options: e,
						getEventProperties: h,
						amplitude: r,
						shouldTrackEvent: i,
						shouldTrackActionClick: o
					}), p.push(_), (b = t?.loggerProvider) == null || b.log(`${d} has been successfully added.`), window.opener && u.enabled && (v = e.cssSelectorAllowlist, y = e.actionClickAllowlist, (x = u.messenger) == null || x.setup(n(n({ logger: t?.loggerProvider }, t?.serverZone && { endpoint: ar[t.serverZone] }), {
						isElementSelectable: ca(e, c(c([], s(v), !1), s(y), !1)),
						cssSelectorAllowlist: v,
						actionClickAllowlist: y
					}))), [2]);
				});
			});
		},
		execute: function(e) {
			return i(void 0, void 0, void 0, function() {
				return a(this, function(t) {
					return [2, e];
				});
			});
		},
		teardown: function() {
			return i(void 0, void 0, void 0, function() {
				var e, t, n, r, i;
				return a(this, function(a) {
					try {
						for (e = o(p), t = e.next(); !t.done; t = e.next()) n = t.value, n.unsubscribe();
					} catch (e) {
						r = { error: e };
					} finally {
						try {
							t && !t.done && (i = e.return) && i.call(e);
						} finally {
							if (r) throw r.error;
						}
					}
					return [2];
				});
			});
		}
	};
}, Va = "utm_campaign", Ha = "utm_content", Ua = "utm_id", Wa = "utm_medium", Ga = "utm_source", Ka = "utm_term", qa = "dclid", Ja = "fbclid", Ya = "gbraid", Xa = "gclid", Za = "ko_click_id", Qa = "li_fat_id", $a = "msclkid", eo = "rtd_cid", to = "ttclid", no = "twclid", ro = "wbraid", io = {
	utm_campaign: void 0,
	utm_content: void 0,
	utm_id: void 0,
	utm_medium: void 0,
	utm_source: void 0,
	utm_term: void 0,
	referrer: void 0,
	referring_domain: void 0,
	dclid: void 0,
	gbraid: void 0,
	gclid: void 0,
	fbclid: void 0,
	ko_click_id: void 0,
	li_fat_id: void 0,
	msclkid: void 0,
	rtd_cid: void 0,
	ttclid: void 0,
	twclid: void 0,
	wbraid: void 0
}, ao = function(e) {
	var t = e.split(".");
	return t.length <= 2 ? e : t.slice(t.length - 2, t.length).join(".");
}, oo = function(e) {
	return Object.values(e).every(function(e) {
		return !e;
	});
}, so = function(e, t, n, i, a) {
	a === void 0 && (a = !0), e.referrer;
	var o = e.referring_domain, s = r(e, ["referrer", "referring_domain"]), c = t || {};
	c.referrer;
	var l = c.referring_domain, u = r(c, ["referrer", "referring_domain"]);
	if (co(n.excludeReferrers, e.referring_domain)) return i.debug(`This is not a new campaign because ${e.referring_domain} is in the exclude referrer list.`), !1;
	if (!a && oo(e) && t) return i.debug("This is not a new campaign because this is a direct traffic in the same session."), !1;
	var d = JSON.stringify(s) !== JSON.stringify(u), f = ao(o || "") !== ao(l || ""), p = !t || d || f;
	return p ? i.debug("This is a new campaign. An $identify event will be sent.") : i.debug("This is not a new campaign because it's the same as the previous one."), p;
}, co = function(e, t) {
	return e === void 0 && (e = []), t === void 0 && (t = ""), e.some(function(e) {
		return e instanceof RegExp ? e.test(t) : e === t;
	});
}, lo = function(e, t) {
	var r = n(n({}, io), e);
	return j(Object.entries(r).reduce(function(e, n) {
		var r = s(n, 2), i = r[0], a = r[1];
		return e.setOnce(`initial_${i}`, a ?? t.initialEmptyValue ?? "EMPTY"), a ? e.set(i, a) : e.unset(i);
	}, new O()));
}, uo = function(e) {
	var t = e;
	return t ? (t.startsWith(".") && (t = t.substring(1)), [RegExp(`${t.replace(".", "\\.")}\$`)]) : [];
}, fo = function() {
	function e() {}
	return e.prototype.parse = function() {
		return i(this, void 0, void 0, function() {
			return a(this, function(e) {
				return [2, n(n(n(n({}, io), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
			});
		});
	}, e.prototype.getUtmParam = function() {
		var e = Re();
		return {
			utm_campaign: e[Va],
			utm_content: e[Ha],
			utm_id: e[Ua],
			utm_medium: e[Wa],
			utm_source: e[Ga],
			utm_term: e[Ka]
		};
	}, e.prototype.getReferrer = function() {
		var e = {
			referrer: void 0,
			referring_domain: void 0
		};
		try {
			e.referrer = document.referrer || void 0, e.referring_domain = e.referrer?.split("/")[2] ?? void 0;
		} catch {}
		return e;
	}, e.prototype.getClickIds = function() {
		var e, t = Re();
		return e = {}, e[qa] = t[qa], e[Ja] = t[Ja], e[Ya] = t[Ya], e[Xa] = t[Xa], e[Za] = t[Za], e[Qa] = t[Qa], e[$a] = t[$a], e[eo] = t[eo], e[to] = t[to], e[no] = t[no], e[ro] = t[ro], e;
	}, e;
}(), po = function() {
	function e(e, t) {
		this.shouldTrackNewCampaign = !1, this.options = n({
			initialEmptyValue: "EMPTY",
			resetSessionOnNewCampaign: !1,
			excludeReferrers: uo(t.cookieOptions?.domain)
		}, e), this.storage = t.cookieStorage, this.storageKey = Ke(t.apiKey, "MKTG"), this.currentCampaign = io, this.sessionTimeout = t.sessionTimeout, this.lastEventTime = t.lastEventTime, this.logger = t.loggerProvider, t.loggerProvider.log("Installing web attribution tracking.");
	}
	return e.prototype.init = function() {
		return i(this, void 0, void 0, function() {
			var e, t;
			return a(this, function(n) {
				switch (n.label) {
					case 0: return [4, this.fetchCampaign()];
					case 1: return t = s.apply(void 0, [n.sent(), 2]), this.currentCampaign = t[0], this.previousCampaign = t[1], e = !this.lastEventTime || Pe(this.sessionTimeout, this.lastEventTime), so(this.currentCampaign, this.previousCampaign, this.options, this.logger, e) ? (this.shouldTrackNewCampaign = !0, [4, this.storage.set(this.storageKey, this.currentCampaign)]) : [3, 3];
					case 2: n.sent(), n.label = 3;
					case 3: return [2];
				}
			});
		});
	}, e.prototype.fetchCampaign = function() {
		return i(this, void 0, void 0, function() {
			return a(this, function(e) {
				switch (e.label) {
					case 0: return [4, Promise.all([new fo().parse(), this.storage.get(this.storageKey)])];
					case 1: return [2, e.sent()];
				}
			});
		});
	}, e.prototype.generateCampaignEvent = function(e) {
		this.shouldTrackNewCampaign = !1;
		var t = lo(this.currentCampaign, this.options);
		return e && (t.event_id = e), t;
	}, e.prototype.shouldSetSessionIdOnNewCampaign = function() {
		return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
	}, e;
}(), mo = function(e) {
	t(r, e);
	function r() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return r.prototype.init = function(e, t, r) {
		e === void 0 && (e = "");
		var i, a;
		return arguments.length > 2 ? (i = t, a = r) : typeof t == "string" ? (i = t, a = void 0) : (i = t?.userId, a = t), M(this._init(n(n({}, a), {
			userId: i,
			apiKey: e
		})));
	}, r.prototype._init = function(t) {
		return i(this, void 0, void 0, function() {
			var n, r, i, o, s, c, l = this;
			return a(this, function(a) {
				switch (a.label) {
					case 0: return this.initializing ? [2] : (this.initializing = !0, [4, zt(t.apiKey, t, this)]);
					case 1: return n = a.sent(), t.fetchRemoteConfig ? [4, Bn(n)] : [3, 4];
					case 2: return r = a.sent(), [4, r.generateJoinedConfig()];
					case 3: n = a.sent(), a.label = 4;
					case 4: return [4, e.prototype._init.call(this, n)];
					case 5: return a.sent(), this.logBrowserOptions(n), $e(this.config.defaultTracking) ? (i = st(this.config), this.webAttribution = new po(i, this.config), [4, this.webAttribution.init()]) : [3, 7];
					case 6: a.sent(), a.label = 7;
					case 7: return o = Re(), s = Number.isNaN(Number(o.ampSessionId)) ? void 0 : Number(o.ampSessionId), this.setSessionId(t.sessionId ?? s ?? this.config.sessionId ?? Date.now()), c = Ae(t.instanceName), c.identityStore.setIdentity({
						userId: this.config.userId,
						deviceId: this.config.deviceId
					}), this.config.offline === null ? [3, 9] : [4, this.add(On()).promise];
					case 8: a.sent(), a.label = 9;
					case 9: return [4, this.add(new ye()).promise];
					case 10: return a.sent(), [4, this.add(new mt()).promise];
					case 11: return a.sent(), [4, this.add(new Ne()).promise];
					case 12: return a.sent(), Dn(this.config), et(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding file download tracking plugin"), [4, this.add(Tn()).promise]) : [3, 14];
					case 13: a.sent(), a.label = 14;
					case 14: return tt(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding form interaction plugin"), [4, this.add(Cn()).promise]) : [3, 16];
					case 15: a.sent(), a.label = 16;
					case 16: return nt(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding page view tracking plugin"), [4, this.add(yn(ot(this.config))).promise]) : [3, 18];
					case 17: a.sent(), a.label = 18;
					case 18: return it(this.config.autocapture) ? (this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)"), [4, this.add(Ba(at(this.config))).promise]) : [3, 20];
					case 19: a.sent(), a.label = 20;
					case 20: return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
					case 21: return a.sent(), c.eventBridge.setEventReceiver(function(e) {
						l.track(e.eventType, e.eventProperties);
					}), [2];
				}
			});
		});
	}, r.prototype.getUserId = function() {
		return this.config?.userId;
	}, r.prototype.setUserId = function(e) {
		if (!this.config) {
			this.q.push(this.setUserId.bind(this, e));
			return;
		}
		this.config.loggerProvider.debug("function setUserId: ", e), (e !== this.config.userId || e === void 0) && (this.config.userId = e, je(e, this.config.instanceName));
	}, r.prototype.getDeviceId = function() {
		return this.config?.deviceId;
	}, r.prototype.setDeviceId = function(e) {
		if (!this.config) {
			this.q.push(this.setDeviceId.bind(this, e));
			return;
		}
		this.config.loggerProvider.debug("function setDeviceId: ", e), this.config.deviceId = e, Me(e, this.config.instanceName);
	}, r.prototype.reset = function() {
		this.setDeviceId(b()), this.setUserId(void 0);
	}, r.prototype.getSessionId = function() {
		return this.config?.sessionId;
	}, r.prototype.setSessionId = function(e) {
		var t = [];
		if (!this.config) return this.q.push(this.setSessionId.bind(this, e)), M(Promise.resolve());
		if (e === this.config.sessionId) return M(Promise.resolve());
		this.config.loggerProvider.debug("function setSessionId: ", e);
		var n = this.getSessionId(), r = this.config.lastEventTime, i = this.config.lastEventId ?? -1;
		this.config.sessionId = e, this.config.lastEventTime = void 0, this.config.pageCounter = 0, rt(this.config.defaultTracking) && (n && r && t.push(this.track(Ot, void 0, {
			device_id: this.previousSessionDeviceId,
			event_id: ++i,
			session_id: n,
			time: r + 1,
			user_id: this.previousSessionUserId
		}).promise), this.config.lastEventTime = this.config.sessionId);
		var a = this.trackCampaignEventIfNeeded(++i, t);
		return rt(this.config.defaultTracking) && t.push(this.track(Dt, void 0, {
			event_id: a ? ++i : i,
			session_id: this.config.sessionId,
			time: this.config.lastEventTime
		}).promise), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId, M(Promise.all(t));
	}, r.prototype.extendSession = function() {
		if (!this.config) {
			this.q.push(this.extendSession.bind(this));
			return;
		}
		this.config.lastEventTime = Date.now();
	}, r.prototype.setTransport = function(e) {
		if (!this.config) {
			this.q.push(this.setTransport.bind(this, e));
			return;
		}
		this.config.transportProvider = Vt(e);
	}, r.prototype.identify = function(t, n) {
		if (lt(t)) {
			var r = t._q;
			t._q = [], t = ct(new O(), r);
		}
		return n?.user_id && this.setUserId(n.user_id), n?.device_id && this.setDeviceId(n.device_id), e.prototype.identify.call(this, t, n);
	}, r.prototype.groupIdentify = function(t, n, r, i) {
		if (lt(r)) {
			var a = r._q;
			r._q = [], r = ct(new O(), a);
		}
		return e.prototype.groupIdentify.call(this, t, n, r, i);
	}, r.prototype.revenue = function(t, n) {
		if (lt(t)) {
			var r = t._q;
			t._q = [], t = ct(new ce(), r);
		}
		return e.prototype.revenue.call(this, t, n);
	}, r.prototype.trackCampaignEventIfNeeded = function(e, t) {
		if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) return !1;
		var n = this.webAttribution.generateCampaignEvent(e);
		return t ? t.push(this.track(n).promise) : this.track(n), this.config.loggerProvider.log("Tracking attribution."), !0;
	}, r.prototype.process = function(t) {
		return i(this, void 0, void 0, function() {
			var n, r, i;
			return a(this, function(a) {
				return n = Date.now(), r = Pe(this.config.sessionTimeout, this.config.lastEventTime), i = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign(), t.event_type !== "session_start" && t.event_type !== "session_end" && (!t.session_id || t.session_id === this.getSessionId()) && (r || i ? (this.setSessionId(n), i && this.config.loggerProvider.log("Created a new session for new campaign.")) : r || this.trackCampaignEventIfNeeded()), [2, e.prototype.process.call(this, t)];
			});
		});
	}, r.prototype.logBrowserOptions = function(e) {
		try {
			var t = n(n({}, e), { apiKey: e.apiKey.substring(0, 10) + "********" });
			this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(t));
		} catch (e) {
			/* istanbul ignore next */
			this.config.loggerProvider.error("Error logging browser config", e);
		}
	}, r;
}(se), ho = function() {
	var e = new mo();
	return {
		init: z(e.init.bind(e), "init", L(e), R(e, ["config"])),
		add: z(e.add.bind(e), "add", L(e), R(e, ["config.apiKey", "timeline.plugins"])),
		remove: z(e.remove.bind(e), "remove", L(e), R(e, ["config.apiKey", "timeline.plugins"])),
		track: z(e.track.bind(e), "track", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		logEvent: z(e.logEvent.bind(e), "logEvent", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		identify: z(e.identify.bind(e), "identify", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		groupIdentify: z(e.groupIdentify.bind(e), "groupIdentify", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		setGroup: z(e.setGroup.bind(e), "setGroup", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		revenue: z(e.revenue.bind(e), "revenue", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		flush: z(e.flush.bind(e), "flush", L(e), R(e, ["config.apiKey", "timeline.queue.length"])),
		getUserId: z(e.getUserId.bind(e), "getUserId", L(e), R(e, ["config", "config.userId"])),
		setUserId: z(e.setUserId.bind(e), "setUserId", L(e), R(e, ["config", "config.userId"])),
		getDeviceId: z(e.getDeviceId.bind(e), "getDeviceId", L(e), R(e, ["config", "config.deviceId"])),
		setDeviceId: z(e.setDeviceId.bind(e), "setDeviceId", L(e), R(e, ["config", "config.deviceId"])),
		reset: z(e.reset.bind(e), "reset", L(e), R(e, [
			"config",
			"config.userId",
			"config.deviceId"
		])),
		getSessionId: z(e.getSessionId.bind(e), "getSessionId", L(e), R(e, ["config"])),
		setSessionId: z(e.setSessionId.bind(e), "setSessionId", L(e), R(e, ["config"])),
		extendSession: z(e.extendSession.bind(e), "extendSession", L(e), R(e, ["config"])),
		setOptOut: z(e.setOptOut.bind(e), "setOptOut", L(e), R(e, ["config"])),
		setTransport: z(e.setTransport.bind(e), "setTransport", L(e), R(e, ["config"]))
	};
}, $ = ho();
$.add, $.extendSession, $.flush, $.getDeviceId, $.getSessionId, $.getUserId, $.groupIdentify, $.identify, $.init, $.logEvent, $.remove, $.reset, $.revenue, $.setDeviceId, $.setGroup, $.setOptOut, $.setSessionId, $.setTransport, $.setUserId, $.track;
var go;
(function(e) {
	e.IdentifyOperation = ne, e.SpecialEventType = A, e.RevenueProperty = N, e.LogLevel = P, e.OfflineDisabled = null, e.DEFAULT_CSS_SELECTOR_ALLOWLIST = Ye, e.DEFAULT_DATA_ATTRIBUTE_PREFIX = Xe, e.DEFAULT_ACTION_CLICK_ALLOWLIST = Ze;
})(go ||= {});
//#endregion
//#region src/generated/index.ts
var _o = {
	prod: "9697cc8538da787c61338c2f38936f4e",
	stag: "44832403362971771e3b4df598b6c3f2"
}, vo = {
	plan: {
		version: "124",
		branch: "main",
		source: "agent-interface",
		versionId: "5f4810e2-9ca0-4091-a4fa-5985057f0d9c"
	},
	ingestionMetadata: {
		sourceName: "browser-typescript-ampli",
		sourceVersion: "2.0.0"
	}
}, yo = class {
	event_properties;
	event_type = go.SpecialEventType.IDENTIFY;
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, bo = class {
	event_properties;
	event_type = "Add Agents Modal Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, xo = class {
	event_type = "Agent Copilot Back Button Clicked";
}, So = class {
	event_type = "Agent Copilot Conversation Custom Attribute Suggestion Accepted";
}, Co = class {
	event_properties;
	event_type = "Agent Copilot Conversation Tag Suggestion Accepted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wo = class {
	event_properties;
	event_type = "Agent Copilot Dropdown Item Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, To = class {
	event_properties;
	event_type = "Agent Copilot Improve Writing Improvement Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Eo = class {
	event_properties;
	event_type = "Agent Copilot Text Insert Below Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Do = class {
	event_properties;
	event_type = "Agent Copilot Text Replace Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Oo = class {
	event_properties;
	event_type = "Agent Copilot Translate Message Language Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ko = class {
	event_properties;
	event_type = "Agent Copilot Trial Learn More Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ao = class {
	event_type = "Agent Copilot Trial Leftmenu CTA Clicked";
}, jo = class {
	event_type = "Agent Copilot Trial Leftmenu CTA Dismissed";
}, Mo = class {
	event_type = "Agent Copilot Trial Request Contact Clicked";
}, No = class {
	event_type = "Agent Copilot Trial Started";
}, Po = class {
	event_type = "Agent Copilot Trial Stopped";
}, Fo = class {
	event_type = "Agent Copilot Undo Clicked";
}, Io = class {
	event_properties;
	event_type = "Agent Custom Away Status Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lo = class {
	event_properties;
	event_type = "Analytics Business Hours Schedule Removed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ro = class {
	event_properties;
	event_type = "Analytics Business Hours Schedule Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zo = class {
	event_properties;
	event_type = "Analytics Chart Format Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bo = class {
	event_properties;
	event_type = "Analytics Chart Granularity Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vo = class {
	event_properties;
	event_type = "Analytics Chart Visualization Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ho = class {
	event_properties;
	event_type = "Analytics Compare Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Uo = class {
	event_properties;
	event_type = "Analytics Compare Context Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wo = class {
	event_properties;
	event_type = "Analytics Compare Period Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Go = class {
	event_properties;
	event_type = "Analytics Context Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ko = class {
	event_properties;
	event_type = "Analytics Conversation Link Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qo = class {
	event_properties;
	event_type = "Analytics Conversation Preview Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jo = class {
	event_properties;
	event_type = "Analytics Dashboard Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yo = class {
	event_properties;
	event_type = "Analytics Export Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xo = class {
	event_properties;
	event_type = "Analytics Export Download Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zo = class {
	event_properties;
	event_type = "Analytics Export My Data Button Pressed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qo = class {
	event_properties;
	event_type = "Analytics Filter Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, $o = class {
	event_properties;
	event_type = "Analytics Filter Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, es = class {
	event_properties;
	event_type = "Analytics Filter Operator Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ts = class {
	event_properties;
	event_type = "Analytics Filter Value Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ns = class {
	event_properties;
	event_type = "Analytics Filters Applied";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rs = class {
	event_properties;
	event_type = "Analytics Filters Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, is = class {
	event_properties;
	event_type = "Analytics Helper Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, as = class {
	event_properties;
	event_type = "Analytics In Depth Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, os = class {
	event_properties;
	event_type = "Analytics Insights Copy Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ss = class {
	event_properties;
	event_type = "Analytics Insights Feedback Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cs = class {
	event_properties;
	event_type = "Analytics Insights Prompt Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ls = class {
	event_properties;
	event_type = "Analytics Insights Regenerate Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, us = class {
	event_properties;
	event_type = "Analytics Panel Controls Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ds = class {
	event_properties;
	event_type = "Analytics Period Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, fs = class {
	event_properties;
	event_type = "Analytics Pin Panel Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ps = class {
	event_properties;
	event_type = "Analytics Pin Panel Quick View Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ms = class {
	event_properties;
	event_type = "Analytics Quick View Auto Refresh Disabled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, hs = class {
	event_properties;
	event_type = "Analytics Quick View Auto Refresh Enabled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, gs = class {
	event_properties;
	event_type = "Analytics Quick View Auto Refresh Triggered";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, _s = class {
	event_properties;
	event_type = "Analytics Quick View Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, vs = class {
	event_properties;
	event_type = "Analytics Quick View Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ys = class {
	event_properties;
	event_type = "Analytics Quick View Duplicated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, bs = class {
	event_properties;
	event_type = "Analytics Quick View Favorite Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, xs = class {
	event_properties;
	event_type = "Analytics Quick View Landing Page Set";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ss = class {
	event_properties;
	event_type = "Analytics Quick View Landing Page Unset";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Cs = class {
	event_type = "Analytics Quick View Ownership Transferred";
}, ws = class {
	event_properties;
	event_type = "Analytics Quick View Panel Controls Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ts = class {
	event_properties;
	event_type = "Analytics Quick View Panel Description Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Es = class {
	event_properties;
	event_type = "Analytics Quick View Panel Pinned";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ds = class {
	event_properties;
	event_type = "Analytics Quick View Panel Unpinned";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Os = class {
	event_properties;
	event_type = "Analytics Quick View Panels Layout Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ks = class {
	event_properties;
	event_type = "Analytics Quick View Panels Reset";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, As = class {
	event_properties;
	event_type = "Analytics Quick View Panels Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, js = class {
	event_properties;
	event_type = "Analytics Quick View Sharing Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ms = class {
	event_properties;
	event_type = "Analytics Quick View Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ns = class {
	event_properties;
	event_type = "Analytics Quick View Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ps = class {
	event_properties;
	event_type = "Analytics Refresh Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fs = class {
	event_properties;
	event_type = "Analytics Table Load All Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Is = class {
	event_properties;
	event_type = "Analytics Table Sort Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ls = class {
	event_properties;
	event_type = "Analytics Timezone Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Rs = class {
	event_properties;
	event_type = "Analytics View Conversations Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zs = class {
	event_properties;
	event_type = "Auth Failed Init";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bs = class {
	event_properties;
	event_type = "Automations Form Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vs = class {
	event_properties;
	event_type = "Automations Form Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hs = class {
	event_properties;
	event_type = "Automations Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Us = class {
	event_type = "Automations Options Menu Opened";
}, Ws = class {
	event_type = "Automations Options Menu Option Delete Clicked";
}, Gs = class {
	event_type = "Automations Options Menu Option Duplicate Clicked";
}, Ks = class {
	event_type = "Automations Options Menu Option Flow Clicked";
}, qs = class {
	event_type = "Automations Options Menu Option Settings Clicked";
}, Js = class {
	event_type = "Automations Pagination Next Clicked";
}, Ys = class {
	event_type = "Automations Pagination Previous Clicked";
}, Xs = class {
	event_type = "Automations Search Applied";
}, Zs = class {
	event_type = "Automations Search Closed";
}, Qs = class {
	event_type = "Automations Search Opened";
}, $s = class {
	event_type = "Automations Toggled Off";
}, ec = class {
	event_type = "Automations Toggled On";
}, tc = class {
	event_properties;
	event_type = "Bans Ban User Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nc = class {
	event_type = "Bans Unban Ip Clicked";
}, rc = class {
	event_properties;
	event_type = "Bans Unban User Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ic = class {
	event_properties;
	event_type = "Bulk Actions Update Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ac = class {
	event_properties;
	event_type = "Business Hours Add Schedule Audio Message Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, oc = class {
	event_type = "Business Hours Add Schedule Button Clicked";
}, sc = class {
	event_properties;
	event_type = "Business Hours Add Schedule Form Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cc = class {
	event_properties;
	event_type = "Business Hours Add Schedule Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lc = class {
	event_type = "Business Hours Conflict Notification Button Clicked";
}, uc = class {
	event_type = "Business Hours Conflict Notification Closed";
}, dc = class {
	event_type = "Business Hours Delete Schedule Form Cancelled";
}, fc = class {
	event_type = "Business Hours Delete Schedule Form Submitted";
}, pc = class {
	event_type = "Business Hours Duplicate Schedule Form Cancelled";
}, mc = class {
	event_type = "Business Hours Duplicate Schedule Form Submitted";
}, hc = class {
	event_properties;
	event_type = "Business Hours First Schedule Modal Question Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, gc = class {
	event_type = "Business Hours First Schedule Support Article Clicked";
}, _c = class {
	event_type = "Business Hours Go To Flow Clicked";
}, vc = class {
	event_properties;
	event_type = "Business Hours Migration Wizard Audio Message Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, yc = class {
	event_type = "Business Hours Migration Wizard Create New Schedule Button Clicked";
}, bc = class {
	event_type = "Business Hours Migration Wizard Edit Hours Button Clicked";
}, xc = class {
	event_properties;
	event_type = "Business Hours Migration Wizard Form Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Sc = class {
	event_properties;
	event_type = "Business Hours Migration Wizard Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Cc = class {
	event_type = "Business Hours Migration Wizard Opening Hours Form Cancelled";
}, wc = class {
	event_type = "Business Hours Migration Wizard Opening Hours Form Submitted";
}, Tc = class {
	event_type = "Business Hours Migration Wizard Start Update Button Clicked";
}, Ec = class {
	event_type = "Business Hours Options Menu Opened";
}, Dc = class {
	event_type = "Business Hours Options Menu Option Delete Clicked";
}, Oc = class {
	event_type = "Business Hours Options Menu Option Duplicate Clicked";
}, kc = class {
	event_type = "Business Hours Options Menu Option Edit Clicked";
}, Ac = class {
	event_type = "Business Hours Options Menu Option Rename Clicked";
}, jc = class {
	event_type = "Business Hours Rename Schedule Form Cancelled";
}, Mc = class {
	event_properties;
	event_type = "Business Hours Rename Schedule Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nc = class {
	event_type = "Business Hours Schedule Add Exception Button Clicked";
}, Pc = class {
	event_type = "Business Hours Schedule Add Exception Form Cancelled";
}, Fc = class {
	event_type = "Business Hours Schedule Add Exception Form Submitted";
}, Ic = class {
	event_properties;
	event_type = "Business Hours Schedule Audio Message Form Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lc = class {
	event_properties;
	event_type = "Business Hours Schedule Audio Message Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Rc = class {
	event_properties;
	event_type = "Business Hours Schedule Audio Message Options Menu Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zc = class {
	event_properties;
	event_type = "Business Hours Schedule Audio Message Options Menu Option Clear Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bc = class {
	event_properties;
	event_type = "Business Hours Schedule Audio Message Options Menu Option Record Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vc = class {
	event_properties;
	event_type = "Business Hours Schedule Audio Message Options Menu Option Upload Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hc = class {
	event_properties;
	event_type = "Business Hours Schedule Auto Reply Options Menu Option Clear Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Uc = class {
	event_type = "Business Hours Schedule Conflict Change Button Clicked";
}, Wc = class {
	event_type = "Business Hours Schedule Conflict Review Button Clicked";
}, Gc = class {
	event_type = "Business Hours Schedule Delete Exception Form Cancelled";
}, Kc = class {
	event_type = "Business Hours Schedule Delete Exception Form Submitted";
}, qc = class {
	event_properties;
	event_type = "Business Hours Schedule Exception Options Menu Option Delete Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jc = class {
	event_type = "Business Hours Schedule Import Holiday Form Cancelled";
}, Yc = class {
	event_properties;
	event_type = "Business Hours Schedule Import Holiday Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xc = class {
	event_type = "Business Hours Schedule Options Menu Import Holidays Clicked";
}, Zc = class {
	event_type = "Business Hours Schedule Options Menu Opened";
}, Qc = class {
	event_type = "Business Hours Schedule Options Menu Recover Holidays Clicked";
}, $c = class {
	event_type = "Business Hours Schedule Options Menu Rename Clicked";
}, el = class {
	event_type = "Business Hours Schedule Options Menu Timezone Clicked";
}, tl = class {
	event_properties;
	event_type = "Business Hours Schedule Preview Button Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nl = class {
	event_type = "Business Hours Schedule Recover Holidays Form Cancelled";
}, rl = class {
	event_type = "Business Hours Schedule Recover Holidays Form Submitted";
}, il = class {
	event_type = "Business Hours Schedule Review Form Cancelled";
}, al = class {
	event_type = "Business Hours Schedule Review Form Submitted";
}, ol = class {
	event_type = "Business Hours Schedule Save Schedule Button Clicked";
}, sl = class {
	event_properties;
	event_type = "Business Hours Schedule Tab Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cl = class {
	event_properties;
	event_type = "Business Hours Schedule View Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ll = class {
	event_type = "Chat Flow Options Menu Option Audit Log Clicked";
}, ul = class {
	event_properties;
	event_type = "Chat Form Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, dl = class {
	event_properties;
	event_type = "Chat Form Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, fl = class {
	event_properties;
	event_type = "Chat Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pl = class {
	event_type = "Chat Options Menu Opened";
}, ml = class {
	event_type = "Chat Options Menu Option Delete Clicked";
}, hl = class {
	event_type = "Chat Options Menu Option Duplicate Clicked";
}, gl = class {
	event_type = "Chat Options Menu Option Flow Clicked";
}, _l = class {
	event_type = "Chat Options Menu Option Rename Clicked";
}, vl = class {
	event_type = "Chat Options Menu Option Setup Clicked";
}, yl = class {
	event_type = "Chat Pagination Next Clicked";
}, bl = class {
	event_type = "Chat Pagination Previous Clicked";
}, xl = class {
	event_type = "Chat Search Applied";
}, Sl = class {
	event_type = "Chat Search Closed";
}, Cl = class {
	event_type = "Chat Search Opened";
}, wl = class {
	event_type = "Chatbot Create Modal Opened";
}, Tl = class {
	event_properties;
	event_type = "Chatbot Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, El = class {
	event_type = "Chatbot Delete Modal Opened";
}, Dl = class {
	event_properties;
	event_type = "Chatbot Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ol = class {
	event_type = "Chatbot Edit Identity Modal Opened";
}, kl = class {
	event_type = "Chatbot Identity Edited";
}, Al = class {
	event_properties;
	event_type = "Color Mode Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jl = class {
	event_properties;
	event_type = "Command Executed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ml = class {
	event_properties;
	event_type = "Command Palette Action Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nl = class {
	event_properties;
	event_type = "Command Palette Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Pl = class {
	event_properties;
	event_type = "Command Palette Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fl = class {
	event_properties;
	event_type = "Company Modal Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Il = class {
	event_type = "Contacts Add New Company Clicked";
}, Ll = class {
	event_type = "Contacts Add New Contact Clicked";
}, Rl = class {
	event_properties;
	event_type = "Contacts Ban User Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zl = class {
	event_type = "Contacts Card Actions Menu Opened";
}, Bl = class {
	event_type = "Contacts Card Compose New Email Clicked";
}, Vl = class {
	event_type = "Contacts Card Edit Company Clicked";
}, Hl = class {
	event_type = "Contacts Card Edit Contact Clicked";
}, Ul = class {
	event_type = "Contacts Card Make Call Clicked";
}, Wl = class {
	event_type = "Contacts Card See All Assigned Conversations Clicked";
}, Gl = class {
	event_type = "Contacts Card See All Conversations Clicked";
}, Kl = class {
	event_type = "Contacts Card View Company Clicked";
}, ql = class {
	event_type = "Contacts Card View User Clicked";
}, Jl = class {
	event_type = "Contacts Search Blurred";
}, Yl = class {
	event_type = "Contacts Search Focused";
}, Xl = class {
	event_properties;
	event_type = "Contacts Unban User Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zl = class {
	event_type = "Contacts View Companies";
}, Ql = class {
	event_type = "Contacts View End Users";
}, $l = class {
	event_type = "Conversation Actions Menu Opened";
}, eu = class {
	event_properties;
	event_type = "Conversation Actions Menu Option Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tu = class {
	event_type = "Conversation Activity Log Closed";
}, nu = class {
	event_type = "Conversation Activity Log Flooter Expanded";
}, ru = class {
	event_properties;
	event_type = "Conversation Activity Log Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, iu = class {
	event_properties;
	event_type = "Conversation Article Draft Improvement Requested";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, au = class {
	event_properties;
	event_type = "Conversation Article Draft Improvement Response Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ou = class {
	event_properties;
	event_type = "Conversation Article Draft Preview Requested";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, su = class {
	event_properties;
	event_type = "Conversation Article Draft Preview Response Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cu = class {
	event_properties;
	event_type = "Conversation Article Draft Save Requested";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lu = class {
	event_properties;
	event_type = "Conversation Article Draft Save Response Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, uu = class {
	event_type = "Conversation Attached Image Is Downloaded";
}, du = class {
	event_type = "Conversation Attached Image Is Viewed";
}, fu = class {
	event_properties;
	event_type = "Conversation Claimed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pu = class {
	event_properties;
	event_type = "Conversation Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, mu = class {
	event_type = "Conversation Csat Cancelled";
}, hu = class {
	event_type = "Conversation Csat Menu Cancel Option Clicked";
}, gu = class {
	event_properties;
	event_type = "Conversation Csat Menu Language Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, _u = class {
	event_type = "Conversation Csat Menu Opened";
}, vu = class {
	event_properties;
	event_type = "Conversation Focus Mode Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, yu = class {
	event_properties;
	event_type = "Conversation Follow Up";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, bu = class {
	event_type = "Conversation Follow Up Menu Opened";
}, xu = class {
	event_properties;
	event_type = "Conversation Follow Up Menu Option Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Su = class {
	event_type = "Conversation Header Conversation Details Menu Opened";
}, Cu = class {
	event_properties;
	event_type = "Conversation Header Tag Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wu = class {
	event_properties;
	event_type = "Conversation Header Tag Include Deactivated Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Tu = class {
	event_type = "Conversation Header Tag Menu Opened";
}, Eu = class {
	event_properties;
	event_type = "Conversation Header Tag Removed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Du = class {
	event_type = "Conversation Header Transfer To Agent Item Selected";
}, Ou = class {
	event_type = "Conversation Header Transfer To Agent Menu Opened";
}, ku = class {
	event_type = "Conversation Header Transfer To Number Button Clicked";
}, Au = class {
	event_properties;
	event_type = "Conversation Header Transfer To Queue Item Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ju = class {
	event_type = "Conversation Header Transfer To Queue Menu Opened";
}, Mu = class {
	event_type = "Conversation Internal Note Editor Opened";
}, Nu = class {
	event_type = "Conversation Message Redaction Modal Opened";
}, Pu = class {
	event_type = "Conversation Message Redaction Modal Submitted";
}, Fu = class {
	event_properties;
	event_type = "Conversation Offered";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Iu = class {
	event_properties;
	event_type = "Conversation Replied";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lu = class {
	event_properties;
	event_type = "Conversation Reply Window Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ru = class {
	event_properties;
	event_type = "Conversation Resolved As A Knowledge Article Draft";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zu = class {
	event_properties;
	event_type = "Conversation Resolved As A Knowledge Gap";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bu = class {
	event_properties;
	event_type = "Conversation Resolved By Knowledge";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vu = class {
	event_properties;
	event_type = "Conversation Resolved With No Knowledge Article";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hu = class {
	event_properties;
	event_type = "Conversation Right Sidebar Item Reordered";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Uu = class {
	event_properties;
	event_type = "Conversation Right Sidebar Item Visibility Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wu = class {
	event_type = "Conversation Sidebar Admin Configuration Saved";
}, Gu = class {
	event_type = "Conversation Sidebar Closed";
}, Ku = class {
	event_type = "Conversation Sidebar Conversation History Closed";
}, qu = class {
	event_type = "Conversation Sidebar Conversation History Navigated To Conversation";
}, Ju = class {
	event_type = "Conversation Sidebar Conversation History Opened";
}, Yu = class {
	event_type = "Conversation Sidebar Customer Info Email Clicked";
}, Xu = class {
	event_type = "Conversation Sidebar Customer Info Phone Number Clicked";
}, Zu = class {
	event_type = "Conversation Sidebar Opened";
}, Qu = class {
	event_type = "Conversation Timeline Item Opened";
}, $u = class {
	event_type = "Conversation Timeline Navigated To Conversation";
}, ed = class {
	event_properties;
	event_type = "Conversation Transferred";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, td = class {
	event_properties;
	event_type = "Conversations Bulk Actions Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nd = class {
	event_type = "Conversations Clear All Clicked";
}, rd = class {
	event_properties;
	event_type = "Conversations Filter Agent Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, id = class {
	event_type = "Conversations Filter Clear All Clicked";
}, ad = class {
	event_properties;
	event_type = "Conversations Filter Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, od = class {
	event_properties;
	event_type = "Conversations Filter Contact Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sd = class {
	event_properties;
	event_type = "Conversations Filter Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cd = class {
	event_properties;
	event_type = "Conversations Go To Conversation Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ld = class {
	event_type = "Conversations Item Preview Clicked";
}, ud = class {
	event_type = "Conversations Next Page Clicked";
}, dd = class {
	event_type = "Conversations Previous Page Clicked";
}, fd = class {
	event_type = "Conversations Select All Clicked";
}, pd = class {
	event_properties;
	event_type = "Conversations Select Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, md = class {
	event_properties;
	event_type = "Conversations Timestamp Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, hd = class {
	event_type = "Conversations Transfer To Queue Clicked";
}, gd = class {
	event_type = "Conversations View Agent Clicked";
}, _d = class {
	event_type = "Conversations View Contact Clicked";
}, vd = class {
	event_properties;
	event_type = "ConversationSummaryFeedbackNotUseful";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, yd = class {
	event_properties;
	event_type = "ConversationSummaryFeedbackUseful";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, bd = class {
	event_properties;
	event_type = "ConversationSummaryRegenerateSummary";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, xd = class {
	event_type = "Copy Script";
}, Sd = class {
	event_type = "Country Code Selected";
}, Cd = class {
	event_properties;
	event_type = "Custom Attribute Value Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wd = class {
	event_type = "Dashboard Channel All Conversations Clicked";
}, Td = class {
	event_type = "Dashboard Channel Go To Analytics Clicked";
}, Ed = class {
	event_type = "Dashboard Channel Longest Queued Time Metric Clicked";
}, Dd = class {
	event_type = "Dashboard Channel Name Clicked";
}, Od = class {
	event_properties;
	event_type = "Dashboard Channel Pending Conversations Metric Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, kd = class {
	event_type = "Dashboard Channel Tv Dashboard Clicked";
}, Ad = class {
	event_properties;
	event_type = "Dashboard Favorite Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jd = class {
	event_properties;
	event_type = "Dashboard Favorite Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Md = class {
	event_properties;
	event_type = "Dashboard Favorite Landing Page Set";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nd = class {
	event_properties;
	event_type = "Dashboard Favorite Landing Page Unset";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Pd = class {
	event_type = "Dashboard Favorite Ownership Transferred";
}, Fd = class {
	event_type = "Dashboard Favorite Queues Reordered";
}, Id = class {
	event_properties;
	event_type = "Dashboard Favorite Sharing Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ld = class {
	event_type = "Dashboard Favorite Tv Dashboard Clicked";
}, Rd = class {
	event_properties;
	event_type = "Dashboard Favorite Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zd = class {
	event_properties;
	event_type = "Dashboard Favorite Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bd = class {
	event_type = "Dashboard Global Tv Dashboard Clicked";
}, Vd = class {
	event_properties;
	event_type = "Dashboard Layout Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hd = class {
	event_properties;
	event_type = "Dashboard Longest Queued Time Metric Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ud = class {
	event_properties;
	event_type = "Dashboard Metric Helper Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wd = class {
	event_type = "Dashboard Next Page Clicked";
}, Gd = class {
	event_type = "Dashboard Organization Timezone Settings Clicked";
}, Kd = class {
	event_type = "Dashboard Previous Page Clicked";
}, qd = class {
	event_type = "Dashboard Queue All Conversations Clicked";
}, Jd = class {
	event_type = "Dashboard Queue Go To Analytics Clicked";
}, Yd = class {
	event_properties;
	event_type = "Dashboard Queue Item Favorite Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xd = class {
	event_type = "Dashboard Queue Name Clicked";
}, Zd = class {
	event_properties;
	event_type = "Dashboard Queue Pending Conversations Metric Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qd = class {
	event_type = "Dashboard Queue Settings Clicked";
}, $d = class {
	event_type = "Dashboard Queue Tv Dashboard Clicked";
}, ef = class {
	event_properties;
	event_type = "Dashboard Queues Manually Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tf = class {
	event_properties;
	event_type = "Dashboard Queues Search Field Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nf = class {
	event_properties;
	event_type = "Dashboard Queues Search Field Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rf = class {
	event_properties;
	event_type = "Dashboard Queues Sorting Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, af = class {
	event_properties;
	event_type = "Dashboard Queues Type Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, of = class {
	event_type = "Dashboard Refresh Data Clicked";
}, sf = class {
	event_properties;
	event_type = "Dashboard Tv Reloaded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cf = class {
	event_properties;
	event_type = "Dashboard Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lf = class {
	event_type = "Email Flow Options Menu Option Audit Log Clicked";
}, uf = class {
	event_properties;
	event_type = "Email Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, df = class {
	event_type = "Email Options Menu Opened";
}, ff = class {
	event_type = "Email Options Menu Option Delete Clicked";
}, pf = class {
	event_type = "Email Options Menu Option Duplicate Clicked";
}, mf = class {
	event_type = "Email Options Menu Option Email Clicked";
}, hf = class {
	event_type = "Email Options Menu Option Flow Clicked";
}, gf = class {
	event_type = "Email Options Menu Option Rename Clicked";
}, _f = class {
	event_type = "Email Search Applied";
}, vf = class {
	event_type = "Email Search Closed";
}, yf = class {
	event_type = "Email Search Opened";
}, bf = class {
	event_properties;
	event_type = "Flow Action Add Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, xf = class {
	event_properties;
	event_type = "Flow Action Condition Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Sf = class {
	event_properties;
	event_type = "Flow Action Condition Removed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Cf = class {
	event_properties;
	event_type = "Flow Action Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wf = class {
	event_properties;
	event_type = "Flow Action Edit Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Tf = class {
	event_properties;
	event_type = "Flow Action Edit Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ef = class {
	event_properties;
	event_type = "Flow Activate Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Df = class {
	event_properties;
	event_type = "Flow Add Action Action Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Of = class {
	event_properties;
	event_type = "Flow Add Action Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, kf = class {
	event_properties;
	event_type = "Flow Add Action Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Af = class {
	event_properties;
	event_type = "Flow Back To Settings Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jf = class {
	event_properties;
	event_type = "Flow Context Align Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Mf = class {
	event_properties;
	event_type = "Flow Context Delete Cancel Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nf = class {
	event_properties;
	event_type = "Flow Context Delete Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Pf = class {
	event_properties;
	event_type = "Flow Context Delete Confirm Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ff = class {
	event_properties;
	event_type = "Flow Context Node Arrange Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, If = class {
	event_type = "Flow Phone Number Changed";
}, Lf = class {
	event_properties;
	event_type = "Flow Save Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Rf = class {
	event_properties;
	event_type = "Flow Title Edit Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zf = class {
	event_properties;
	event_type = "Flow Zoom In Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bf = class {
	event_properties;
	event_type = "Flow Zoom Out Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vf = class {
	event_properties;
	event_type = "Flow Zoom Reset Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hf = class {
	event_type = "Follow Up Conversation Modal Internal Note Added";
}, Uf = class {
	event_type = "Follow Up Conversation Modal Offer In Queue Added";
}, Wf = class {
	event_properties;
	event_type = "Intelligence Dashboard Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gf = class {
	event_properties;
	event_type = "Intelligence Distribution Chart Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Kf = class {
	event_properties;
	event_type = "Intelligence Evolution Chart Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qf = class {
	event_properties;
	event_type = "Intelligence Filter Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jf = class {
	event_properties;
	event_type = "Intelligence Filter Period Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yf = class {
	event_properties;
	event_type = "Intelligence Group By Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xf = class {
	event_properties;
	event_type = "Intelligence Preset Comparison Started";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zf = class {
	event_properties;
	event_type = "Intelligence Table Customized";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qf = class {
	event_type = "Intent Detection Created";
}, $f = class {
	event_type = "Intent Detection Deleted";
}, ep = class {
	event_properties;
	event_type = "Intent Detection Flow Node Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tp = class {
	event_type = "Intent Detection Updated";
}, np = class {
	event_properties;
	event_type = "Knowledge Article Archived";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rp = class {
	event_properties;
	event_type = "Knowledge Article Changes Discarded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ip = class {
	event_properties;
	event_type = "Knowledge Article Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ap = class {
	event_properties;
	event_type = "Knowledge Article Destroyed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, op = class {
	event_properties;
	event_type = "Knowledge Article Feedback Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sp = class {
	event_properties;
	event_type = "Knowledge Article Marked As Helpful";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cp = class {
	event_properties;
	event_type = "Knowledge Article Moved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lp = class {
	event_properties;
	event_type = "Knowledge Article Published";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, up = class {
	event_properties;
	event_type = "Knowledge Article Reordered";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, dp = class {
	event_type = "Knowledge Article Restored";
}, fp = class {
	event_properties;
	event_type = "Knowledge Article Tag Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pp = class {
	event_properties;
	event_type = "Knowledge Article Tag Removed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, mp = class {
	event_properties;
	event_type = "Knowledge Article Unpublished";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, hp = class {
	event_properties;
	event_type = "Knowledge Article Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, gp = class {
	event_type = "Knowledge Article Version History Clicked";
}, _p = class {
	event_properties;
	event_type = "Knowledge Article Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, vp = class {
	event_properties;
	event_type = "Knowledge Articles Search By Term Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, yp = class {
	event_properties;
	event_type = "Knowledge Category Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, bp = class {
	event_properties;
	event_type = "Knowledge Category Destroyed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, xp = class {
	event_properties;
	event_type = "Knowledge Category Reordered";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Sp = class {
	event_properties;
	event_type = "Knowledge Category Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Cp = class {
	event_properties;
	event_type = "Knowledge Collection Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wp = class {
	event_properties;
	event_type = "Knowledge Collection Destroyed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Tp = class {
	event_properties;
	event_type = "Knowledge Collection Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ep = class {
	event_properties;
	event_type = "Knowledge Collection Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Dp = class {
	event_properties;
	event_type = "Knowledge Help Center Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Op = class {
	event_properties;
	event_type = "Knowledge Help Center Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, kp = class {
	event_properties;
	event_type = "Knowledge Help Center Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ap = class {
	event_type = "Knowledge Internal Kb Dashboard Viewed";
}, jp = class {
	event_properties;
	event_type = "Knowledge Internal Kb Search Result Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Mp = class {
	event_properties;
	event_type = "Knowledge Resolution Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Np = class {
	event_properties;
	event_type = "Knowledge Resolution Initialised";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Pp = class {
	event_properties;
	event_type = "Knowledge Retranslate Article Block Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fp = class {
	event_properties;
	event_type = "Knowledge Retranslate Article Title Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ip = class {
	event_properties;
	event_type = "Knowledge Translate Article Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lp = class {
	event_type = "Link Conversations Modal Opened";
}, Rp = class {
	event_type = "Link Conversations Submitted";
}, zp = class {
	event_type = "Mention User Notification Clicked";
}, Bp = class {
	event_type = "Mention User Selected";
}, Vp = class {
	event_type = "Merge Contacts Merge Cancelled";
}, Hp = class {
	event_type = "Merge Contacts Merge Failed";
}, Up = class {
	event_properties;
	event_type = "Merge Contacts Merge Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wp = class {
	event_type = "Merge Contacts Modal Closed";
}, Gp = class {
	event_type = "Merge Contacts Modal Opened";
}, Kp = class {
	event_type = "Merge Contacts Source Contact Selected";
}, qp = class {
	event_type = "Messenger Flow Options Menu Option Audit Log Clicked";
}, Jp = class {
	event_properties;
	event_type = "Messenger Form Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yp = class {
	event_properties;
	event_type = "Messenger Form Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xp = class {
	event_properties;
	event_type = "Messenger Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zp = class {
	event_type = "Messenger Options Menu Opened";
}, Qp = class {
	event_properties;
	event_type = "Messenger Options Menu Option Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, $p = class {
	event_type = "Modal Conversation Close Cancel Clicked";
}, em = class {
	event_properties;
	event_type = "Modal Conversation Close Confirm Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tm = class {
	event_type = "Modal Transfer To Queue Cancel Clicked";
}, nm = class {
	event_properties;
	event_type = "Modal Transfer To Queue Confirm Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rm = class {
	event_properties;
	event_type = "Network Connection Status Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, im = class {
	event_properties;
	event_type = "Notification Offer Accepted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, am = class {
	event_properties;
	event_type = "Notification Offer Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, om = class {
	event_properties;
	event_type = "Notification Offer Rejected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sm = class {
	event_type = "Notification Offer Timeout";
}, cm = class {
	event_properties;
	event_type = "Notification Transfer Offer Accepted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lm = class {
	event_properties;
	event_type = "Notification Transfer Offer Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, um = class {
	event_properties;
	event_type = "Notification Transfer Offer Rejected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, dm = class {
	event_type = "Notification Transfer Offer Timeout";
}, fm = class {
	event_properties;
	event_type = "Organizations Navigation Organization Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pm = class {
	event_type = "Partner Integrations Braze Profile Received";
}, mm = class {
	event_type = "Partner Integrations Braze Subscription Email Opt in Succeeded";
}, hm = class {
	event_type = "Partner Integrations Braze Subscription Email Unsubscribed Succeeded";
}, gm = class {
	event_properties;
	event_type = "Partner Integrations Condition Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, _m = class {
	event_type = "Partner Integrations Condition Deleted";
}, vm = class {
	event_properties;
	event_type = "Partner Integrations Condition Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ym = class {
	event_properties;
	event_type = "Partner Integrations Github Create New Issue Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, bm = class {
	event_properties;
	event_type = "Partner Integrations Github Create New Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, xm = class {
	event_properties;
	event_type = "Partner Integrations Github Create New Issue Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Sm = class {
	event_properties;
	event_type = "Partner Integrations Github Link Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Cm = class {
	event_properties;
	event_type = "Partner Integrations Github Unlink All Issues Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wm = class {
	event_properties;
	event_type = "Partner Integrations Github Unlink All Issues Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Tm = class {
	event_properties;
	event_type = "Partner Integrations Github Unlink All Issues Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Em = class {
	event_properties;
	event_type = "Partner Integrations Github Unlink Issue Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Dm = class {
	event_properties;
	event_type = "Partner Integrations Github Unlink Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Om = class {
	event_properties;
	event_type = "Partner Integrations Github Unlink Issue Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, km = class {
	event_properties;
	event_type = "Partner Integrations Github View Link Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Am = class {
	event_properties;
	event_type = "Partner Integrations Jira Comments Collapsed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jm = class {
	event_properties;
	event_type = "Partner Integrations Jira Comments Expanded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Mm = class {
	event_properties;
	event_type = "Partner Integrations Jira Create Issue Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nm = class {
	event_properties;
	event_type = "Partner Integrations Jira Create Issue Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Pm = class {
	event_properties;
	event_type = "Partner Integrations Jira Link Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fm = class {
	event_properties;
	event_type = "Partner Integrations Jira Open Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Im = class {
	event_properties;
	event_type = "Partner Integrations Jira Open Jira Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lm = class {
	event_properties;
	event_type = "Partner Integrations Jira Remove All Dangling Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Rm = class {
	event_properties;
	event_type = "Partner Integrations Jira Remove Dangling Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zm = class {
	event_properties;
	event_type = "Partner Integrations Jira Unlink All Issues Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bm = class {
	event_properties;
	event_type = "Partner Integrations Jira Unlink All Issues Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vm = class {
	event_properties;
	event_type = "Partner Integrations Jira Unlink All Issues Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hm = class {
	event_properties;
	event_type = "Partner Integrations Jira Unlink Issue Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Um = class {
	event_properties;
	event_type = "Partner Integrations Jira Unlink Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wm = class {
	event_properties;
	event_type = "Partner Integrations Jira Unlink Issue Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gm = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Messages Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Km = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qm = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jm = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Subscription To Channel Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ym = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Subscription To Channel Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xm = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Subscription To Channel Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zm = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Unsubscribe Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qm = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Unsubscribe Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, $m = class {
	event_properties;
	event_type = "Partner Integrations Klaviyo Profile Unsubscribe Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, eh = class {
	event_properties;
	event_type = "Partner Integrations Linear Create New Issue Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, th = class {
	event_properties;
	event_type = "Partner Integrations Linear Create New Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nh = class {
	event_properties;
	event_type = "Partner Integrations Linear Create New Issue Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rh = class {
	event_properties;
	event_type = "Partner Integrations Linear Link Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ih = class {
	event_properties;
	event_type = "Partner Integrations Linear Open Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ah = class {
	event_properties;
	event_type = "Partner Integrations Linear Open Linear Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, oh = class {
	event_properties;
	event_type = "Partner Integrations Linear Unlink Issue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sh = class {
	event_type = "Partner Integrations Recharge Widget Customer Overview Opened";
}, ch = class {
	event_type = "Partner Integrations Recharge Widget Order Opened";
}, lh = class {
	event_type = "Partner Integrations Recharge Widget Orders List Opened";
}, uh = class {
	event_type = "Partner Integrations Recharge Widget Profile Received";
}, dh = class {
	event_type = "Partner Integrations Recharge Widget Subscription Cancelled";
}, fh = class {
	event_type = "Partner Integrations Recharge Widget Subscription Opened";
}, ph = class {
	event_type = "Partner Integrations Recharge Widget Subscription Reactivated";
}, mh = class {
	event_type = "Partner Integrations Recharge Widget Subscription Skipped";
}, hh = class {
	event_type = "Partner Integrations Recharge Widget Subscription Swapped";
}, gh = class {
	event_type = "Partner Integrations Recharge Widget Subscriptions List Opened";
}, _h = class {
	event_type = "Partner Integrations RivoLoyalty Widget Customer Clicked";
}, vh = class {
	event_type = "Partner Integrations RivoLoyalty Widget Customer Received";
}, yh = class {
	event_type = "Partner Integrations RivoLoyalty Widget Points Add Failed";
}, bh = class {
	event_type = "Partner Integrations RivoLoyalty Widget Points Add Succeeded";
}, xh = class {
	event_type = "Partner Integrations RivoLoyalty Widget Points Remove Failed";
}, Sh = class {
	event_type = "Partner Integrations RivoLoyalty Widget Points Remove Succeeded";
}, Ch = class {
	event_properties;
	event_type = "Partner Integrations Settings Create Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wh = class {
	event_properties;
	event_type = "Partner Integrations Settings Overview Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Th = class {
	event_properties;
	event_type = "Partner Integrations Settings Overview Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Eh = class {
	event_properties;
	event_type = "Partner Integrations Settings View Delete Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Dh = class {
	event_properties;
	event_type = "Partner Integrations Settings View Delete Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Oh = class {
	event_properties;
	event_type = "Partner Integrations Settings View Delete Requested";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, kh = class {
	event_properties;
	event_type = "Partner Integrations Settings View OAuth Started";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ah = class {
	event_properties;
	event_type = "Partner Integrations Settings View OAuth Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jh = class {
	event_properties;
	event_type = "Partner Integrations Settings View Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Mh = class {
	event_type = "Partner Integrations Shopify Widget Create Draft Order Failed";
}, Nh = class {
	event_type = "Partner Integrations Shopify Widget Create Draft Order Succeeded";
}, Ph = class {
	event_type = "Partner Integrations Shopify Widget Create Order Failed";
}, Fh = class {
	event_type = "Partner Integrations Shopify Widget Create Order Succeeded";
}, Ih = class {
	event_type = "Partner Integrations Shopify Widget Discount Code Created";
}, Lh = class {
	event_type = "Partner Integrations Shopify Widget Duplicate Order Failed";
}, Rh = class {
	event_type = "Partner Integrations Shopify Widget Duplicate Order Succeeded";
}, zh = class {
	event_type = "Partner Integrations Shopify Widget Order Cancelled";
}, Bh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Collapse Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Collapse Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Uh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Edit Shipping Address Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Refund Canceled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Kh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Refund Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order Refund Requested";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jh = class {
	event_type = "Partner Integrations Shopify Widget Order Tags Updated";
}, Yh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Order View Order In Shopify Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zh = class {
	event_type = "Partner Integrations Shopify Widget Profile Created";
}, Qh = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget Refreshed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, $h = class {
	event_type = "Partner Integrations Shopify Widget Refund Partial Order Failed";
}, eg = class {
	event_type = "Partner Integrations Shopify Widget Refund Partial Order Succeeded";
}, tg = class {
	event_properties;
	event_type = "Partner Integrations Shopify Widget View Customer In Shopify Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ng = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Channel Subscription Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rg = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Channel Subscription Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ig = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Channel Subscription Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ag = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Channel Unsubscription Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, og = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Channel Unsubscription Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sg = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Channel Unsubscription Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cg = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Message External Link Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lg = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Messages Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ug = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Orders Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, dg = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Profile Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, fg = class {
	event_properties;
	event_type = "Partner Integrations Voyado Widget Transactions Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pg = class {
	event_properties;
	event_type = "Partner Integrations Widget Collapse Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, mg = class {
	event_properties;
	event_type = "Partner Integrations Widget Collapse Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, hg = class {
	event_type = "Partner Integrations Widget LoyaltyLion Add Points Failed";
}, gg = class {
	event_type = "Partner Integrations Widget LoyaltyLion Add Points Succeeded";
}, _g = class {
	event_type = "Partner Integrations Widget LoyaltyLion Customer Received";
}, vg = class {
	event_type = "Partner Integrations Widget LoyaltyLion Remove Points Failed";
}, yg = class {
	event_type = "Partner Integrations Widget LoyaltyLion Remove Points Succeeded";
}, bg = class {
	event_type = "Partner Integrations Widget Voyado Update Points Failed";
}, xg = class {
	event_type = "Partner Integrations Widget Voyado Update Points Succeeded";
}, Sg = class {
	event_type = "Phone Actions Menu Action Add Outbound Caller ID Clicked";
}, Cg = class {
	event_type = "Phone Actions Menu Action Change Hold Music Clicked";
}, wg = class {
	event_type = "Phone Actions Menu Opened";
}, Tg = class {
	event_type = "Phone Add Outbound Caller ID Form Cancelled";
}, Eg = class {
	event_type = "Phone Add Outbound Caller ID Form Submitted";
}, Dg = class {
	event_type = "Phone Change Hold Music Form Cancelled";
}, Og = class {
	event_type = "Phone Change Hold Music Form Submitted";
}, kg = class {
	event_type = "Phone Create Flow Form Cancelled";
}, Ag = class {
	event_type = "Phone Create Flow Form Submitted";
}, jg = class {
	event_type = "Phone Flow Options Menu Option Audit Log Clicked";
}, Mg = class {
	event_type = "Phone Flow Options Menu Option Delete Clicked";
}, Ng = class {
	event_type = "Phone Flow Options Menu Option Duplicate Clicked";
}, Pg = class {
	event_type = "Phone Flow Options Menu Option Edit Clicked";
}, Fg = class {
	event_type = "Phone Flow Options Menu Option Move To Another Number Clicked";
}, Ig = class {
	event_type = "Phone Flow Options Menu Option Opened";
}, Lg = class {
	event_type = "Phone Flow Options Menu Option Rename Clicked";
}, Rg = class {
	event_type = "Phone Form Cancelled";
}, zg = class {
	event_type = "Phone Form Opened";
}, Bg = class {
	event_type = "Phone Form Submitted";
}, Vg = class {
	event_type = "Phone Options Menu Opened";
}, Hg = class {
	event_type = "Phone Options Menu Option Create Flow Clicked";
}, Ug = class {
	event_type = "Phone Options Menu Option Edit Clicked";
}, Wg = class {
	event_type = "Phone Options Menu Option Remove Number Clicked";
}, Gg = class {
	event_type = "Phone Options Menu Option Set Default Caller ID Clicked";
}, Kg = class {
	event_type = "Phone Options Menu Option Setup Clicked";
}, qg = class {
	event_properties;
	event_type = "Phone Recording Downloaded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jg = class {
	event_properties;
	event_type = "Phone Recording Pause Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yg = class {
	event_properties;
	event_type = "Phone Recording Play Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xg = class {
	event_properties;
	event_type = "Phone Recording Playback Abandoned";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zg = class {
	event_properties;
	event_type = "Phone Recording Playback Ended";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qg = class {
	event_type = "Phone Search Applied";
}, $g = class {
	event_type = "Presence List Item Clicked";
}, e_ = class {
	event_properties;
	event_type = "Presence Media Other Agent Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, t_ = class {
	event_properties;
	event_type = "Presence Media Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, n_ = class {
	event_properties;
	event_type = "Presence Other Agent Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, r_ = class {
	event_properties;
	event_type = "Presence Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, i_ = class {
	event_properties;
	event_type = "Push Notification Platform Form Cancelled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, a_ = class {
	event_properties;
	event_type = "Push Notification Platform Form Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, o_ = class {
	event_properties;
	event_type = "Push Notification Platform Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, s_ = class {
	event_properties;
	event_type = "Quick Replies Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, c_ = class {
	event_properties;
	event_type = "Quick Reply Chosen";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, l_ = class {
	event_properties;
	event_type = "Quick Reply Feedback for Recommended Replies Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, u_ = class {
	event_properties;
	event_type = "Quick Reply Filter Chosen";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, d_ = class {
	event_properties;
	event_type = "Quick Reply Language Selected";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, f_ = class {
	event_properties;
	event_type = "Quick Reply Template Favorite Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, p_ = class {
	event_properties;
	event_type = "Rewind Dismissed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, m_ = class {
	event_properties;
	event_type = "Rewind Feedback Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, h_ = class {
	event_properties;
	event_type = "Rewind Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, g_ = class {
	event_properties;
	event_type = "Rewind Share To LinkedIn Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, __ = class {
	event_properties;
	event_type = "Rewind Slide Image Copied";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, v_ = class {
	event_properties;
	event_type = "Rewind Slide Image Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, y_ = class {
	event_properties;
	event_type = "Rewind Slide Text Copied";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, b_ = class {
	event_properties;
	event_type = "Rewind Slide Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, x_ = class {
	event_type = "Saved Search Applied";
}, S_ = class {
	event_type = "Saved Search Closed";
}, C_ = class {
	event_properties;
	event_type = "Saved Search Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, w_ = class {
	event_type = "Saved Search Deleted";
}, T_ = class {
	event_type = "Saved Search Updated";
}, E_ = class {
	event_type = "Scheduled Conversations Csv Import Clicked";
}, D_ = class {
	event_type = "Scheduled Conversations Csv Imported";
}, O_ = class {
	event_type = "Search Conversation Preview Closed";
}, k_ = class {
	event_properties;
	event_type = "Search Conversation Preview Go To Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, A_ = class {
	event_properties;
	event_type = "Search Conversation Preview Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, j_ = class {
	event_properties;
	event_type = "Search Field Blurred";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, M_ = class {
	event_properties;
	event_type = "Search Field Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, N_ = class {
	event_properties;
	event_type = "Search Field Focused";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, P_ = class {
	event_properties;
	event_type = "Search Field Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, F_ = class {
	event_properties;
	event_type = "Search Filter Condition Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, I_ = class {
	event_properties;
	event_type = "Search Filter Condition Removed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, L_ = class {
	event_properties;
	event_type = "Search Filter Operator Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, R_ = class {
	event_properties;
	event_type = "Search Filter Strategy Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, z_ = class {
	event_properties;
	event_type = "Search Filter Value Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, B_ = class {
	event_properties;
	event_type = "Search Filter Value Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, V_ = class {
	event_properties;
	event_type = "Search Filters Applied";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, H_ = class {
	event_properties;
	event_type = "Search Filters Cleared";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, U_ = class {
	event_properties;
	event_type = "Search Filters Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, W_ = class {
	event_properties;
	event_type = "Search Filters Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, G_ = class {
	event_properties;
	event_type = "Search Filters Validation Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, K_ = class {
	event_properties;
	event_type = "Search Sorting Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, q_ = class {
	event_properties;
	event_type = "Search Strict Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, J_ = class {
	event_type = "Settings Agents Add Agent Button Clicked";
}, Y_ = class {
	event_properties;
	event_type = "Settings Agents Custom Workload Assigned";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, X_ = class {
	event_type = "Settings Agents Custom Workload Created";
}, Z_ = class {
	event_type = "Settings Agents Custom Workload Deleted";
}, Q_ = class {
	event_type = "Settings Agents Edit Button Clicked";
}, $_ = class {
	event_properties;
	event_type = "Settings Agents Tab Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ev = class {
	event_properties;
	event_type = "Settings Audio Delete Cancel Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tv = class {
	event_properties;
	event_type = "Settings Audio Delete Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nv = class {
	event_properties;
	event_type = "Settings Audio Delete Confirm Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rv = class {
	event_properties;
	event_type = "Settings Audio Usage Flow Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, iv = class {
	event_properties;
	event_type = "Settings Audio Usage Link Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, av = class {
	event_properties;
	event_type = "Settings Commands Assign Keybindings";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ov = class {
	event_type = "Settings Commands Reset All Keybindings";
}, sv = class {
	event_properties;
	event_type = "Settings Commands Reset Keybindings";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cv = class {
	event_type = "Settings Commands Unassign All Keybindings";
}, lv = class {
	event_properties;
	event_type = "Settings Commands Unassign Keybindings";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, uv = class {
	event_properties;
	event_type = "Settings Custom Attribute Activated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, dv = class {
	event_properties;
	event_type = "Settings Custom Attribute Add New Attribute Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, fv = class {
	event_properties;
	event_type = "Settings Custom Attribute Archived";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pv = class {
	event_properties;
	event_type = "Settings Custom Attribute Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, mv = class {
	event_properties;
	event_type = "Settings Custom Attribute Deactivated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, hv = class {
	event_properties;
	event_type = "Settings Custom Attribute Reordered";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, gv = class {
	event_properties;
	event_type = "Settings Custom Attribute Unarchived";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, _v = class {
	event_properties;
	event_type = "Settings Custom Attribute Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, vv = class {
	event_type = "Settings Custom Away Status Add New Clicked";
}, yv = class {
	event_type = "Settings Custom Away Status Archived";
}, bv = class {
	event_type = "Settings Custom Away Status Created";
}, xv = class {
	event_type = "Settings Custom Away Status Unarchived";
}, Sv = class {
	event_type = "Settings Custom Away Status Updated";
}, Cv = class {
	event_type = "Settings Forms Embed Url Copied";
}, wv = class {
	event_type = "Settings Forms Styling Added";
}, Tv = class {
	event_properties;
	event_type = "Settings Integrations Api Tokens Add Confirm";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ev = class {
	event_type = "Settings Integrations Api Tokens Copy";
}, Dv = class {
	event_type = "Settings Integrations Api Tokens Documentation Link Integrations Api";
}, Ov = class {
	event_type = "Settings Integrations Api Tokens Remove";
}, kv = class {
	event_type = "Settings Integrations Api Tokens Remove Cancel";
}, Av = class {
	event_type = "Settings Integrations Api Tokens Remove Confirm";
}, jv = class {
	event_type = "Settings Integrations Api Tokens View";
}, Mv = class {
	event_properties;
	event_type = "Settings Integrations Card Edit Save";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nv = class {
	event_properties;
	event_type = "Settings Integrations Card Edit Test";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Pv = class {
	event_properties;
	event_type = "Settings Integrations Card Listing Add Card";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fv = class {
	event_properties;
	event_type = "Settings Integrations Card Read Documentation";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Iv = class {
	event_properties;
	event_type = "Settings Integrations Card Test";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lv = class {
	event_properties;
	event_type = "Settings Integrations Card Test Add Parameter";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Rv = class {
	event_properties;
	event_type = "Settings Integrations Card Test Remove Parameter";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Edited";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Vv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Oauth Provider Authentication Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Oauth Provider Authentication Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Uv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Oauth Provider Authentication Timed Out";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Oauth Provider Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gv = class {
	event_properties;
	event_type = "Settings Integrations Custom Card Oauth Provider Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Kv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Backfill Started Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Backfill Started Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Configuration Enabled Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Configuration Enabled Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Create Configuration Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Create Configuration Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qv = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Delete Configuration Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, $v = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Delete Configuration Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ey = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Retry Backfilling Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ty = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Retry Backfilling Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ny = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Start Syncing Events Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ry = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Type Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, iy = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Update Configuration Failed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ay = class {
	event_properties;
	event_type = "Settings Integrations Data Sync Update Configuration Succeeded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, oy = class {
	event_properties;
	event_type = "Settings Integrations Item Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sy = class {
	event_properties;
	event_type = "Settings Integrations Webform Endpoints Add Save";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cy = class {
	event_type = "Settings Integrations Webform Endpoints Copy";
}, ly = class {
	event_type = "Settings Integrations Webform Endpoints Read Documentation Link";
}, uy = class {
	event_properties;
	event_type = "Settings Integrations Webform Endpoints Remove";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, dy = class {
	event_properties;
	event_type = "Settings Integrations Webform Endpoints Remove Cancel";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, fy = class {
	event_properties;
	event_type = "Settings Integrations Webform Endpoints Remove Confirm";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, py = class {
	event_type = "Settings Integrations Webhooks Add";
}, my = class {
	event_type = "Settings Integrations Webhooks Add Confirm";
}, hy = class {
	event_type = "Settings Integrations Webhooks Documentation Link Clicked";
}, gy = class {
	event_type = "Settings Integrations Webhooks Edit";
}, _y = class {
	event_type = "Settings Integrations Webhooks Edit Save";
}, vy = class {
	event_type = "Settings Integrations Webhooks Enabled Off";
}, yy = class {
	event_type = "Settings Integrations Webhooks Enabled On";
}, by = class {
	event_type = "Settings Integrations Webhooks Remove";
}, xy = class {
	event_type = "Settings Integrations Webhooks Remove Cancel";
}, Sy = class {
	event_type = "Settings Integrations Webhooks Remove Confirm";
}, Cy = class {
	event_type = "Settings Integrations Webhooks View";
}, wy = class {
	event_type = "Settings Integrations Webhooks View Copy Secret";
}, Ty = class {
	event_type = "Settings Integrations Webhooks View Copy Url";
}, Ey = class {
	event_type = "Settings Integrations Webhooks View Edit";
}, Dy = class {
	event_properties;
	event_type = "Settings Menu Item Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Oy = class {
	event_type = "Settings Organization Form Submitted";
}, ky = class {
	event_type = "Settings Organization Logo Changed";
}, Ay = class {
	event_properties;
	event_type = "Settings Profile Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jy = class {
	event_properties;
	event_type = "Settings Queue Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, My = class {
	event_type = "Settings Queue Agent Deleted";
}, Ny = class {
	event_type = "Settings Queue Agent Search Submitted";
}, Py = class {
	event_properties;
	event_type = "Settings Queue Agent Sorted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fy = class {
	event_properties;
	event_type = "Settings Queue Alerts Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Iy = class {
	event_properties;
	event_type = "Settings Queue Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ly = class {
	event_type = "Settings Queue Teams Add Team Button Clicked";
}, Ry = class {
	event_type = "Settings Queue Teams Add Team Form Submitted";
}, zy = class {
	event_type = "Settings Queue Teams Delete Team Button Clicked";
}, By = class {
	event_type = "Settings Queues Add Queue Clicked";
}, Vy = class {
	event_properties;
	event_type = "Settings Queues Archive Queue Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hy = class {
	event_type = "Settings Queues Edit Queue Clicked";
}, Uy = class {
	event_type = "Settings Queues Unarchive Queue Clicked";
}, Wy = class {
	event_properties;
	event_type = "Settings Roles Custom Role Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gy = class {
	event_type = "Settings Roles Custom Role Deleted";
}, Ky = class {
	event_properties;
	event_type = "Settings Roles Custom Role Edited";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qy = class {
	event_properties;
	event_type = "Settings Satisfaction Filters Channel Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jy = class {
	event_properties;
	event_type = "Settings Satisfaction Filters Channel Removed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yy = class {
	event_type = "Settings Satisfaction Filters Create Viewed";
}, Xy = class {
	event_type = "Settings Satisfaction Filters Created";
}, Zy = class {
	event_type = "Settings Satisfaction Filters Edited";
}, Qy = class {
	event_type = "Settings Summarization Save Changes Clicked";
}, $y = class {
	event_properties;
	event_type = "Settings Summarization Show Automatically Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, eb = class {
	event_properties;
	event_type = "Settings Summarization Show On Demand Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tb = class {
	event_type = "Settings Survey Accent Color Changed";
}, nb = class {
	event_type = "Settings Survey Back To List Clicked";
}, rb = class {
	event_properties;
	event_type = "Settings Survey Back To Survey Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ib = class {
	event_type = "Settings Survey Create Failed";
}, ab = class {
	event_type = "Settings Survey Create Modal Opened";
}, ob = class {
	event_properties;
	event_type = "Settings Survey Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, sb = class {
	event_type = "Settings Survey Delete Cancelled";
}, cb = class {
	event_type = "Settings Survey Delete Confirmed";
}, lb = class {
	event_type = "Settings Survey Delete Failed";
}, ub = class {
	event_type = "Settings Survey Deleted";
}, db = class {
	event_properties;
	event_type = "Settings Survey Edit Button Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, fb = class {
	event_properties;
	event_type = "Settings Survey Edit Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, pb = class {
	event_type = "Settings Survey Email Preview Area Clicked";
}, mb = class {
	event_type = "Settings Survey Font Color Changed";
}, hb = class {
	event_properties;
	event_type = "Settings Survey Header Image Type Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, gb = class {
	event_type = "Settings Survey Ivr Details Save Failed";
}, _b = class {
	event_type = "Settings Survey Ivr Details Saved";
}, vb = class {
	event_type = "Settings Survey Ivr Details Viewed";
}, yb = class {
	event_type = "Settings Survey Language Added";
}, bb = class {
	event_type = "Settings Survey Language Delete Cancelled";
}, xb = class {
	event_properties;
	event_type = "Settings Survey Language Delete Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Sb = class {
	event_type = "Settings Survey Language Delete Failed";
}, Cb = class {
	event_properties;
	event_type = "Settings Survey Language Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, wb = class {
	event_properties;
	event_type = "Settings Survey Language Disabled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Tb = class {
	event_properties;
	event_type = "Settings Survey Language Edit Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Eb = class {
	event_properties;
	event_type = "Settings Survey Language Enabled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Db = class {
	event_type = "Settings Survey List Viewed";
}, Ob = class {
	event_type = "Settings Survey Multi Question Details Save Failed";
}, kb = class {
	event_properties;
	event_type = "Settings Survey Multi Question Details Saved";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ab = class {
	event_properties;
	event_type = "Settings Survey Multi Question Details Viewed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jb = class {
	event_properties;
	event_type = "Settings Survey Multi Question Tab Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Mb = class {
	event_type = "Settings Survey Name Save Failed";
}, Nb = class {
	event_type = "Settings Survey Name Saved";
}, Pb = class {
	event_properties;
	event_type = "Settings Survey Preview Mode Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Fb = class {
	event_type = "Settings Survey Question Add Clicked";
}, Ib = class {
	event_properties;
	event_type = "Settings Survey Question Added";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lb = class {
	event_properties;
	event_type = "Settings Survey Question Deleted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Rb = class {
	event_properties;
	event_type = "Settings Survey Question Edit Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, zb = class {
	event_type = "Settings Survey Question Editor Cancelled";
}, Bb = class {
	event_type = "Settings Survey Question Reordered";
}, Vb = class {
	event_properties;
	event_type = "Settings Survey Question Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Hb = class {
	event_properties;
	event_type = "Settings Survey Unsaved Changes Dialog Shown";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ub = class {
	event_properties;
	event_type = "Settings Survey Unsaved Changes Discarded";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Wb = class {
	event_properties;
	event_type = "Settings Survey Unsaved Changes Kept";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gb = class {
	event_type = "Settings Tags Add Tag Button Clicked";
}, Kb = class {
	event_properties;
	event_type = "Settings Tags Tag Activated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qb = class {
	event_properties;
	event_type = "Settings Tags Tag Deactivated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jb = class {
	event_type = "Settings Team Add Team Button Clicked";
}, Yb = class {
	event_type = "Settings Team Details Add Agents Button Clicked";
}, Xb = class {
	event_type = "Settings Team Edit Team Button Clicked";
}, Zb = class {
	event_properties;
	event_type = "Settings Team Modal Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qb = class {
	event_type = "Settings Team Remove Team Button Clicked";
}, $b = class {
	event_type = "Settings Team Remove Team Confirmed";
}, ex = class {
	event_properties;
	event_type = "Settings Templates Add Template Button Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, tx = class {
	event_properties;
	event_type = "Settings Templates Edit Template Button Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, nx = class {
	event_properties;
	event_type = "Settings Templates Modal Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, rx = class {
	event_properties;
	event_type = "Settings Templates Remove Template Button Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ix = class {
	event_properties;
	event_type = "Settings Templates Remove Template Confirmed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ax = class {
	event_properties;
	event_type = "Settings Templates Tab Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, ox = class {
	event_type = "Shared Worker Tab Or Window Changed";
}, sx = class {
	event_properties;
	event_type = "Shared Worker Tab Or Window Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, cx = class {
	event_properties;
	event_type = "Shared Worker Tab Or Window Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, lx = class {
	event_type = "Sidebar Add Agent Button Clicked";
}, ux = class {
	event_type = "Sidebar Collapsed";
}, dx = class {
	event_type = "Sidebar Expanded";
}, fx = class {
	event_properties;
	event_type = "Sidebar Nav Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, px = class {
	event_type = "Sign Out Aborted";
}, mx = class {
	event_type = "Sign Out Confirmed";
}, hx = class {
	event_properties;
	event_type = "Simultaneous Ring Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, gx = class {
	event_type = "SLA Policies Reordered";
}, _x = class {
	event_type = "SLA Policy Activated";
}, vx = class {
	event_properties;
	event_type = "SLA Policy Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, yx = class {
	event_type = "SLA Policy Deactivated";
}, bx = class {
	event_type = "SLA Policy Deleted";
}, xx = class {
	event_properties;
	event_type = "SLA Policy Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Sx = class {
	event_properties;
	event_type = "Smart Conversation Reply Button Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Cx = class {
	event_type = "Subflow Back To Main Flow Node Reused";
}, wx = class {
	event_type = "Subflow Back To Main Flow Node Used";
}, Tx = class {
	event_type = "Subflow Created From Highlighted Nodes";
}, Ex = class {
	event_type = "Subflow Created From Scratch";
}, Dx = class {
	event_type = "Subflow Reused";
}, Ox = class {
	event_properties;
	event_type = "Tag Select Create New Tag Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, kx = class {
	event_properties;
	event_type = "Tags Create Modal Color Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Ax = class {
	event_properties;
	event_type = "Tags Create Modal Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, jx = class {
	event_properties;
	event_type = "Tags Create Modal Opened";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Mx = class {
	event_properties;
	event_type = "Team Agent Actions Menu Item Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Nx = class {
	event_type = "Team Agent Actions Menu Opened";
}, Px = class {
	event_type = "Team Agent Collapsed";
}, Fx = class {
	event_type = "Team Agent Expanded";
}, Ix = class {
	event_properties;
	event_type = "Team Favorite Toggled";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Lx = class {
	event_type = "Theme Imported";
}, Rx = class {
	event_type = "Theme Shared";
}, zx = class {
	event_properties;
	event_type = "Theme Updated";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Bx = class {
	event_type = "Topbar Beamer Opened";
}, Vx = class {
	event_type = "Topbar Email Opened";
}, Hx = class {
	event_type = "Topbar Notifications Opened";
}, Ux = class {
	event_type = "Topbar Phones Opened";
}, Wx = class {
	event_properties;
	event_type = "Topbar Search Quick Action Clicked";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Gx = class {
	event_type = "Topbar Support Opened";
}, Kx = class {
	event_properties;
	event_type = "User Modal Form Submitted";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, qx = class {
	event_properties;
	event_type = "User Modal Role Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Jx = class {
	event_properties;
	event_type = "User Modal User Type Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Yx = class {
	event_properties;
	event_type = "Websocket Active Connection Changed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Xx = class {
	event_properties;
	event_type = "Websocket Close Event Received";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Zx = class {
	event_properties;
	event_type = "Websocket Connection Closed";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, Qx = class {
	event_properties;
	event_type = "Websocket Connection Created";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, $x = class {
	event_properties;
	event_type = "Websocket Reconnect Attempt Started";
	constructor(e) {
		this.event_properties = e, this.event_properties = e;
	}
}, eS = () => ({ promise: Promise.resolve() }), tS = class {
	disabled = !1;
	amplitude;
	get client() {
		return this.isInitializedAndEnabled(), this.amplitude;
	}
	get isLoaded() {
		return this.amplitude != null;
	}
	isInitializedAndEnabled() {
		return this.amplitude ? !this.disabled : (console.error("ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?"), !1);
	}
	load(e) {
		if (this.disabled = e.disabled ?? !1, this.amplitude) return console.warn("WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup."), eS();
		let t = null;
		if (e.client && "apiKey" in e.client ? t = e.client.apiKey : "environment" in e && (t = _o[e.environment]), e.client && "instance" in e.client) this.amplitude = e.client.instance;
		else if (t) {
			this.amplitude = ho();
			let n = e.client && "configuration" in e.client ? e.client.configuration : {};
			return this.amplitude.init(t, void 0, {
				...vo,
				...n
			});
		} else console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
		return eS();
	}
	identify(e, t, n) {
		if (!this.isInitializedAndEnabled()) return eS();
		e && (n = {
			...n,
			user_id: e
		});
		let r = new O(), i = t;
		if (i != null) for (let [e, t] of Object.entries(i)) r.set(e, t);
		return this.amplitude.identify(r, n);
	}
	flush() {
		return this.isInitializedAndEnabled() ? this.amplitude.flush() : eS();
	}
	track(e, t) {
		return this.isInitializedAndEnabled() ? this.amplitude.track(e, void 0, t) : eS();
	}
	addAgentsModalFormSubmitted(e, t) {
		return this.track(new bo(e), t);
	}
	agentCopilotBackButtonClicked(e) {
		return this.track(new xo(), e);
	}
	agentCopilotConversationCustomAttributeSuggestionAccepted(e) {
		return this.track(new So(), e);
	}
	agentCopilotConversationTagSuggestionAccepted(e, t) {
		return this.track(new Co(e), t);
	}
	agentCopilotDropdownItemClicked(e, t) {
		return this.track(new wo(e), t);
	}
	agentCopilotImproveWritingImprovementClicked(e, t) {
		return this.track(new To(e), t);
	}
	agentCopilotTextInsertBelowClicked(e, t) {
		return this.track(new Eo(e), t);
	}
	agentCopilotTextReplaceClicked(e, t) {
		return this.track(new Do(e), t);
	}
	agentCopilotTranslateMessageLanguageSelected(e, t) {
		return this.track(new Oo(e), t);
	}
	agentCopilotTrialLearnMoreClicked(e, t) {
		return this.track(new ko(e), t);
	}
	agentCopilotTrialLeftmenuCtaClicked(e) {
		return this.track(new Ao(), e);
	}
	agentCopilotTrialLeftmenuCtaDismissed(e) {
		return this.track(new jo(), e);
	}
	agentCopilotTrialRequestContactClicked(e) {
		return this.track(new Mo(), e);
	}
	agentCopilotTrialStarted(e) {
		return this.track(new No(), e);
	}
	agentCopilotTrialStopped(e) {
		return this.track(new Po(), e);
	}
	agentCopilotUndoClicked(e) {
		return this.track(new Fo(), e);
	}
	agentCustomAwayStatusUpdated(e, t) {
		return this.track(new Io(e), t);
	}
	analyticsBusinessHoursScheduleRemoved(e, t) {
		return this.track(new Lo(e), t);
	}
	analyticsBusinessHoursScheduleUpdated(e, t) {
		return this.track(new Ro(e), t);
	}
	analyticsChartFormatChanged(e, t) {
		return this.track(new zo(e), t);
	}
	analyticsChartGranularityChanged(e, t) {
		return this.track(new Bo(e), t);
	}
	analyticsChartVisualizationChanged(e, t) {
		return this.track(new Vo(e), t);
	}
	analyticsCompareClicked(e, t) {
		return this.track(new Ho(e), t);
	}
	analyticsCompareContextUpdated(e, t) {
		return this.track(new Uo(e), t);
	}
	analyticsComparePeriodUpdated(e, t) {
		return this.track(new Wo(e), t);
	}
	analyticsContextUpdated(e, t) {
		return this.track(new Go(e), t);
	}
	analyticsConversationLinkClicked(e, t) {
		return this.track(new Ko(e), t);
	}
	analyticsConversationPreviewClicked(e, t) {
		return this.track(new qo(e), t);
	}
	analyticsDashboardViewed(e, t) {
		return this.track(new Jo(e), t);
	}
	analyticsExportClicked(e, t) {
		return this.track(new Yo(e), t);
	}
	analyticsExportDownloadClicked(e, t) {
		return this.track(new Xo(e), t);
	}
	analyticsExportMyDataButtonPressed(e, t) {
		return this.track(new Zo(e), t);
	}
	analyticsFilterCleared(e, t) {
		return this.track(new Qo(e), t);
	}
	analyticsFilterOpened(e, t) {
		return this.track(new $o(e), t);
	}
	analyticsFilterOperatorUpdated(e, t) {
		return this.track(new es(e), t);
	}
	analyticsFilterValueAdded(e, t) {
		return this.track(new ts(e), t);
	}
	analyticsFiltersApplied(e, t) {
		return this.track(new ns(e), t);
	}
	analyticsFiltersCleared(e, t) {
		return this.track(new rs(e), t);
	}
	analyticsHelperClicked(e, t) {
		return this.track(new is(e), t);
	}
	analyticsInDepthClicked(e, t) {
		return this.track(new as(e), t);
	}
	analyticsInsightsCopyClicked(e, t) {
		return this.track(new os(e), t);
	}
	analyticsInsightsFeedbackClicked(e, t) {
		return this.track(new ss(e), t);
	}
	analyticsInsightsPromptClicked(e, t) {
		return this.track(new cs(e), t);
	}
	analyticsInsightsRegenerateClicked(e, t) {
		return this.track(new ls(e), t);
	}
	analyticsPanelControlsOpened(e, t) {
		return this.track(new us(e), t);
	}
	analyticsPeriodUpdated(e, t) {
		return this.track(new ds(e), t);
	}
	analyticsPinPanelClicked(e, t) {
		return this.track(new fs(e), t);
	}
	analyticsPinPanelQuickViewCreated(e, t) {
		return this.track(new ps(e), t);
	}
	analyticsQuickViewAutoRefreshDisabled(e, t) {
		return this.track(new ms(e), t);
	}
	analyticsQuickViewAutoRefreshEnabled(e, t) {
		return this.track(new hs(e), t);
	}
	analyticsQuickViewAutoRefreshTriggered(e, t) {
		return this.track(new gs(e), t);
	}
	analyticsQuickViewCreated(e, t) {
		return this.track(new _s(e), t);
	}
	analyticsQuickViewDeleted(e, t) {
		return this.track(new vs(e), t);
	}
	analyticsQuickViewDuplicated(e, t) {
		return this.track(new ys(e), t);
	}
	analyticsQuickViewFavoriteToggled(e, t) {
		return this.track(new bs(e), t);
	}
	analyticsQuickViewLandingPageSet(e, t) {
		return this.track(new xs(e), t);
	}
	analyticsQuickViewLandingPageUnset(e, t) {
		return this.track(new Ss(e), t);
	}
	analyticsQuickViewOwnershipTransferred(e) {
		return this.track(new Cs(), e);
	}
	analyticsQuickViewPanelControlsUpdated(e, t) {
		return this.track(new ws(e), t);
	}
	analyticsQuickViewPanelDescriptionUpdated(e, t) {
		return this.track(new Ts(e), t);
	}
	analyticsQuickViewPanelPinned(e, t) {
		return this.track(new Es(e), t);
	}
	analyticsQuickViewPanelUnpinned(e, t) {
		return this.track(new Ds(e), t);
	}
	analyticsQuickViewPanelsLayoutChanged(e, t) {
		return this.track(new Os(e), t);
	}
	analyticsQuickViewPanelsReset(e, t) {
		return this.track(new ks(e), t);
	}
	analyticsQuickViewPanelsUpdated(e, t) {
		return this.track(new As(e), t);
	}
	analyticsQuickViewSharingToggled(e, t) {
		return this.track(new js(e), t);
	}
	analyticsQuickViewUpdated(e, t) {
		return this.track(new Ms(e), t);
	}
	analyticsQuickViewViewed(e, t) {
		return this.track(new Ns(e), t);
	}
	analyticsRefreshClicked(e, t) {
		return this.track(new Ps(e), t);
	}
	analyticsTableLoadAllClicked(e, t) {
		return this.track(new Fs(e), t);
	}
	analyticsTableSortUpdated(e, t) {
		return this.track(new Is(e), t);
	}
	analyticsTimezoneUpdated(e, t) {
		return this.track(new Ls(e), t);
	}
	analyticsViewConversationsClicked(e, t) {
		return this.track(new Rs(e), t);
	}
	authFailedInit(e, t) {
		return this.track(new zs(e), t);
	}
	automationsFormCancelled(e, t) {
		return this.track(new Bs(e), t);
	}
	automationsFormOpened(e, t) {
		return this.track(new Vs(e), t);
	}
	automationsFormSubmitted(e, t) {
		return this.track(new Hs(e), t);
	}
	automationsOptionsMenuOpened(e) {
		return this.track(new Us(), e);
	}
	automationsOptionsMenuOptionDeleteClicked(e) {
		return this.track(new Ws(), e);
	}
	automationsOptionsMenuOptionDuplicateClicked(e) {
		return this.track(new Gs(), e);
	}
	automationsOptionsMenuOptionFlowClicked(e) {
		return this.track(new Ks(), e);
	}
	automationsOptionsMenuOptionSettingsClicked(e) {
		return this.track(new qs(), e);
	}
	automationsPaginationNextClicked(e) {
		return this.track(new Js(), e);
	}
	automationsPaginationPreviousClicked(e) {
		return this.track(new Ys(), e);
	}
	automationsSearchApplied(e) {
		return this.track(new Xs(), e);
	}
	automationsSearchClosed(e) {
		return this.track(new Zs(), e);
	}
	automationsSearchOpened(e) {
		return this.track(new Qs(), e);
	}
	automationsToggledOff(e) {
		return this.track(new $s(), e);
	}
	automationsToggledOn(e) {
		return this.track(new ec(), e);
	}
	bansBanUserClicked(e, t) {
		return this.track(new tc(e), t);
	}
	bansUnbanIpClicked(e) {
		return this.track(new nc(), e);
	}
	bansUnbanUserClicked(e, t) {
		return this.track(new rc(e), t);
	}
	bulkActionsUpdateClicked(e, t) {
		return this.track(new ic(e), t);
	}
	businessHoursAddScheduleAudioMessageAdded(e, t) {
		return this.track(new ac(e), t);
	}
	businessHoursAddScheduleButtonClicked(e) {
		return this.track(new oc(), e);
	}
	businessHoursAddScheduleFormCancelled(e, t) {
		return this.track(new sc(e), t);
	}
	businessHoursAddScheduleFormSubmitted(e, t) {
		return this.track(new cc(e), t);
	}
	businessHoursConflictNotificationButtonClicked(e) {
		return this.track(new lc(), e);
	}
	businessHoursConflictNotificationClosed(e) {
		return this.track(new uc(), e);
	}
	businessHoursDeleteScheduleFormCancelled(e) {
		return this.track(new dc(), e);
	}
	businessHoursDeleteScheduleFormSubmitted(e) {
		return this.track(new fc(), e);
	}
	businessHoursDuplicateScheduleFormCancelled(e) {
		return this.track(new pc(), e);
	}
	businessHoursDuplicateScheduleFormSubmitted(e) {
		return this.track(new mc(), e);
	}
	businessHoursFirstScheduleModalQuestionClicked(e, t) {
		return this.track(new hc(e), t);
	}
	businessHoursFirstScheduleSupportArticleClicked(e) {
		return this.track(new gc(), e);
	}
	businessHoursGoToFlowClicked(e) {
		return this.track(new _c(), e);
	}
	businessHoursMigrationWizardAudioMessageAdded(e, t) {
		return this.track(new vc(e), t);
	}
	businessHoursMigrationWizardCreateNewScheduleButtonClicked(e) {
		return this.track(new yc(), e);
	}
	businessHoursMigrationWizardEditHoursButtonClicked(e) {
		return this.track(new bc(), e);
	}
	businessHoursMigrationWizardFormCancelled(e, t) {
		return this.track(new xc(e), t);
	}
	businessHoursMigrationWizardFormSubmitted(e, t) {
		return this.track(new Sc(e), t);
	}
	businessHoursMigrationWizardOpeningHoursFormCancelled(e) {
		return this.track(new Cc(), e);
	}
	businessHoursMigrationWizardOpeningHoursFormSubmitted(e) {
		return this.track(new wc(), e);
	}
	businessHoursMigrationWizardStartUpdateButtonClicked(e) {
		return this.track(new Tc(), e);
	}
	businessHoursOptionsMenuOpened(e) {
		return this.track(new Ec(), e);
	}
	businessHoursOptionsMenuOptionDeleteClicked(e) {
		return this.track(new Dc(), e);
	}
	businessHoursOptionsMenuOptionDuplicateClicked(e) {
		return this.track(new Oc(), e);
	}
	businessHoursOptionsMenuOptionEditClicked(e) {
		return this.track(new kc(), e);
	}
	businessHoursOptionsMenuOptionRenameClicked(e) {
		return this.track(new Ac(), e);
	}
	businessHoursRenameScheduleFormCancelled(e) {
		return this.track(new jc(), e);
	}
	businessHoursRenameScheduleFormSubmitted(e, t) {
		return this.track(new Mc(e), t);
	}
	businessHoursScheduleAddExceptionButtonClicked(e) {
		return this.track(new Nc(), e);
	}
	businessHoursScheduleAddExceptionFormCancelled(e) {
		return this.track(new Pc(), e);
	}
	businessHoursScheduleAddExceptionFormSubmitted(e) {
		return this.track(new Fc(), e);
	}
	businessHoursScheduleAudioMessageFormCancelled(e, t) {
		return this.track(new Ic(e), t);
	}
	businessHoursScheduleAudioMessageFormSubmitted(e, t) {
		return this.track(new Lc(e), t);
	}
	businessHoursScheduleAudioMessageOptionsMenuOpened(e, t) {
		return this.track(new Rc(e), t);
	}
	businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked(e, t) {
		return this.track(new zc(e), t);
	}
	businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked(e, t) {
		return this.track(new Bc(e), t);
	}
	businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked(e, t) {
		return this.track(new Vc(e), t);
	}
	businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked(e, t) {
		return this.track(new Hc(e), t);
	}
	businessHoursScheduleConflictChangeButtonClicked(e) {
		return this.track(new Uc(), e);
	}
	businessHoursScheduleConflictReviewButtonClicked(e) {
		return this.track(new Wc(), e);
	}
	businessHoursScheduleDeleteExceptionFormCancelled(e) {
		return this.track(new Gc(), e);
	}
	businessHoursScheduleDeleteExceptionFormSubmitted(e) {
		return this.track(new Kc(), e);
	}
	businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked(e, t) {
		return this.track(new qc(e), t);
	}
	businessHoursScheduleImportHolidayFormCancelled(e) {
		return this.track(new Jc(), e);
	}
	businessHoursScheduleImportHolidayFormSubmitted(e, t) {
		return this.track(new Yc(e), t);
	}
	businessHoursScheduleOptionsMenuImportHolidaysClicked(e) {
		return this.track(new Xc(), e);
	}
	businessHoursScheduleOptionsMenuOpened(e) {
		return this.track(new Zc(), e);
	}
	businessHoursScheduleOptionsMenuRecoverHolidaysClicked(e) {
		return this.track(new Qc(), e);
	}
	businessHoursScheduleOptionsMenuRenameClicked(e) {
		return this.track(new $c(), e);
	}
	businessHoursScheduleOptionsMenuTimezoneClicked(e) {
		return this.track(new el(), e);
	}
	businessHoursSchedulePreviewButtonClicked(e, t) {
		return this.track(new tl(e), t);
	}
	businessHoursScheduleRecoverHolidaysFormCancelled(e) {
		return this.track(new nl(), e);
	}
	businessHoursScheduleRecoverHolidaysFormSubmitted(e) {
		return this.track(new rl(), e);
	}
	businessHoursScheduleReviewFormCancelled(e) {
		return this.track(new il(), e);
	}
	businessHoursScheduleReviewFormSubmitted(e) {
		return this.track(new al(), e);
	}
	businessHoursScheduleSaveScheduleButtonClicked(e) {
		return this.track(new ol(), e);
	}
	businessHoursScheduleTabClicked(e, t) {
		return this.track(new sl(e), t);
	}
	businessHoursScheduleViewClicked(e, t) {
		return this.track(new cl(e), t);
	}
	chatFlowOptionsMenuOptionAuditLogClicked(e) {
		return this.track(new ll(), e);
	}
	chatFormCanceled(e, t) {
		return this.track(new ul(e), t);
	}
	chatFormOpened(e, t) {
		return this.track(new dl(e), t);
	}
	chatFormSubmitted(e, t) {
		return this.track(new fl(e), t);
	}
	chatOptionsMenuOpened(e) {
		return this.track(new pl(), e);
	}
	chatOptionsMenuOptionDeleteClicked(e) {
		return this.track(new ml(), e);
	}
	chatOptionsMenuOptionDuplicateClicked(e) {
		return this.track(new hl(), e);
	}
	chatOptionsMenuOptionFlowClicked(e) {
		return this.track(new gl(), e);
	}
	chatOptionsMenuOptionRenameClicked(e) {
		return this.track(new _l(), e);
	}
	chatOptionsMenuOptionSetupClicked(e) {
		return this.track(new vl(), e);
	}
	chatPaginationNextClicked(e) {
		return this.track(new yl(), e);
	}
	chatPaginationPreviousClicked(e) {
		return this.track(new bl(), e);
	}
	chatSearchApplied(e) {
		return this.track(new xl(), e);
	}
	chatSearchClosed(e) {
		return this.track(new Sl(), e);
	}
	chatSearchOpened(e) {
		return this.track(new Cl(), e);
	}
	chatbotCreateModalOpened(e) {
		return this.track(new wl(), e);
	}
	chatbotCreated(e, t) {
		return this.track(new Tl(e), t);
	}
	chatbotDeleteModalOpened(e) {
		return this.track(new El(), e);
	}
	chatbotDeleted(e, t) {
		return this.track(new Dl(e), t);
	}
	chatbotEditIdentityModalOpened(e) {
		return this.track(new Ol(), e);
	}
	chatbotIdentityEdited(e) {
		return this.track(new kl(), e);
	}
	colorModeUpdated(e, t) {
		return this.track(new Al(e), t);
	}
	commandExecuted(e, t) {
		return this.track(new jl(e), t);
	}
	commandPaletteActionSelected(e, t) {
		return this.track(new Ml(e), t);
	}
	commandPaletteClosed(e, t) {
		return this.track(new Nl(e), t);
	}
	commandPaletteOpened(e, t) {
		return this.track(new Pl(e), t);
	}
	companyModalFormSubmitted(e, t) {
		return this.track(new Fl(e), t);
	}
	contactsAddNewCompanyClicked(e) {
		return this.track(new Il(), e);
	}
	contactsAddNewContactClicked(e) {
		return this.track(new Ll(), e);
	}
	contactsBanUserClicked(e, t) {
		return this.track(new Rl(e), t);
	}
	contactsCardActionsMenuOpened(e) {
		return this.track(new zl(), e);
	}
	contactsCardComposeNewEmailClicked(e) {
		return this.track(new Bl(), e);
	}
	contactsCardEditCompanyClicked(e) {
		return this.track(new Vl(), e);
	}
	contactsCardEditContactClicked(e) {
		return this.track(new Hl(), e);
	}
	contactsCardMakeCallClicked(e) {
		return this.track(new Ul(), e);
	}
	contactsCardSeeAllAssignedConversationsClicked(e) {
		return this.track(new Wl(), e);
	}
	contactsCardSeeAllConversationsClicked(e) {
		return this.track(new Gl(), e);
	}
	contactsCardViewCompanyClicked(e) {
		return this.track(new Kl(), e);
	}
	contactsCardViewUserClicked(e) {
		return this.track(new ql(), e);
	}
	contactsSearchBlurred(e) {
		return this.track(new Jl(), e);
	}
	contactsSearchFocused(e) {
		return this.track(new Yl(), e);
	}
	contactsUnbanUserClicked(e, t) {
		return this.track(new Xl(e), t);
	}
	contactsViewCompanies(e) {
		return this.track(new Zl(), e);
	}
	contactsViewEndUsers(e) {
		return this.track(new Ql(), e);
	}
	conversationActionsMenuOpened(e) {
		return this.track(new $l(), e);
	}
	conversationActionsMenuOptionClicked(e, t) {
		return this.track(new eu(e), t);
	}
	conversationActivityLogClosed(e) {
		return this.track(new tu(), e);
	}
	conversationActivityLogFlooterExpanded(e) {
		return this.track(new nu(), e);
	}
	conversationActivityLogOpened(e, t) {
		return this.track(new ru(e), t);
	}
	conversationArticleDraftImprovementRequested(e, t) {
		return this.track(new iu(e), t);
	}
	conversationArticleDraftImprovementResponseReceived(e, t) {
		return this.track(new au(e), t);
	}
	conversationArticleDraftPreviewRequested(e, t) {
		return this.track(new ou(e), t);
	}
	conversationArticleDraftPreviewResponseReceived(e, t) {
		return this.track(new su(e), t);
	}
	conversationArticleDraftSaveRequested(e, t) {
		return this.track(new cu(e), t);
	}
	conversationArticleDraftSaveResponseReceived(e, t) {
		return this.track(new lu(e), t);
	}
	conversationAttachedImageIsDownloaded(e) {
		return this.track(new uu(), e);
	}
	conversationAttachedImageIsViewed(e) {
		return this.track(new du(), e);
	}
	conversationClaimed(e, t) {
		return this.track(new fu(e), t);
	}
	conversationClosed(e, t) {
		return this.track(new pu(e), t);
	}
	conversationCsatCancelled(e) {
		return this.track(new mu(), e);
	}
	conversationCsatMenuCancelOptionClicked(e) {
		return this.track(new hu(), e);
	}
	conversationCsatMenuLanguageSelected(e, t) {
		return this.track(new gu(e), t);
	}
	conversationCsatMenuOpened(e) {
		return this.track(new _u(), e);
	}
	conversationFocusModeToggled(e, t) {
		return this.track(new vu(e), t);
	}
	conversationFollowUp(e, t) {
		return this.track(new yu(e), t);
	}
	conversationFollowUpMenuOpened(e) {
		return this.track(new bu(), e);
	}
	conversationFollowUpMenuOptionClicked(e, t) {
		return this.track(new xu(e), t);
	}
	conversationHeaderConversationDetailsMenuOpened(e) {
		return this.track(new Su(), e);
	}
	conversationHeaderTagAdded(e, t) {
		return this.track(new Cu(e), t);
	}
	conversationHeaderTagIncludeDeactivatedToggled(e, t) {
		return this.track(new wu(e), t);
	}
	conversationHeaderTagMenuOpened(e) {
		return this.track(new Tu(), e);
	}
	conversationHeaderTagRemoved(e, t) {
		return this.track(new Eu(e), t);
	}
	conversationHeaderTransferToAgentItemSelected(e) {
		return this.track(new Du(), e);
	}
	conversationHeaderTransferToAgentMenuOpened(e) {
		return this.track(new Ou(), e);
	}
	conversationHeaderTransferToNumberButtonClicked(e) {
		return this.track(new ku(), e);
	}
	conversationHeaderTransferToQueueItemSelected(e, t) {
		return this.track(new Au(e), t);
	}
	conversationHeaderTransferToQueueMenuOpened(e) {
		return this.track(new ju(), e);
	}
	conversationInternalNoteEditorOpened(e) {
		return this.track(new Mu(), e);
	}
	conversationMessageRedactionModalOpened(e) {
		return this.track(new Nu(), e);
	}
	conversationMessageRedactionModalSubmitted(e) {
		return this.track(new Pu(), e);
	}
	conversationOffered(e, t) {
		return this.track(new Fu(e), t);
	}
	conversationReplied(e, t) {
		return this.track(new Iu(e), t);
	}
	conversationReplyWindowToggled(e, t) {
		return this.track(new Lu(e), t);
	}
	conversationResolvedAsAKnowledgeArticleDraft(e, t) {
		return this.track(new Ru(e), t);
	}
	conversationResolvedAsAKnowledgeGap(e, t) {
		return this.track(new zu(e), t);
	}
	conversationResolvedByKnowledge(e, t) {
		return this.track(new Bu(e), t);
	}
	conversationResolvedWithNoKnowledgeArticle(e, t) {
		return this.track(new Vu(e), t);
	}
	conversationRightSidebarItemReordered(e, t) {
		return this.track(new Hu(e), t);
	}
	conversationRightSidebarItemVisibilityToggled(e, t) {
		return this.track(new Uu(e), t);
	}
	conversationSidebarAdminConfigurationSaved(e) {
		return this.track(new Wu(), e);
	}
	conversationSidebarClosed(e) {
		return this.track(new Gu(), e);
	}
	conversationSidebarConversationHistoryClosed(e) {
		return this.track(new Ku(), e);
	}
	conversationSidebarConversationHistoryNavigatedToConversation(e) {
		return this.track(new qu(), e);
	}
	conversationSidebarConversationHistoryOpened(e) {
		return this.track(new Ju(), e);
	}
	conversationSidebarCustomerInfoEmailClicked(e) {
		return this.track(new Yu(), e);
	}
	conversationSidebarCustomerInfoPhoneNumberClicked(e) {
		return this.track(new Xu(), e);
	}
	conversationSidebarOpened(e) {
		return this.track(new Zu(), e);
	}
	conversationTimelineItemOpened(e) {
		return this.track(new Qu(), e);
	}
	conversationTimelineNavigatedToConversation(e) {
		return this.track(new $u(), e);
	}
	conversationTransferred(e, t) {
		return this.track(new ed(e), t);
	}
	conversationsBulkActionsClicked(e, t) {
		return this.track(new td(e), t);
	}
	conversationsClearAllClicked(e) {
		return this.track(new nd(), e);
	}
	conversationsFilterAgentClicked(e, t) {
		return this.track(new rd(e), t);
	}
	conversationsFilterClearAllClicked(e) {
		return this.track(new id(), e);
	}
	conversationsFilterCleared(e, t) {
		return this.track(new ad(e), t);
	}
	conversationsFilterContactClicked(e, t) {
		return this.track(new od(e), t);
	}
	conversationsFilterToggled(e, t) {
		return this.track(new sd(e), t);
	}
	conversationsGoToConversationClicked(e, t) {
		return this.track(new cd(e), t);
	}
	conversationsItemPreviewClicked(e) {
		return this.track(new ld(), e);
	}
	conversationsNextPageClicked(e) {
		return this.track(new ud(), e);
	}
	conversationsPreviousPageClicked(e) {
		return this.track(new dd(), e);
	}
	conversationsSelectAllClicked(e) {
		return this.track(new fd(), e);
	}
	conversationsSelectClicked(e, t) {
		return this.track(new pd(e), t);
	}
	conversationsTimestampClicked(e, t) {
		return this.track(new md(e), t);
	}
	conversationsTransferToQueueClicked(e) {
		return this.track(new hd(), e);
	}
	conversationsViewAgentClicked(e) {
		return this.track(new gd(), e);
	}
	conversationsViewContactClicked(e) {
		return this.track(new _d(), e);
	}
	conversationSummaryFeedbackNotUseful(e, t) {
		return this.track(new vd(e), t);
	}
	conversationSummaryFeedbackUseful(e, t) {
		return this.track(new yd(e), t);
	}
	conversationSummaryRegenerateSummary(e, t) {
		return this.track(new bd(e), t);
	}
	copyScript(e) {
		return this.track(new xd(), e);
	}
	countryCodeSelected(e) {
		return this.track(new Sd(), e);
	}
	customAttributeValueUpdated(e, t) {
		return this.track(new Cd(e), t);
	}
	dashboardChannelAllConversationsClicked(e) {
		return this.track(new wd(), e);
	}
	dashboardChannelGoToAnalyticsClicked(e) {
		return this.track(new Td(), e);
	}
	dashboardChannelLongestQueuedTimeMetricClicked(e) {
		return this.track(new Ed(), e);
	}
	dashboardChannelNameClicked(e) {
		return this.track(new Dd(), e);
	}
	dashboardChannelPendingConversationsMetricClicked(e, t) {
		return this.track(new Od(e), t);
	}
	dashboardChannelTvDashboardClicked(e) {
		return this.track(new kd(), e);
	}
	dashboardFavoriteCreated(e, t) {
		return this.track(new Ad(e), t);
	}
	dashboardFavoriteDeleted(e, t) {
		return this.track(new jd(e), t);
	}
	dashboardFavoriteLandingPageSet(e, t) {
		return this.track(new Md(e), t);
	}
	dashboardFavoriteLandingPageUnset(e, t) {
		return this.track(new Nd(e), t);
	}
	dashboardFavoriteOwnershipTransferred(e) {
		return this.track(new Pd(), e);
	}
	dashboardFavoriteQueuesReordered(e) {
		return this.track(new Fd(), e);
	}
	dashboardFavoriteSharingToggled(e, t) {
		return this.track(new Id(e), t);
	}
	dashboardFavoriteTvDashboardClicked(e) {
		return this.track(new Ld(), e);
	}
	dashboardFavoriteUpdated(e, t) {
		return this.track(new Rd(e), t);
	}
	dashboardFavoriteViewed(e, t) {
		return this.track(new zd(e), t);
	}
	dashboardGlobalTvDashboardClicked(e) {
		return this.track(new Bd(), e);
	}
	dashboardLayoutChanged(e, t) {
		return this.track(new Vd(e), t);
	}
	dashboardLongestQueuedTimeMetricClicked(e, t) {
		return this.track(new Hd(e), t);
	}
	dashboardMetricHelperClicked(e, t) {
		return this.track(new Ud(e), t);
	}
	dashboardNextPageClicked(e) {
		return this.track(new Wd(), e);
	}
	dashboardOrganizationTimezoneSettingsClicked(e) {
		return this.track(new Gd(), e);
	}
	dashboardPreviousPageClicked(e) {
		return this.track(new Kd(), e);
	}
	dashboardQueueAllConversationsClicked(e) {
		return this.track(new qd(), e);
	}
	dashboardQueueGoToAnalyticsClicked(e) {
		return this.track(new Jd(), e);
	}
	dashboardQueueItemFavoriteToggled(e, t) {
		return this.track(new Yd(e), t);
	}
	dashboardQueueNameClicked(e) {
		return this.track(new Xd(), e);
	}
	dashboardQueuePendingConversationsMetricClicked(e, t) {
		return this.track(new Zd(e), t);
	}
	dashboardQueueSettingsClicked(e) {
		return this.track(new Qd(), e);
	}
	dashboardQueueTvDashboardClicked(e) {
		return this.track(new $d(), e);
	}
	dashboardQueuesManuallySelected(e, t) {
		return this.track(new ef(e), t);
	}
	dashboardQueuesSearchFieldCleared(e, t) {
		return this.track(new tf(e), t);
	}
	dashboardQueuesSearchFieldSubmitted(e, t) {
		return this.track(new nf(e), t);
	}
	dashboardQueuesSortingUpdated(e, t) {
		return this.track(new rf(e), t);
	}
	dashboardQueuesTypeChanged(e, t) {
		return this.track(new af(e), t);
	}
	dashboardRefreshDataClicked(e) {
		return this.track(new of(), e);
	}
	dashboardTvReloaded(e, t) {
		return this.track(new sf(e), t);
	}
	dashboardViewed(e, t) {
		return this.track(new cf(e), t);
	}
	emailFlowOptionsMenuOptionAuditLogClicked(e) {
		return this.track(new lf(), e);
	}
	emailFormSubmitted(e, t) {
		return this.track(new uf(e), t);
	}
	emailOptionsMenuOpened(e) {
		return this.track(new df(), e);
	}
	emailOptionsMenuOptionDeleteClicked(e) {
		return this.track(new ff(), e);
	}
	emailOptionsMenuOptionDuplicateClicked(e) {
		return this.track(new pf(), e);
	}
	emailOptionsMenuOptionEmailClicked(e) {
		return this.track(new mf(), e);
	}
	emailOptionsMenuOptionFlowClicked(e) {
		return this.track(new hf(), e);
	}
	emailOptionsMenuOptionRenameClicked(e) {
		return this.track(new gf(), e);
	}
	emailSearchApplied(e) {
		return this.track(new _f(), e);
	}
	emailSearchClosed(e) {
		return this.track(new vf(), e);
	}
	emailSearchOpened(e) {
		return this.track(new yf(), e);
	}
	flowActionAddSaved(e, t) {
		return this.track(new bf(e), t);
	}
	flowActionConditionAdded(e, t) {
		return this.track(new xf(e), t);
	}
	flowActionConditionRemoved(e, t) {
		return this.track(new Sf(e), t);
	}
	flowActionDeleted(e, t) {
		return this.track(new Cf(e), t);
	}
	flowActionEditClicked(e, t) {
		return this.track(new wf(e), t);
	}
	flowActionEditSaved(e, t) {
		return this.track(new Tf(e), t);
	}
	flowActivateClicked(e, t) {
		return this.track(new Ef(e), t);
	}
	flowAddActionActionSelected(e, t) {
		return this.track(new Df(e), t);
	}
	flowAddActionCancelled(e, t) {
		return this.track(new Of(e), t);
	}
	flowAddActionOpened(e, t) {
		return this.track(new kf(e), t);
	}
	flowBackToSettingsClicked(e, t) {
		return this.track(new Af(e), t);
	}
	flowContextAlignClicked(e, t) {
		return this.track(new jf(e), t);
	}
	flowContextDeleteCancelClicked(e, t) {
		return this.track(new Mf(e), t);
	}
	flowContextDeleteClicked(e, t) {
		return this.track(new Nf(e), t);
	}
	flowContextDeleteConfirmClicked(e, t) {
		return this.track(new Pf(e), t);
	}
	flowContextNodeArrangeClicked(e, t) {
		return this.track(new Ff(e), t);
	}
	flowPhoneNumberChanged(e) {
		return this.track(new If(), e);
	}
	flowSaveClicked(e, t) {
		return this.track(new Lf(e), t);
	}
	flowTitleEditClicked(e, t) {
		return this.track(new Rf(e), t);
	}
	flowZoomInClicked(e, t) {
		return this.track(new zf(e), t);
	}
	flowZoomOutClicked(e, t) {
		return this.track(new Bf(e), t);
	}
	flowZoomResetClicked(e, t) {
		return this.track(new Vf(e), t);
	}
	followUpConversationModalInternalNoteAdded(e) {
		return this.track(new Hf(), e);
	}
	followUpConversationModalOfferInQueueAdded(e) {
		return this.track(new Uf(), e);
	}
	intelligenceDashboardViewed(e, t) {
		return this.track(new Wf(e), t);
	}
	intelligenceDistributionChartOpened(e, t) {
		return this.track(new Gf(e), t);
	}
	intelligenceEvolutionChartOpened(e, t) {
		return this.track(new Kf(e), t);
	}
	intelligenceFilterChanged(e, t) {
		return this.track(new qf(e), t);
	}
	intelligenceFilterPeriodChanged(e, t) {
		return this.track(new Jf(e), t);
	}
	intelligenceGroupByChanged(e, t) {
		return this.track(new Yf(e), t);
	}
	intelligencePresetComparisonStarted(e, t) {
		return this.track(new Xf(e), t);
	}
	intelligenceTableCustomized(e, t) {
		return this.track(new Zf(e), t);
	}
	intentDetectionCreated(e) {
		return this.track(new Qf(), e);
	}
	intentDetectionDeleted(e) {
		return this.track(new $f(), e);
	}
	intentDetectionFlowNodeSaved(e, t) {
		return this.track(new ep(e), t);
	}
	intentDetectionUpdated(e) {
		return this.track(new tp(), e);
	}
	knowledgeArticleArchived(e, t) {
		return this.track(new np(e), t);
	}
	knowledgeArticleChangesDiscarded(e, t) {
		return this.track(new rp(e), t);
	}
	knowledgeArticleCreated(e, t) {
		return this.track(new ip(e), t);
	}
	knowledgeArticleDestroyed(e, t) {
		return this.track(new ap(e), t);
	}
	knowledgeArticleFeedbackSubmitted(e, t) {
		return this.track(new op(e), t);
	}
	knowledgeArticleMarkedAsHelpful(e, t) {
		return this.track(new sp(e), t);
	}
	knowledgeArticleMoved(e, t) {
		return this.track(new cp(e), t);
	}
	knowledgeArticlePublished(e, t) {
		return this.track(new lp(e), t);
	}
	knowledgeArticleReordered(e, t) {
		return this.track(new up(e), t);
	}
	knowledgeArticleRestored(e) {
		return this.track(new dp(), e);
	}
	knowledgeArticleTagAdded(e, t) {
		return this.track(new fp(e), t);
	}
	knowledgeArticleTagRemoved(e, t) {
		return this.track(new pp(e), t);
	}
	knowledgeArticleUnpublished(e, t) {
		return this.track(new mp(e), t);
	}
	knowledgeArticleUpdated(e, t) {
		return this.track(new hp(e), t);
	}
	knowledgeArticleVersionHistoryClicked(e) {
		return this.track(new gp(), e);
	}
	knowledgeArticleViewed(e, t) {
		return this.track(new _p(e), t);
	}
	knowledgeArticlesSearchByTermSubmitted(e, t) {
		return this.track(new vp(e), t);
	}
	knowledgeCategoryCreated(e, t) {
		return this.track(new yp(e), t);
	}
	knowledgeCategoryDestroyed(e, t) {
		return this.track(new bp(e), t);
	}
	knowledgeCategoryReordered(e, t) {
		return this.track(new xp(e), t);
	}
	knowledgeCategoryUpdated(e, t) {
		return this.track(new Sp(e), t);
	}
	knowledgeCollectionCreated(e, t) {
		return this.track(new Cp(e), t);
	}
	knowledgeCollectionDestroyed(e, t) {
		return this.track(new wp(e), t);
	}
	knowledgeCollectionUpdated(e, t) {
		return this.track(new Tp(e), t);
	}
	knowledgeCollectionViewed(e, t) {
		return this.track(new Ep(e), t);
	}
	knowledgeHelpCenterCreated(e, t) {
		return this.track(new Dp(e), t);
	}
	knowledgeHelpCenterDeleted(e, t) {
		return this.track(new Op(e), t);
	}
	knowledgeHelpCenterUpdated(e, t) {
		return this.track(new kp(e), t);
	}
	knowledgeInternalKbDashboardViewed(e) {
		return this.track(new Ap(), e);
	}
	knowledgeInternalKbSearchResultClicked(e, t) {
		return this.track(new jp(e), t);
	}
	knowledgeResolutionCancelled(e, t) {
		return this.track(new Mp(e), t);
	}
	knowledgeResolutionInitialised(e, t) {
		return this.track(new Np(e), t);
	}
	knowledgeRetranslateArticleBlockClicked(e, t) {
		return this.track(new Pp(e), t);
	}
	knowledgeRetranslateArticleTitleClicked(e, t) {
		return this.track(new Fp(e), t);
	}
	knowledgeTranslateArticleClicked(e, t) {
		return this.track(new Ip(e), t);
	}
	linkConversationsModalOpened(e) {
		return this.track(new Lp(), e);
	}
	linkConversationsSubmitted(e) {
		return this.track(new Rp(), e);
	}
	mentionUserNotificationClicked(e) {
		return this.track(new zp(), e);
	}
	mentionUserSelected(e) {
		return this.track(new Bp(), e);
	}
	mergeContactsMergeCancelled(e) {
		return this.track(new Vp(), e);
	}
	mergeContactsMergeFailed(e) {
		return this.track(new Hp(), e);
	}
	mergeContactsMergeSucceeded(e, t) {
		return this.track(new Up(e), t);
	}
	mergeContactsModalClosed(e) {
		return this.track(new Wp(), e);
	}
	mergeContactsModalOpened(e) {
		return this.track(new Gp(), e);
	}
	mergeContactsSourceContactSelected(e) {
		return this.track(new Kp(), e);
	}
	messengerFlowOptionsMenuOptionAuditLogClicked(e) {
		return this.track(new qp(), e);
	}
	messengerFormCancelled(e, t) {
		return this.track(new Jp(e), t);
	}
	messengerFormOpened(e, t) {
		return this.track(new Yp(e), t);
	}
	messengerFormSubmitted(e, t) {
		return this.track(new Xp(e), t);
	}
	messengerOptionsMenuOpened(e) {
		return this.track(new Zp(), e);
	}
	messengerOptionsMenuOptionClicked(e, t) {
		return this.track(new Qp(e), t);
	}
	modalConversationCloseCancelClicked(e) {
		return this.track(new $p(), e);
	}
	modalConversationCloseConfirmClicked(e, t) {
		return this.track(new em(e), t);
	}
	modalTransferToQueueCancelClicked(e) {
		return this.track(new tm(), e);
	}
	modalTransferToQueueConfirmClicked(e, t) {
		return this.track(new nm(e), t);
	}
	networkConnectionStatusChanged(e, t) {
		return this.track(new rm(e), t);
	}
	notificationOfferAccepted(e, t) {
		return this.track(new im(e), t);
	}
	notificationOfferClosed(e, t) {
		return this.track(new am(e), t);
	}
	notificationOfferRejected(e, t) {
		return this.track(new om(e), t);
	}
	notificationOfferTimeout(e) {
		return this.track(new sm(), e);
	}
	notificationTransferOfferAccepted(e, t) {
		return this.track(new cm(e), t);
	}
	notificationTransferOfferClosed(e, t) {
		return this.track(new lm(e), t);
	}
	notificationTransferOfferRejected(e, t) {
		return this.track(new um(e), t);
	}
	notificationTransferOfferTimeout(e) {
		return this.track(new dm(), e);
	}
	organizationsNavigationOrganizationClicked(e, t) {
		return this.track(new fm(e), t);
	}
	partnerIntegrationsBrazeProfileReceived(e) {
		return this.track(new pm(), e);
	}
	partnerIntegrationsBrazeSubscriptionEmailOptInSucceeded(e) {
		return this.track(new mm(), e);
	}
	partnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded(e) {
		return this.track(new hm(), e);
	}
	partnerIntegrationsConditionCreated(e, t) {
		return this.track(new gm(e), t);
	}
	partnerIntegrationsConditionDeleted(e) {
		return this.track(new _m(), e);
	}
	partnerIntegrationsConditionUpdated(e, t) {
		return this.track(new vm(e), t);
	}
	partnerIntegrationsGithubCreateNewIssueCanceled(e, t) {
		return this.track(new ym(e), t);
	}
	partnerIntegrationsGithubCreateNewIssueClicked(e, t) {
		return this.track(new bm(e), t);
	}
	partnerIntegrationsGithubCreateNewIssueConfirmed(e, t) {
		return this.track(new xm(e), t);
	}
	partnerIntegrationsGithubLinkIssueClicked(e, t) {
		return this.track(new Sm(e), t);
	}
	partnerIntegrationsGithubUnlinkAllIssuesCanceled(e, t) {
		return this.track(new Cm(e), t);
	}
	partnerIntegrationsGithubUnlinkAllIssuesClicked(e, t) {
		return this.track(new wm(e), t);
	}
	partnerIntegrationsGithubUnlinkAllIssuesConfirmed(e, t) {
		return this.track(new Tm(e), t);
	}
	partnerIntegrationsGithubUnlinkIssueCanceled(e, t) {
		return this.track(new Em(e), t);
	}
	partnerIntegrationsGithubUnlinkIssueClicked(e, t) {
		return this.track(new Dm(e), t);
	}
	partnerIntegrationsGithubUnlinkIssueConfirmed(e, t) {
		return this.track(new Om(e), t);
	}
	partnerIntegrationsGithubViewLinkClicked(e, t) {
		return this.track(new km(e), t);
	}
	partnerIntegrationsJiraCommentsCollapsed(e, t) {
		return this.track(new Am(e), t);
	}
	partnerIntegrationsJiraCommentsExpanded(e, t) {
		return this.track(new jm(e), t);
	}
	partnerIntegrationsJiraCreateIssueFailed(e, t) {
		return this.track(new Mm(e), t);
	}
	partnerIntegrationsJiraCreateIssueSucceeded(e, t) {
		return this.track(new Nm(e), t);
	}
	partnerIntegrationsJiraLinkIssueClicked(e, t) {
		return this.track(new Pm(e), t);
	}
	partnerIntegrationsJiraOpenIssueClicked(e, t) {
		return this.track(new Fm(e), t);
	}
	partnerIntegrationsJiraOpenJiraClicked(e, t) {
		return this.track(new Im(e), t);
	}
	partnerIntegrationsJiraRemoveAllDanglingClicked(e, t) {
		return this.track(new Lm(e), t);
	}
	partnerIntegrationsJiraRemoveDanglingIssueClicked(e, t) {
		return this.track(new Rm(e), t);
	}
	partnerIntegrationsJiraUnlinkAllIssuesCancelled(e, t) {
		return this.track(new zm(e), t);
	}
	partnerIntegrationsJiraUnlinkAllIssuesClicked(e, t) {
		return this.track(new Bm(e), t);
	}
	partnerIntegrationsJiraUnlinkAllIssuesConfirmed(e, t) {
		return this.track(new Vm(e), t);
	}
	partnerIntegrationsJiraUnlinkIssueCancelled(e, t) {
		return this.track(new Hm(e), t);
	}
	partnerIntegrationsJiraUnlinkIssueClicked(e, t) {
		return this.track(new Um(e), t);
	}
	partnerIntegrationsJiraUnlinkIssueConfirmed(e, t) {
		return this.track(new Wm(e), t);
	}
	partnerIntegrationsKlaviyoMessagesReceived(e, t) {
		return this.track(new Gm(e), t);
	}
	partnerIntegrationsKlaviyoProfileFailed(e, t) {
		return this.track(new Km(e), t);
	}
	partnerIntegrationsKlaviyoProfileReceived(e, t) {
		return this.track(new qm(e), t);
	}
	partnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked(e, t) {
		return this.track(new Jm(e), t);
	}
	partnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed(e, t) {
		return this.track(new Ym(e), t);
	}
	partnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded(e, t) {
		return this.track(new Xm(e), t);
	}
	partnerIntegrationsKlaviyoProfileUnsubscribeClicked(e, t) {
		return this.track(new Zm(e), t);
	}
	partnerIntegrationsKlaviyoProfileUnsubscribeFailed(e, t) {
		return this.track(new Qm(e), t);
	}
	partnerIntegrationsKlaviyoProfileUnsubscribeSucceeded(e, t) {
		return this.track(new $m(e), t);
	}
	partnerIntegrationsLinearCreateNewIssueCancelled(e, t) {
		return this.track(new eh(e), t);
	}
	partnerIntegrationsLinearCreateNewIssueClicked(e, t) {
		return this.track(new th(e), t);
	}
	partnerIntegrationsLinearCreateNewIssueConfirmed(e, t) {
		return this.track(new nh(e), t);
	}
	partnerIntegrationsLinearLinkIssueClicked(e, t) {
		return this.track(new rh(e), t);
	}
	partnerIntegrationsLinearOpenIssueClicked(e, t) {
		return this.track(new ih(e), t);
	}
	partnerIntegrationsLinearOpenLinearClicked(e, t) {
		return this.track(new ah(e), t);
	}
	partnerIntegrationsLinearUnlinkIssueClicked(e, t) {
		return this.track(new oh(e), t);
	}
	partnerIntegrationsRechargeWidgetCustomerOverviewOpened(e) {
		return this.track(new sh(), e);
	}
	partnerIntegrationsRechargeWidgetOrderOpened(e) {
		return this.track(new ch(), e);
	}
	partnerIntegrationsRechargeWidgetOrdersListOpened(e) {
		return this.track(new lh(), e);
	}
	partnerIntegrationsRechargeWidgetProfileReceived(e) {
		return this.track(new uh(), e);
	}
	partnerIntegrationsRechargeWidgetSubscriptionCancelled(e) {
		return this.track(new dh(), e);
	}
	partnerIntegrationsRechargeWidgetSubscriptionOpened(e) {
		return this.track(new fh(), e);
	}
	partnerIntegrationsRechargeWidgetSubscriptionReactivated(e) {
		return this.track(new ph(), e);
	}
	partnerIntegrationsRechargeWidgetSubscriptionSkipped(e) {
		return this.track(new mh(), e);
	}
	partnerIntegrationsRechargeWidgetSubscriptionSwapped(e) {
		return this.track(new hh(), e);
	}
	partnerIntegrationsRechargeWidgetSubscriptionsListOpened(e) {
		return this.track(new gh(), e);
	}
	partnerIntegrationsRivoLoyaltyWidgetCustomerClicked(e) {
		return this.track(new _h(), e);
	}
	partnerIntegrationsRivoLoyaltyWidgetCustomerReceived(e) {
		return this.track(new vh(), e);
	}
	partnerIntegrationsRivoLoyaltyWidgetPointsAddFailed(e) {
		return this.track(new yh(), e);
	}
	partnerIntegrationsRivoLoyaltyWidgetPointsAddSucceeded(e) {
		return this.track(new bh(), e);
	}
	partnerIntegrationsRivoLoyaltyWidgetPointsRemoveFailed(e) {
		return this.track(new xh(), e);
	}
	partnerIntegrationsRivoLoyaltyWidgetPointsRemoveSucceeded(e) {
		return this.track(new Sh(), e);
	}
	partnerIntegrationsSettingsCreateSubmitted(e, t) {
		return this.track(new Ch(e), t);
	}
	partnerIntegrationsSettingsOverviewCreated(e, t) {
		return this.track(new wh(e), t);
	}
	partnerIntegrationsSettingsOverviewViewed(e, t) {
		return this.track(new Th(e), t);
	}
	partnerIntegrationsSettingsViewDeleteCanceled(e, t) {
		return this.track(new Eh(e), t);
	}
	partnerIntegrationsSettingsViewDeleteConfirmed(e, t) {
		return this.track(new Dh(e), t);
	}
	partnerIntegrationsSettingsViewDeleteRequested(e, t) {
		return this.track(new Oh(e), t);
	}
	partnerIntegrationsSettingsViewOAuthStarted(e, t) {
		return this.track(new kh(e), t);
	}
	partnerIntegrationsSettingsViewOAuthSucceeded(e, t) {
		return this.track(new Ah(e), t);
	}
	partnerIntegrationsSettingsViewSubmitted(e, t) {
		return this.track(new jh(e), t);
	}
	partnerIntegrationsShopifyWidgetCreateDraftOrderFailed(e) {
		return this.track(new Mh(), e);
	}
	partnerIntegrationsShopifyWidgetCreateDraftOrderSucceeded(e) {
		return this.track(new Nh(), e);
	}
	partnerIntegrationsShopifyWidgetCreateOrderFailed(e) {
		return this.track(new Ph(), e);
	}
	partnerIntegrationsShopifyWidgetCreateOrderSucceeded(e) {
		return this.track(new Fh(), e);
	}
	partnerIntegrationsShopifyWidgetDiscountCodeCreated(e) {
		return this.track(new Ih(), e);
	}
	partnerIntegrationsShopifyWidgetDuplicateOrderFailed(e) {
		return this.track(new Lh(), e);
	}
	partnerIntegrationsShopifyWidgetDuplicateOrderSucceeded(e) {
		return this.track(new Rh(), e);
	}
	partnerIntegrationsShopifyWidgetOrderCancelled(e) {
		return this.track(new zh(), e);
	}
	partnerIntegrationsShopifyWidgetOrderCollapseClosed(e, t) {
		return this.track(new Bh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderCollapseOpened(e, t) {
		return this.track(new Vh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled(e, t) {
		return this.track(new Hh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened(e, t) {
		return this.track(new Uh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted(e, t) {
		return this.track(new Wh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderRefundCanceled(e, t) {
		return this.track(new Gh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderRefundConfirmed(e, t) {
		return this.track(new Kh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderRefundRequested(e, t) {
		return this.track(new qh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderTagsUpdated(e) {
		return this.track(new Jh(), e);
	}
	partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked(e, t) {
		return this.track(new Yh(e), t);
	}
	partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked(e, t) {
		return this.track(new Xh(e), t);
	}
	partnerIntegrationsShopifyWidgetProfileCreated(e) {
		return this.track(new Zh(), e);
	}
	partnerIntegrationsShopifyWidgetRefreshed(e, t) {
		return this.track(new Qh(e), t);
	}
	partnerIntegrationsShopifyWidgetRefundPartialOrderFailed(e) {
		return this.track(new $h(), e);
	}
	partnerIntegrationsShopifyWidgetRefundPartialOrderSucceeded(e) {
		return this.track(new eg(), e);
	}
	partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked(e, t) {
		return this.track(new tg(e), t);
	}
	partnerIntegrationsVoyadoWidgetChannelSubscriptionClicked(e, t) {
		return this.track(new ng(e), t);
	}
	partnerIntegrationsVoyadoWidgetChannelSubscriptionFailed(e, t) {
		return this.track(new rg(e), t);
	}
	partnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded(e, t) {
		return this.track(new ig(e), t);
	}
	partnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked(e, t) {
		return this.track(new ag(e), t);
	}
	partnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed(e, t) {
		return this.track(new og(e), t);
	}
	partnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded(e, t) {
		return this.track(new sg(e), t);
	}
	partnerIntegrationsVoyadoWidgetMessageExternalLinkOpened(e, t) {
		return this.track(new cg(e), t);
	}
	partnerIntegrationsVoyadoWidgetMessagesReceived(e, t) {
		return this.track(new lg(e), t);
	}
	partnerIntegrationsVoyadoWidgetOrdersReceived(e, t) {
		return this.track(new ug(e), t);
	}
	partnerIntegrationsVoyadoWidgetProfileReceived(e, t) {
		return this.track(new dg(e), t);
	}
	partnerIntegrationsVoyadoWidgetTransactionsReceived(e, t) {
		return this.track(new fg(e), t);
	}
	partnerIntegrationsWidgetCollapseClosed(e, t) {
		return this.track(new pg(e), t);
	}
	partnerIntegrationsWidgetCollapseOpened(e, t) {
		return this.track(new mg(e), t);
	}
	partnerIntegrationsWidgetLoyaltyLionAddPointsFailed(e) {
		return this.track(new hg(), e);
	}
	partnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded(e) {
		return this.track(new gg(), e);
	}
	partnerIntegrationsWidgetLoyaltyLionCustomerReceived(e) {
		return this.track(new _g(), e);
	}
	partnerIntegrationsWidgetLoyaltyLionRemovePointsFailed(e) {
		return this.track(new vg(), e);
	}
	partnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded(e) {
		return this.track(new yg(), e);
	}
	partnerIntegrationsWidgetVoyadoUpdatePointsFailed(e) {
		return this.track(new bg(), e);
	}
	partnerIntegrationsWidgetVoyadoUpdatePointsSucceeded(e) {
		return this.track(new xg(), e);
	}
	phoneActionsMenuActionAddOutboundCallerIdClicked(e) {
		return this.track(new Sg(), e);
	}
	phoneActionsMenuActionChangeHoldMusicClicked(e) {
		return this.track(new Cg(), e);
	}
	phoneActionsMenuOpened(e) {
		return this.track(new wg(), e);
	}
	phoneAddOutboundCallerIdFormCancelled(e) {
		return this.track(new Tg(), e);
	}
	phoneAddOutboundCallerIdFormSubmitted(e) {
		return this.track(new Eg(), e);
	}
	phoneChangeHoldMusicFormCancelled(e) {
		return this.track(new Dg(), e);
	}
	phoneChangeHoldMusicFormSubmitted(e) {
		return this.track(new Og(), e);
	}
	phoneCreateFlowFormCancelled(e) {
		return this.track(new kg(), e);
	}
	phoneCreateFlowFormSubmitted(e) {
		return this.track(new Ag(), e);
	}
	phoneFlowOptionsMenuOptionAuditLogClicked(e) {
		return this.track(new jg(), e);
	}
	phoneFlowOptionsMenuOptionDeleteClicked(e) {
		return this.track(new Mg(), e);
	}
	phoneFlowOptionsMenuOptionDuplicateClicked(e) {
		return this.track(new Ng(), e);
	}
	phoneFlowOptionsMenuOptionEditClicked(e) {
		return this.track(new Pg(), e);
	}
	phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked(e) {
		return this.track(new Fg(), e);
	}
	phoneFlowOptionsMenuOptionOpened(e) {
		return this.track(new Ig(), e);
	}
	phoneFlowOptionsMenuOptionRenameClicked(e) {
		return this.track(new Lg(), e);
	}
	phoneFormCancelled(e) {
		return this.track(new Rg(), e);
	}
	phoneFormOpened(e) {
		return this.track(new zg(), e);
	}
	phoneFormSubmitted(e) {
		return this.track(new Bg(), e);
	}
	phoneOptionsMenuOpened(e) {
		return this.track(new Vg(), e);
	}
	phoneOptionsMenuOptionCreateFlowClicked(e) {
		return this.track(new Hg(), e);
	}
	phoneOptionsMenuOptionEditClicked(e) {
		return this.track(new Ug(), e);
	}
	phoneOptionsMenuOptionRemoveNumberClicked(e) {
		return this.track(new Wg(), e);
	}
	phoneOptionsMenuOptionSetDefaultCallerIdClicked(e) {
		return this.track(new Gg(), e);
	}
	phoneOptionsMenuOptionSetupClicked(e) {
		return this.track(new Kg(), e);
	}
	phoneRecordingDownloaded(e, t) {
		return this.track(new qg(e), t);
	}
	phoneRecordingPauseClicked(e, t) {
		return this.track(new Jg(e), t);
	}
	phoneRecordingPlayClicked(e, t) {
		return this.track(new Yg(e), t);
	}
	phoneRecordingPlaybackAbandoned(e, t) {
		return this.track(new Xg(e), t);
	}
	phoneRecordingPlaybackEnded(e, t) {
		return this.track(new Zg(e), t);
	}
	phoneSearchApplied(e) {
		return this.track(new Qg(), e);
	}
	presenceListItemClicked(e) {
		return this.track(new $g(), e);
	}
	presenceMediaOtherAgentUpdated(e, t) {
		return this.track(new e_(e), t);
	}
	presenceMediaUpdated(e, t) {
		return this.track(new t_(e), t);
	}
	presenceOtherAgentUpdated(e, t) {
		return this.track(new n_(e), t);
	}
	presenceUpdated(e, t) {
		return this.track(new r_(e), t);
	}
	pushNotificationPlatformFormCancelled(e, t) {
		return this.track(new i_(e), t);
	}
	pushNotificationPlatformFormOpened(e, t) {
		return this.track(new a_(e), t);
	}
	pushNotificationPlatformFormSubmitted(e, t) {
		return this.track(new o_(e), t);
	}
	quickRepliesOpened(e, t) {
		return this.track(new s_(e), t);
	}
	quickReplyChosen(e, t) {
		return this.track(new c_(e), t);
	}
	quickReplyFeedbackForRecommendedRepliesClicked(e, t) {
		return this.track(new l_(e), t);
	}
	quickReplyFilterChosen(e, t) {
		return this.track(new u_(e), t);
	}
	quickReplyLanguageSelected(e, t) {
		return this.track(new d_(e), t);
	}
	quickReplyTemplateFavoriteToggled(e, t) {
		return this.track(new f_(e), t);
	}
	rewindDismissed(e, t) {
		return this.track(new p_(e), t);
	}
	rewindFeedbackClicked(e, t) {
		return this.track(new m_(e), t);
	}
	rewindOpened(e, t) {
		return this.track(new h_(e), t);
	}
	rewindShareToLinkedInClicked(e, t) {
		return this.track(new g_(e), t);
	}
	rewindSlideImageCopied(e, t) {
		return this.track(new __(e), t);
	}
	rewindSlideImageSaved(e, t) {
		return this.track(new v_(e), t);
	}
	rewindSlideTextCopied(e, t) {
		return this.track(new y_(e), t);
	}
	rewindSlideViewed(e, t) {
		return this.track(new b_(e), t);
	}
	savedSearchApplied(e) {
		return this.track(new x_(), e);
	}
	savedSearchClosed(e) {
		return this.track(new S_(), e);
	}
	savedSearchCreated(e, t) {
		return this.track(new C_(e), t);
	}
	savedSearchDeleted(e) {
		return this.track(new w_(), e);
	}
	savedSearchUpdated(e) {
		return this.track(new T_(), e);
	}
	scheduledConversationsCsvImportClicked(e) {
		return this.track(new E_(), e);
	}
	scheduledConversationsCsvImported(e) {
		return this.track(new D_(), e);
	}
	searchConversationPreviewClosed(e) {
		return this.track(new O_(), e);
	}
	searchConversationPreviewGoToClicked(e, t) {
		return this.track(new k_(e), t);
	}
	searchConversationPreviewOpened(e, t) {
		return this.track(new A_(e), t);
	}
	searchFieldBlurred(e, t) {
		return this.track(new j_(e), t);
	}
	searchFieldCleared(e, t) {
		return this.track(new M_(e), t);
	}
	searchFieldFocused(e, t) {
		return this.track(new N_(e), t);
	}
	searchFieldSubmitted(e, t) {
		return this.track(new P_(e), t);
	}
	searchFilterConditionAdded(e, t) {
		return this.track(new F_(e), t);
	}
	searchFilterConditionRemoved(e, t) {
		return this.track(new I_(e), t);
	}
	searchFilterOperatorUpdated(e, t) {
		return this.track(new L_(e), t);
	}
	searchFilterStrategyUpdated(e, t) {
		return this.track(new R_(e), t);
	}
	searchFilterValueAdded(e, t) {
		return this.track(new z_(e), t);
	}
	searchFilterValueCleared(e, t) {
		return this.track(new B_(e), t);
	}
	searchFiltersApplied(e, t) {
		return this.track(new V_(e), t);
	}
	searchFiltersCleared(e, t) {
		return this.track(new H_(e), t);
	}
	searchFiltersClosed(e, t) {
		return this.track(new U_(e), t);
	}
	searchFiltersOpened(e, t) {
		return this.track(new W_(e), t);
	}
	searchFiltersValidationFailed(e, t) {
		return this.track(new G_(e), t);
	}
	searchSortingUpdated(e, t) {
		return this.track(new K_(e), t);
	}
	searchStrictToggled(e, t) {
		return this.track(new q_(e), t);
	}
	settingsAgentsAddAgentButtonClicked(e) {
		return this.track(new J_(), e);
	}
	settingsAgentsCustomWorkloadAssigned(e, t) {
		return this.track(new Y_(e), t);
	}
	settingsAgentsCustomWorkloadCreated(e) {
		return this.track(new X_(), e);
	}
	settingsAgentsCustomWorkloadDeleted(e) {
		return this.track(new Z_(), e);
	}
	settingsAgentsEditButtonClicked(e) {
		return this.track(new Q_(), e);
	}
	settingsAgentsTabClicked(e, t) {
		return this.track(new $_(e), t);
	}
	settingsAudioDeleteCancelClicked(e, t) {
		return this.track(new ev(e), t);
	}
	settingsAudioDeleteClicked(e, t) {
		return this.track(new tv(e), t);
	}
	settingsAudioDeleteConfirmClicked(e, t) {
		return this.track(new nv(e), t);
	}
	settingsAudioUsageFlowClicked(e, t) {
		return this.track(new rv(e), t);
	}
	settingsAudioUsageLinkClicked(e, t) {
		return this.track(new iv(e), t);
	}
	settingsCommandsAssignKeybindings(e, t) {
		return this.track(new av(e), t);
	}
	settingsCommandsResetAllKeybindings(e) {
		return this.track(new ov(), e);
	}
	settingsCommandsResetKeybindings(e, t) {
		return this.track(new sv(e), t);
	}
	settingsCommandsUnassignAllKeybindings(e) {
		return this.track(new cv(), e);
	}
	settingsCommandsUnassignKeybindings(e, t) {
		return this.track(new lv(e), t);
	}
	settingsCustomAttributeActivated(e, t) {
		return this.track(new uv(e), t);
	}
	settingsCustomAttributeAddNewAttributeClicked(e, t) {
		return this.track(new dv(e), t);
	}
	settingsCustomAttributeArchived(e, t) {
		return this.track(new fv(e), t);
	}
	settingsCustomAttributeCreated(e, t) {
		return this.track(new pv(e), t);
	}
	settingsCustomAttributeDeactivated(e, t) {
		return this.track(new mv(e), t);
	}
	settingsCustomAttributeReordered(e, t) {
		return this.track(new hv(e), t);
	}
	settingsCustomAttributeUnarchived(e, t) {
		return this.track(new gv(e), t);
	}
	settingsCustomAttributeUpdated(e, t) {
		return this.track(new _v(e), t);
	}
	settingsCustomAwayStatusAddNewClicked(e) {
		return this.track(new vv(), e);
	}
	settingsCustomAwayStatusArchived(e) {
		return this.track(new yv(), e);
	}
	settingsCustomAwayStatusCreated(e) {
		return this.track(new bv(), e);
	}
	settingsCustomAwayStatusUnarchived(e) {
		return this.track(new xv(), e);
	}
	settingsCustomAwayStatusUpdated(e) {
		return this.track(new Sv(), e);
	}
	settingsFormsEmbedUrlCopied(e) {
		return this.track(new Cv(), e);
	}
	settingsFormsStylingAdded(e) {
		return this.track(new wv(), e);
	}
	settingsIntegrationsApiTokensAddConfirm(e, t) {
		return this.track(new Tv(e), t);
	}
	settingsIntegrationsApiTokensCopy(e) {
		return this.track(new Ev(), e);
	}
	settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi(e) {
		return this.track(new Dv(), e);
	}
	settingsIntegrationsApiTokensRemove(e) {
		return this.track(new Ov(), e);
	}
	settingsIntegrationsApiTokensRemoveCancel(e) {
		return this.track(new kv(), e);
	}
	settingsIntegrationsApiTokensRemoveConfirm(e) {
		return this.track(new Av(), e);
	}
	settingsIntegrationsApiTokensView(e) {
		return this.track(new jv(), e);
	}
	settingsIntegrationsCardEditSave(e, t) {
		return this.track(new Mv(e), t);
	}
	settingsIntegrationsCardEditTest(e, t) {
		return this.track(new Nv(e), t);
	}
	settingsIntegrationsCardListingAddCard(e, t) {
		return this.track(new Pv(e), t);
	}
	settingsIntegrationsCardReadDocumentation(e, t) {
		return this.track(new Fv(e), t);
	}
	settingsIntegrationsCardTest(e, t) {
		return this.track(new Iv(e), t);
	}
	settingsIntegrationsCardTestAddParameter(e, t) {
		return this.track(new Lv(e), t);
	}
	settingsIntegrationsCardTestRemoveParameter(e, t) {
		return this.track(new Rv(e), t);
	}
	settingsIntegrationsCustomCardCreated(e, t) {
		return this.track(new zv(e), t);
	}
	settingsIntegrationsCustomCardEdited(e, t) {
		return this.track(new Bv(e), t);
	}
	settingsIntegrationsCustomCardOauthProviderAuthenticationFailed(e, t) {
		return this.track(new Vv(e), t);
	}
	settingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded(e, t) {
		return this.track(new Hv(e), t);
	}
	settingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut(e, t) {
		return this.track(new Uv(e), t);
	}
	settingsIntegrationsCustomCardOauthProviderCreated(e, t) {
		return this.track(new Wv(e), t);
	}
	settingsIntegrationsCustomCardOauthProviderUpdated(e, t) {
		return this.track(new Gv(e), t);
	}
	settingsIntegrationsDataSyncBackfillStartedFailed(e, t) {
		return this.track(new Kv(e), t);
	}
	settingsIntegrationsDataSyncBackfillStartedSucceeded(e, t) {
		return this.track(new qv(e), t);
	}
	settingsIntegrationsDataSyncConfigurationEnabledFailed(e, t) {
		return this.track(new Jv(e), t);
	}
	settingsIntegrationsDataSyncConfigurationEnabledSucceeded(e, t) {
		return this.track(new Yv(e), t);
	}
	settingsIntegrationsDataSyncCreateConfigurationFailed(e, t) {
		return this.track(new Xv(e), t);
	}
	settingsIntegrationsDataSyncCreateConfigurationSucceeded(e, t) {
		return this.track(new Zv(e), t);
	}
	settingsIntegrationsDataSyncDeleteConfigurationFailed(e, t) {
		return this.track(new Qv(e), t);
	}
	settingsIntegrationsDataSyncDeleteConfigurationSucceeded(e, t) {
		return this.track(new $v(e), t);
	}
	settingsIntegrationsDataSyncRetryBackfillingFailed(e, t) {
		return this.track(new ey(e), t);
	}
	settingsIntegrationsDataSyncRetryBackfillingSucceeded(e, t) {
		return this.track(new ty(e), t);
	}
	settingsIntegrationsDataSyncStartSyncingEventsSucceeded(e, t) {
		return this.track(new ny(e), t);
	}
	settingsIntegrationsDataSyncTypeClicked(e, t) {
		return this.track(new ry(e), t);
	}
	settingsIntegrationsDataSyncUpdateConfigurationFailed(e, t) {
		return this.track(new iy(e), t);
	}
	settingsIntegrationsDataSyncUpdateConfigurationSucceeded(e, t) {
		return this.track(new ay(e), t);
	}
	settingsIntegrationsItemClicked(e, t) {
		return this.track(new oy(e), t);
	}
	settingsIntegrationsWebformEndpointsAddSave(e, t) {
		return this.track(new sy(e), t);
	}
	settingsIntegrationsWebformEndpointsCopy(e) {
		return this.track(new cy(), e);
	}
	settingsIntegrationsWebformEndpointsReadDocumentationLink(e) {
		return this.track(new ly(), e);
	}
	settingsIntegrationsWebformEndpointsRemove(e, t) {
		return this.track(new uy(e), t);
	}
	settingsIntegrationsWebformEndpointsRemoveCancel(e, t) {
		return this.track(new dy(e), t);
	}
	settingsIntegrationsWebformEndpointsRemoveConfirm(e, t) {
		return this.track(new fy(e), t);
	}
	settingsIntegrationsWebhooksAdd(e) {
		return this.track(new py(), e);
	}
	settingsIntegrationsWebhooksAddConfirm(e) {
		return this.track(new my(), e);
	}
	settingsIntegrationsWebhooksDocumentationLinkClicked(e) {
		return this.track(new hy(), e);
	}
	settingsIntegrationsWebhooksEdit(e) {
		return this.track(new gy(), e);
	}
	settingsIntegrationsWebhooksEditSave(e) {
		return this.track(new _y(), e);
	}
	settingsIntegrationsWebhooksEnabledOff(e) {
		return this.track(new vy(), e);
	}
	settingsIntegrationsWebhooksEnabledOn(e) {
		return this.track(new yy(), e);
	}
	settingsIntegrationsWebhooksRemove(e) {
		return this.track(new by(), e);
	}
	settingsIntegrationsWebhooksRemoveCancel(e) {
		return this.track(new xy(), e);
	}
	settingsIntegrationsWebhooksRemoveConfirm(e) {
		return this.track(new Sy(), e);
	}
	settingsIntegrationsWebhooksView(e) {
		return this.track(new Cy(), e);
	}
	settingsIntegrationsWebhooksViewCopySecret(e) {
		return this.track(new wy(), e);
	}
	settingsIntegrationsWebhooksViewCopyUrl(e) {
		return this.track(new Ty(), e);
	}
	settingsIntegrationsWebhooksViewEdit(e) {
		return this.track(new Ey(), e);
	}
	settingsMenuItemClicked(e, t) {
		return this.track(new Dy(e), t);
	}
	settingsOrganizationFormSubmitted(e) {
		return this.track(new Oy(), e);
	}
	settingsOrganizationLogoChanged(e) {
		return this.track(new ky(), e);
	}
	settingsProfileFormSubmitted(e, t) {
		return this.track(new Ay(e), t);
	}
	settingsQueueAdded(e, t) {
		return this.track(new jy(e), t);
	}
	settingsQueueAgentDeleted(e) {
		return this.track(new My(), e);
	}
	settingsQueueAgentSearchSubmitted(e) {
		return this.track(new Ny(), e);
	}
	settingsQueueAgentSorted(e, t) {
		return this.track(new Py(e), t);
	}
	settingsQueueAlertsSaved(e, t) {
		return this.track(new Fy(e), t);
	}
	settingsQueueSaved(e, t) {
		return this.track(new Iy(e), t);
	}
	settingsQueueTeamsAddTeamButtonClicked(e) {
		return this.track(new Ly(), e);
	}
	settingsQueueTeamsAddTeamFormSubmitted(e) {
		return this.track(new Ry(), e);
	}
	settingsQueueTeamsDeleteTeamButtonClicked(e) {
		return this.track(new zy(), e);
	}
	settingsQueuesAddQueueClicked(e) {
		return this.track(new By(), e);
	}
	settingsQueuesArchiveQueueClicked(e, t) {
		return this.track(new Vy(e), t);
	}
	settingsQueuesEditQueueClicked(e) {
		return this.track(new Hy(), e);
	}
	settingsQueuesUnarchiveQueueClicked(e) {
		return this.track(new Uy(), e);
	}
	settingsRolesCustomRoleCreated(e, t) {
		return this.track(new Wy(e), t);
	}
	settingsRolesCustomRoleDeleted(e) {
		return this.track(new Gy(), e);
	}
	settingsRolesCustomRoleEdited(e, t) {
		return this.track(new Ky(e), t);
	}
	settingsSatisfactionFiltersChannelAdded(e, t) {
		return this.track(new qy(e), t);
	}
	settingsSatisfactionFiltersChannelRemoved(e, t) {
		return this.track(new Jy(e), t);
	}
	settingsSatisfactionFiltersCreateViewed(e) {
		return this.track(new Yy(), e);
	}
	settingsSatisfactionFiltersCreated(e) {
		return this.track(new Xy(), e);
	}
	settingsSatisfactionFiltersEdited(e) {
		return this.track(new Zy(), e);
	}
	settingsSummarizationSaveChangesClicked(e) {
		return this.track(new Qy(), e);
	}
	settingsSummarizationShowAutomaticallyClicked(e, t) {
		return this.track(new $y(e), t);
	}
	settingsSummarizationShowOnDemandClicked(e, t) {
		return this.track(new eb(e), t);
	}
	settingsSurveyAccentColorChanged(e) {
		return this.track(new tb(), e);
	}
	settingsSurveyBackToListClicked(e) {
		return this.track(new nb(), e);
	}
	settingsSurveyBackToSurveyClicked(e, t) {
		return this.track(new rb(e), t);
	}
	settingsSurveyCreateFailed(e) {
		return this.track(new ib(), e);
	}
	settingsSurveyCreateModalOpened(e) {
		return this.track(new ab(), e);
	}
	settingsSurveyCreated(e, t) {
		return this.track(new ob(e), t);
	}
	settingsSurveyDeleteCancelled(e) {
		return this.track(new sb(), e);
	}
	settingsSurveyDeleteConfirmed(e) {
		return this.track(new cb(), e);
	}
	settingsSurveyDeleteFailed(e) {
		return this.track(new lb(), e);
	}
	settingsSurveyDeleted(e) {
		return this.track(new ub(), e);
	}
	settingsSurveyEditButtonClicked(e, t) {
		return this.track(new db(e), t);
	}
	settingsSurveyEditViewed(e, t) {
		return this.track(new fb(e), t);
	}
	settingsSurveyEmailPreviewAreaClicked(e) {
		return this.track(new pb(), e);
	}
	settingsSurveyFontColorChanged(e) {
		return this.track(new mb(), e);
	}
	settingsSurveyHeaderImageTypeChanged(e, t) {
		return this.track(new hb(e), t);
	}
	settingsSurveyIvrDetailsSaveFailed(e) {
		return this.track(new gb(), e);
	}
	settingsSurveyIvrDetailsSaved(e) {
		return this.track(new _b(), e);
	}
	settingsSurveyIvrDetailsViewed(e) {
		return this.track(new vb(), e);
	}
	settingsSurveyLanguageAdded(e) {
		return this.track(new yb(), e);
	}
	settingsSurveyLanguageDeleteCancelled(e) {
		return this.track(new bb(), e);
	}
	settingsSurveyLanguageDeleteConfirmed(e, t) {
		return this.track(new xb(e), t);
	}
	settingsSurveyLanguageDeleteFailed(e) {
		return this.track(new Sb(), e);
	}
	settingsSurveyLanguageDeleted(e, t) {
		return this.track(new Cb(e), t);
	}
	settingsSurveyLanguageDisabled(e, t) {
		return this.track(new wb(e), t);
	}
	settingsSurveyLanguageEditClicked(e, t) {
		return this.track(new Tb(e), t);
	}
	settingsSurveyLanguageEnabled(e, t) {
		return this.track(new Eb(e), t);
	}
	settingsSurveyListViewed(e) {
		return this.track(new Db(), e);
	}
	settingsSurveyMultiQuestionDetailsSaveFailed(e) {
		return this.track(new Ob(), e);
	}
	settingsSurveyMultiQuestionDetailsSaved(e, t) {
		return this.track(new kb(e), t);
	}
	settingsSurveyMultiQuestionDetailsViewed(e, t) {
		return this.track(new Ab(e), t);
	}
	settingsSurveyMultiQuestionTabChanged(e, t) {
		return this.track(new jb(e), t);
	}
	settingsSurveyNameSaveFailed(e) {
		return this.track(new Mb(), e);
	}
	settingsSurveyNameSaved(e) {
		return this.track(new Nb(), e);
	}
	settingsSurveyPreviewModeChanged(e, t) {
		return this.track(new Pb(e), t);
	}
	settingsSurveyQuestionAddClicked(e) {
		return this.track(new Fb(), e);
	}
	settingsSurveyQuestionAdded(e, t) {
		return this.track(new Ib(e), t);
	}
	settingsSurveyQuestionDeleted(e, t) {
		return this.track(new Lb(e), t);
	}
	settingsSurveyQuestionEditClicked(e, t) {
		return this.track(new Rb(e), t);
	}
	settingsSurveyQuestionEditorCancelled(e) {
		return this.track(new zb(), e);
	}
	settingsSurveyQuestionReordered(e) {
		return this.track(new Bb(), e);
	}
	settingsSurveyQuestionUpdated(e, t) {
		return this.track(new Vb(e), t);
	}
	settingsSurveyUnsavedChangesDialogShown(e, t) {
		return this.track(new Hb(e), t);
	}
	settingsSurveyUnsavedChangesDiscarded(e, t) {
		return this.track(new Ub(e), t);
	}
	settingsSurveyUnsavedChangesKept(e, t) {
		return this.track(new Wb(e), t);
	}
	settingsTagsAddTagButtonClicked(e) {
		return this.track(new Gb(), e);
	}
	settingsTagsTagActivated(e, t) {
		return this.track(new Kb(e), t);
	}
	settingsTagsTagDeactivated(e, t) {
		return this.track(new qb(e), t);
	}
	settingsTeamAddTeamButtonClicked(e) {
		return this.track(new Jb(), e);
	}
	settingsTeamDetailsAddAgentsButtonClicked(e) {
		return this.track(new Yb(), e);
	}
	settingsTeamEditTeamButtonClicked(e) {
		return this.track(new Xb(), e);
	}
	settingsTeamModalFormSubmitted(e, t) {
		return this.track(new Zb(e), t);
	}
	settingsTeamRemoveTeamButtonClicked(e) {
		return this.track(new Qb(), e);
	}
	settingsTeamRemoveTeamConfirmed(e) {
		return this.track(new $b(), e);
	}
	settingsTemplatesAddTemplateButtonClicked(e, t) {
		return this.track(new ex(e), t);
	}
	settingsTemplatesEditTemplateButtonClicked(e, t) {
		return this.track(new tx(e), t);
	}
	settingsTemplatesModalFormSubmitted(e, t) {
		return this.track(new nx(e), t);
	}
	settingsTemplatesRemoveTemplateButtonClicked(e, t) {
		return this.track(new rx(e), t);
	}
	settingsTemplatesRemoveTemplateConfirmed(e, t) {
		return this.track(new ix(e), t);
	}
	settingsTemplatesTabClicked(e, t) {
		return this.track(new ax(e), t);
	}
	sharedWorkerTabOrWindowChanged(e) {
		return this.track(new ox(), e);
	}
	sharedWorkerTabOrWindowClosed(e, t) {
		return this.track(new sx(e), t);
	}
	sharedWorkerTabOrWindowOpened(e, t) {
		return this.track(new cx(e), t);
	}
	sidebarAddAgentButtonClicked(e) {
		return this.track(new lx(), e);
	}
	sidebarCollapsed(e) {
		return this.track(new ux(), e);
	}
	sidebarExpanded(e) {
		return this.track(new dx(), e);
	}
	sidebarNavClicked(e, t) {
		return this.track(new fx(e), t);
	}
	signOutAborted(e) {
		return this.track(new px(), e);
	}
	signOutConfirmed(e) {
		return this.track(new mx(), e);
	}
	simultaneousRingUpdated(e, t) {
		return this.track(new hx(e), t);
	}
	slaPoliciesReordered(e) {
		return this.track(new gx(), e);
	}
	slaPolicyActivated(e) {
		return this.track(new _x(), e);
	}
	slaPolicyCreated(e, t) {
		return this.track(new vx(e), t);
	}
	slaPolicyDeactivated(e) {
		return this.track(new yx(), e);
	}
	slaPolicyDeleted(e) {
		return this.track(new bx(), e);
	}
	slaPolicyUpdated(e, t) {
		return this.track(new xx(e), t);
	}
	smartConversationReplyButtonClicked(e, t) {
		return this.track(new Sx(e), t);
	}
	subflowBackToMainFlowNodeReused(e) {
		return this.track(new Cx(), e);
	}
	subflowBackToMainFlowNodeUsed(e) {
		return this.track(new wx(), e);
	}
	subflowCreatedFromHighlightedNodes(e) {
		return this.track(new Tx(), e);
	}
	subflowCreatedFromScratch(e) {
		return this.track(new Ex(), e);
	}
	subflowReused(e) {
		return this.track(new Dx(), e);
	}
	tagSelectCreateNewTagClicked(e, t) {
		return this.track(new Ox(e), t);
	}
	tagsCreateModalColorChanged(e, t) {
		return this.track(new kx(e), t);
	}
	tagsCreateModalFormSubmitted(e, t) {
		return this.track(new Ax(e), t);
	}
	tagsCreateModalOpened(e, t) {
		return this.track(new jx(e), t);
	}
	teamAgentActionsMenuItemClicked(e, t) {
		return this.track(new Mx(e), t);
	}
	teamAgentActionsMenuOpened(e) {
		return this.track(new Nx(), e);
	}
	teamAgentCollapsed(e) {
		return this.track(new Px(), e);
	}
	teamAgentExpanded(e) {
		return this.track(new Fx(), e);
	}
	teamFavoriteToggled(e, t) {
		return this.track(new Ix(e), t);
	}
	themeImported(e) {
		return this.track(new Lx(), e);
	}
	themeShared(e) {
		return this.track(new Rx(), e);
	}
	themeUpdated(e, t) {
		return this.track(new zx(e), t);
	}
	topbarBeamerOpened(e) {
		return this.track(new Bx(), e);
	}
	topbarEmailOpened(e) {
		return this.track(new Vx(), e);
	}
	topbarNotificationsOpened(e) {
		return this.track(new Hx(), e);
	}
	topbarPhonesOpened(e) {
		return this.track(new Ux(), e);
	}
	topbarSearchQuickActionClicked(e, t) {
		return this.track(new Wx(e), t);
	}
	topbarSupportOpened(e) {
		return this.track(new Gx(), e);
	}
	userModalFormSubmitted(e, t) {
		return this.track(new Kx(e), t);
	}
	userModalRoleChanged(e, t) {
		return this.track(new qx(e), t);
	}
	userModalUserTypeChanged(e, t) {
		return this.track(new Jx(e), t);
	}
	websocketActiveConnectionChanged(e, t) {
		return this.track(new Yx(e), t);
	}
	websocketCloseEventReceived(e, t) {
		return this.track(new Xx(e), t);
	}
	websocketConnectionClosed(e, t) {
		return this.track(new Zx(e), t);
	}
	websocketConnectionCreated(e, t) {
		return this.track(new Qx(e), t);
	}
	websocketReconnectAttemptStarted(e, t) {
		return this.track(new $x(e), t);
	}
}, nS = new tS();
//#endregion
//#region src/index.ts
function rS(e, t, n) {
	if (!nS.isLoaded) return { promise: Promise.resolve() };
	let r = new O();
	if (n) for (let [e, t] of Object.entries(n)) t != null && r.set(e, t);
	return nS.client.groupIdentify(e, t, r);
}
//#endregion
export { bo as AddAgentsModalFormSubmitted, xo as AgentCopilotBackButtonClicked, So as AgentCopilotConversationCustomAttributeSuggestionAccepted, Co as AgentCopilotConversationTagSuggestionAccepted, wo as AgentCopilotDropdownItemClicked, To as AgentCopilotImproveWritingImprovementClicked, Eo as AgentCopilotTextInsertBelowClicked, Do as AgentCopilotTextReplaceClicked, Oo as AgentCopilotTranslateMessageLanguageSelected, ko as AgentCopilotTrialLearnMoreClicked, Ao as AgentCopilotTrialLeftmenuCtaClicked, jo as AgentCopilotTrialLeftmenuCtaDismissed, Mo as AgentCopilotTrialRequestContactClicked, No as AgentCopilotTrialStarted, Po as AgentCopilotTrialStopped, Fo as AgentCopilotUndoClicked, Io as AgentCustomAwayStatusUpdated, tS as Ampli, Lo as AnalyticsBusinessHoursScheduleRemoved, Ro as AnalyticsBusinessHoursScheduleUpdated, zo as AnalyticsChartFormatChanged, Bo as AnalyticsChartGranularityChanged, Vo as AnalyticsChartVisualizationChanged, Ho as AnalyticsCompareClicked, Uo as AnalyticsCompareContextUpdated, Wo as AnalyticsComparePeriodUpdated, Go as AnalyticsContextUpdated, Ko as AnalyticsConversationLinkClicked, qo as AnalyticsConversationPreviewClicked, Jo as AnalyticsDashboardViewed, Yo as AnalyticsExportClicked, Xo as AnalyticsExportDownloadClicked, Zo as AnalyticsExportMyDataButtonPressed, Qo as AnalyticsFilterCleared, $o as AnalyticsFilterOpened, es as AnalyticsFilterOperatorUpdated, ts as AnalyticsFilterValueAdded, ns as AnalyticsFiltersApplied, rs as AnalyticsFiltersCleared, is as AnalyticsHelperClicked, as as AnalyticsInDepthClicked, os as AnalyticsInsightsCopyClicked, ss as AnalyticsInsightsFeedbackClicked, cs as AnalyticsInsightsPromptClicked, ls as AnalyticsInsightsRegenerateClicked, us as AnalyticsPanelControlsOpened, ds as AnalyticsPeriodUpdated, fs as AnalyticsPinPanelClicked, ps as AnalyticsPinPanelQuickViewCreated, ms as AnalyticsQuickViewAutoRefreshDisabled, hs as AnalyticsQuickViewAutoRefreshEnabled, gs as AnalyticsQuickViewAutoRefreshTriggered, _s as AnalyticsQuickViewCreated, vs as AnalyticsQuickViewDeleted, ys as AnalyticsQuickViewDuplicated, bs as AnalyticsQuickViewFavoriteToggled, xs as AnalyticsQuickViewLandingPageSet, Ss as AnalyticsQuickViewLandingPageUnset, Cs as AnalyticsQuickViewOwnershipTransferred, ws as AnalyticsQuickViewPanelControlsUpdated, Ts as AnalyticsQuickViewPanelDescriptionUpdated, Es as AnalyticsQuickViewPanelPinned, Ds as AnalyticsQuickViewPanelUnpinned, Os as AnalyticsQuickViewPanelsLayoutChanged, ks as AnalyticsQuickViewPanelsReset, As as AnalyticsQuickViewPanelsUpdated, js as AnalyticsQuickViewSharingToggled, Ms as AnalyticsQuickViewUpdated, Ns as AnalyticsQuickViewViewed, Ps as AnalyticsRefreshClicked, Fs as AnalyticsTableLoadAllClicked, Is as AnalyticsTableSortUpdated, Ls as AnalyticsTimezoneUpdated, Rs as AnalyticsViewConversationsClicked, _o as ApiKey, zs as AuthFailedInit, Bs as AutomationsFormCancelled, Vs as AutomationsFormOpened, Hs as AutomationsFormSubmitted, Us as AutomationsOptionsMenuOpened, Ws as AutomationsOptionsMenuOptionDeleteClicked, Gs as AutomationsOptionsMenuOptionDuplicateClicked, Ks as AutomationsOptionsMenuOptionFlowClicked, qs as AutomationsOptionsMenuOptionSettingsClicked, Js as AutomationsPaginationNextClicked, Ys as AutomationsPaginationPreviousClicked, Xs as AutomationsSearchApplied, Zs as AutomationsSearchClosed, Qs as AutomationsSearchOpened, $s as AutomationsToggledOff, ec as AutomationsToggledOn, tc as BansBanUserClicked, nc as BansUnbanIpClicked, rc as BansUnbanUserClicked, ic as BulkActionsUpdateClicked, ac as BusinessHoursAddScheduleAudioMessageAdded, oc as BusinessHoursAddScheduleButtonClicked, sc as BusinessHoursAddScheduleFormCancelled, cc as BusinessHoursAddScheduleFormSubmitted, lc as BusinessHoursConflictNotificationButtonClicked, uc as BusinessHoursConflictNotificationClosed, dc as BusinessHoursDeleteScheduleFormCancelled, fc as BusinessHoursDeleteScheduleFormSubmitted, pc as BusinessHoursDuplicateScheduleFormCancelled, mc as BusinessHoursDuplicateScheduleFormSubmitted, hc as BusinessHoursFirstScheduleModalQuestionClicked, gc as BusinessHoursFirstScheduleSupportArticleClicked, _c as BusinessHoursGoToFlowClicked, vc as BusinessHoursMigrationWizardAudioMessageAdded, yc as BusinessHoursMigrationWizardCreateNewScheduleButtonClicked, bc as BusinessHoursMigrationWizardEditHoursButtonClicked, xc as BusinessHoursMigrationWizardFormCancelled, Sc as BusinessHoursMigrationWizardFormSubmitted, Cc as BusinessHoursMigrationWizardOpeningHoursFormCancelled, wc as BusinessHoursMigrationWizardOpeningHoursFormSubmitted, Tc as BusinessHoursMigrationWizardStartUpdateButtonClicked, Ec as BusinessHoursOptionsMenuOpened, Dc as BusinessHoursOptionsMenuOptionDeleteClicked, Oc as BusinessHoursOptionsMenuOptionDuplicateClicked, kc as BusinessHoursOptionsMenuOptionEditClicked, Ac as BusinessHoursOptionsMenuOptionRenameClicked, jc as BusinessHoursRenameScheduleFormCancelled, Mc as BusinessHoursRenameScheduleFormSubmitted, Nc as BusinessHoursScheduleAddExceptionButtonClicked, Pc as BusinessHoursScheduleAddExceptionFormCancelled, Fc as BusinessHoursScheduleAddExceptionFormSubmitted, Ic as BusinessHoursScheduleAudioMessageFormCancelled, Lc as BusinessHoursScheduleAudioMessageFormSubmitted, Rc as BusinessHoursScheduleAudioMessageOptionsMenuOpened, zc as BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked, Bc as BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked, Vc as BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked, Hc as BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked, Uc as BusinessHoursScheduleConflictChangeButtonClicked, Wc as BusinessHoursScheduleConflictReviewButtonClicked, Gc as BusinessHoursScheduleDeleteExceptionFormCancelled, Kc as BusinessHoursScheduleDeleteExceptionFormSubmitted, qc as BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked, Jc as BusinessHoursScheduleImportHolidayFormCancelled, Yc as BusinessHoursScheduleImportHolidayFormSubmitted, Xc as BusinessHoursScheduleOptionsMenuImportHolidaysClicked, Zc as BusinessHoursScheduleOptionsMenuOpened, Qc as BusinessHoursScheduleOptionsMenuRecoverHolidaysClicked, $c as BusinessHoursScheduleOptionsMenuRenameClicked, el as BusinessHoursScheduleOptionsMenuTimezoneClicked, tl as BusinessHoursSchedulePreviewButtonClicked, nl as BusinessHoursScheduleRecoverHolidaysFormCancelled, rl as BusinessHoursScheduleRecoverHolidaysFormSubmitted, il as BusinessHoursScheduleReviewFormCancelled, al as BusinessHoursScheduleReviewFormSubmitted, ol as BusinessHoursScheduleSaveScheduleButtonClicked, sl as BusinessHoursScheduleTabClicked, cl as BusinessHoursScheduleViewClicked, ll as ChatFlowOptionsMenuOptionAuditLogClicked, ul as ChatFormCanceled, dl as ChatFormOpened, fl as ChatFormSubmitted, pl as ChatOptionsMenuOpened, ml as ChatOptionsMenuOptionDeleteClicked, hl as ChatOptionsMenuOptionDuplicateClicked, gl as ChatOptionsMenuOptionFlowClicked, _l as ChatOptionsMenuOptionRenameClicked, vl as ChatOptionsMenuOptionSetupClicked, yl as ChatPaginationNextClicked, bl as ChatPaginationPreviousClicked, xl as ChatSearchApplied, Sl as ChatSearchClosed, Cl as ChatSearchOpened, wl as ChatbotCreateModalOpened, Tl as ChatbotCreated, El as ChatbotDeleteModalOpened, Dl as ChatbotDeleted, Ol as ChatbotEditIdentityModalOpened, kl as ChatbotIdentityEdited, Al as ColorModeUpdated, jl as CommandExecuted, Ml as CommandPaletteActionSelected, Nl as CommandPaletteClosed, Pl as CommandPaletteOpened, Fl as CompanyModalFormSubmitted, Il as ContactsAddNewCompanyClicked, Ll as ContactsAddNewContactClicked, Rl as ContactsBanUserClicked, zl as ContactsCardActionsMenuOpened, Bl as ContactsCardComposeNewEmailClicked, Vl as ContactsCardEditCompanyClicked, Hl as ContactsCardEditContactClicked, Ul as ContactsCardMakeCallClicked, Wl as ContactsCardSeeAllAssignedConversationsClicked, Gl as ContactsCardSeeAllConversationsClicked, Kl as ContactsCardViewCompanyClicked, ql as ContactsCardViewUserClicked, Jl as ContactsSearchBlurred, Yl as ContactsSearchFocused, Xl as ContactsUnbanUserClicked, Zl as ContactsViewCompanies, Ql as ContactsViewEndUsers, $l as ConversationActionsMenuOpened, eu as ConversationActionsMenuOptionClicked, tu as ConversationActivityLogClosed, nu as ConversationActivityLogFlooterExpanded, ru as ConversationActivityLogOpened, iu as ConversationArticleDraftImprovementRequested, au as ConversationArticleDraftImprovementResponseReceived, ou as ConversationArticleDraftPreviewRequested, su as ConversationArticleDraftPreviewResponseReceived, cu as ConversationArticleDraftSaveRequested, lu as ConversationArticleDraftSaveResponseReceived, uu as ConversationAttachedImageIsDownloaded, du as ConversationAttachedImageIsViewed, fu as ConversationClaimed, pu as ConversationClosed, mu as ConversationCsatCancelled, hu as ConversationCsatMenuCancelOptionClicked, gu as ConversationCsatMenuLanguageSelected, _u as ConversationCsatMenuOpened, vu as ConversationFocusModeToggled, yu as ConversationFollowUp, bu as ConversationFollowUpMenuOpened, xu as ConversationFollowUpMenuOptionClicked, Su as ConversationHeaderConversationDetailsMenuOpened, Cu as ConversationHeaderTagAdded, wu as ConversationHeaderTagIncludeDeactivatedToggled, Tu as ConversationHeaderTagMenuOpened, Eu as ConversationHeaderTagRemoved, Du as ConversationHeaderTransferToAgentItemSelected, Ou as ConversationHeaderTransferToAgentMenuOpened, ku as ConversationHeaderTransferToNumberButtonClicked, Au as ConversationHeaderTransferToQueueItemSelected, ju as ConversationHeaderTransferToQueueMenuOpened, Mu as ConversationInternalNoteEditorOpened, Nu as ConversationMessageRedactionModalOpened, Pu as ConversationMessageRedactionModalSubmitted, Fu as ConversationOffered, Iu as ConversationReplied, Lu as ConversationReplyWindowToggled, Ru as ConversationResolvedAsAKnowledgeArticleDraft, zu as ConversationResolvedAsAKnowledgeGap, Bu as ConversationResolvedByKnowledge, Vu as ConversationResolvedWithNoKnowledgeArticle, Hu as ConversationRightSidebarItemReordered, Uu as ConversationRightSidebarItemVisibilityToggled, Wu as ConversationSidebarAdminConfigurationSaved, Gu as ConversationSidebarClosed, Ku as ConversationSidebarConversationHistoryClosed, qu as ConversationSidebarConversationHistoryNavigatedToConversation, Ju as ConversationSidebarConversationHistoryOpened, Yu as ConversationSidebarCustomerInfoEmailClicked, Xu as ConversationSidebarCustomerInfoPhoneNumberClicked, Zu as ConversationSidebarOpened, vd as ConversationSummaryFeedbackNotUseful, yd as ConversationSummaryFeedbackUseful, bd as ConversationSummaryRegenerateSummary, Qu as ConversationTimelineItemOpened, $u as ConversationTimelineNavigatedToConversation, ed as ConversationTransferred, td as ConversationsBulkActionsClicked, nd as ConversationsClearAllClicked, rd as ConversationsFilterAgentClicked, id as ConversationsFilterClearAllClicked, ad as ConversationsFilterCleared, od as ConversationsFilterContactClicked, sd as ConversationsFilterToggled, cd as ConversationsGoToConversationClicked, ld as ConversationsItemPreviewClicked, ud as ConversationsNextPageClicked, dd as ConversationsPreviousPageClicked, fd as ConversationsSelectAllClicked, pd as ConversationsSelectClicked, md as ConversationsTimestampClicked, hd as ConversationsTransferToQueueClicked, gd as ConversationsViewAgentClicked, _d as ConversationsViewContactClicked, xd as CopyScript, Sd as CountryCodeSelected, Cd as CustomAttributeValueUpdated, wd as DashboardChannelAllConversationsClicked, Td as DashboardChannelGoToAnalyticsClicked, Ed as DashboardChannelLongestQueuedTimeMetricClicked, Dd as DashboardChannelNameClicked, Od as DashboardChannelPendingConversationsMetricClicked, kd as DashboardChannelTvDashboardClicked, Ad as DashboardFavoriteCreated, jd as DashboardFavoriteDeleted, Md as DashboardFavoriteLandingPageSet, Nd as DashboardFavoriteLandingPageUnset, Pd as DashboardFavoriteOwnershipTransferred, Fd as DashboardFavoriteQueuesReordered, Id as DashboardFavoriteSharingToggled, Ld as DashboardFavoriteTvDashboardClicked, Rd as DashboardFavoriteUpdated, zd as DashboardFavoriteViewed, Bd as DashboardGlobalTvDashboardClicked, Vd as DashboardLayoutChanged, Hd as DashboardLongestQueuedTimeMetricClicked, Ud as DashboardMetricHelperClicked, Wd as DashboardNextPageClicked, Gd as DashboardOrganizationTimezoneSettingsClicked, Kd as DashboardPreviousPageClicked, qd as DashboardQueueAllConversationsClicked, Jd as DashboardQueueGoToAnalyticsClicked, Yd as DashboardQueueItemFavoriteToggled, Xd as DashboardQueueNameClicked, Zd as DashboardQueuePendingConversationsMetricClicked, Qd as DashboardQueueSettingsClicked, $d as DashboardQueueTvDashboardClicked, ef as DashboardQueuesManuallySelected, tf as DashboardQueuesSearchFieldCleared, nf as DashboardQueuesSearchFieldSubmitted, rf as DashboardQueuesSortingUpdated, af as DashboardQueuesTypeChanged, of as DashboardRefreshDataClicked, sf as DashboardTvReloaded, cf as DashboardViewed, vo as DefaultConfiguration, lf as EmailFlowOptionsMenuOptionAuditLogClicked, uf as EmailFormSubmitted, df as EmailOptionsMenuOpened, ff as EmailOptionsMenuOptionDeleteClicked, pf as EmailOptionsMenuOptionDuplicateClicked, mf as EmailOptionsMenuOptionEmailClicked, hf as EmailOptionsMenuOptionFlowClicked, gf as EmailOptionsMenuOptionRenameClicked, _f as EmailSearchApplied, vf as EmailSearchClosed, yf as EmailSearchOpened, bf as FlowActionAddSaved, xf as FlowActionConditionAdded, Sf as FlowActionConditionRemoved, Cf as FlowActionDeleted, wf as FlowActionEditClicked, Tf as FlowActionEditSaved, Ef as FlowActivateClicked, Df as FlowAddActionActionSelected, Of as FlowAddActionCancelled, kf as FlowAddActionOpened, Af as FlowBackToSettingsClicked, jf as FlowContextAlignClicked, Mf as FlowContextDeleteCancelClicked, Nf as FlowContextDeleteClicked, Pf as FlowContextDeleteConfirmClicked, Ff as FlowContextNodeArrangeClicked, If as FlowPhoneNumberChanged, Lf as FlowSaveClicked, Rf as FlowTitleEditClicked, zf as FlowZoomInClicked, Bf as FlowZoomOutClicked, Vf as FlowZoomResetClicked, Hf as FollowUpConversationModalInternalNoteAdded, Uf as FollowUpConversationModalOfferInQueueAdded, yo as Identify, Wf as IntelligenceDashboardViewed, Gf as IntelligenceDistributionChartOpened, Kf as IntelligenceEvolutionChartOpened, qf as IntelligenceFilterChanged, Jf as IntelligenceFilterPeriodChanged, Yf as IntelligenceGroupByChanged, Xf as IntelligencePresetComparisonStarted, Zf as IntelligenceTableCustomized, Qf as IntentDetectionCreated, $f as IntentDetectionDeleted, ep as IntentDetectionFlowNodeSaved, tp as IntentDetectionUpdated, np as KnowledgeArticleArchived, rp as KnowledgeArticleChangesDiscarded, ip as KnowledgeArticleCreated, ap as KnowledgeArticleDestroyed, op as KnowledgeArticleFeedbackSubmitted, sp as KnowledgeArticleMarkedAsHelpful, cp as KnowledgeArticleMoved, lp as KnowledgeArticlePublished, up as KnowledgeArticleReordered, dp as KnowledgeArticleRestored, fp as KnowledgeArticleTagAdded, pp as KnowledgeArticleTagRemoved, mp as KnowledgeArticleUnpublished, hp as KnowledgeArticleUpdated, gp as KnowledgeArticleVersionHistoryClicked, _p as KnowledgeArticleViewed, vp as KnowledgeArticlesSearchByTermSubmitted, yp as KnowledgeCategoryCreated, bp as KnowledgeCategoryDestroyed, xp as KnowledgeCategoryReordered, Sp as KnowledgeCategoryUpdated, Cp as KnowledgeCollectionCreated, wp as KnowledgeCollectionDestroyed, Tp as KnowledgeCollectionUpdated, Ep as KnowledgeCollectionViewed, Dp as KnowledgeHelpCenterCreated, Op as KnowledgeHelpCenterDeleted, kp as KnowledgeHelpCenterUpdated, Ap as KnowledgeInternalKbDashboardViewed, jp as KnowledgeInternalKbSearchResultClicked, Mp as KnowledgeResolutionCancelled, Np as KnowledgeResolutionInitialised, Pp as KnowledgeRetranslateArticleBlockClicked, Fp as KnowledgeRetranslateArticleTitleClicked, Ip as KnowledgeTranslateArticleClicked, Lp as LinkConversationsModalOpened, Rp as LinkConversationsSubmitted, zp as MentionUserNotificationClicked, Bp as MentionUserSelected, Vp as MergeContactsMergeCancelled, Hp as MergeContactsMergeFailed, Up as MergeContactsMergeSucceeded, Wp as MergeContactsModalClosed, Gp as MergeContactsModalOpened, Kp as MergeContactsSourceContactSelected, qp as MessengerFlowOptionsMenuOptionAuditLogClicked, Jp as MessengerFormCancelled, Yp as MessengerFormOpened, Xp as MessengerFormSubmitted, Zp as MessengerOptionsMenuOpened, Qp as MessengerOptionsMenuOptionClicked, $p as ModalConversationCloseCancelClicked, em as ModalConversationCloseConfirmClicked, tm as ModalTransferToQueueCancelClicked, nm as ModalTransferToQueueConfirmClicked, rm as NetworkConnectionStatusChanged, im as NotificationOfferAccepted, am as NotificationOfferClosed, om as NotificationOfferRejected, sm as NotificationOfferTimeout, cm as NotificationTransferOfferAccepted, lm as NotificationTransferOfferClosed, um as NotificationTransferOfferRejected, dm as NotificationTransferOfferTimeout, fm as OrganizationsNavigationOrganizationClicked, pm as PartnerIntegrationsBrazeProfileReceived, mm as PartnerIntegrationsBrazeSubscriptionEmailOptInSucceeded, hm as PartnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded, gm as PartnerIntegrationsConditionCreated, _m as PartnerIntegrationsConditionDeleted, vm as PartnerIntegrationsConditionUpdated, ym as PartnerIntegrationsGithubCreateNewIssueCanceled, bm as PartnerIntegrationsGithubCreateNewIssueClicked, xm as PartnerIntegrationsGithubCreateNewIssueConfirmed, Sm as PartnerIntegrationsGithubLinkIssueClicked, Cm as PartnerIntegrationsGithubUnlinkAllIssuesCanceled, wm as PartnerIntegrationsGithubUnlinkAllIssuesClicked, Tm as PartnerIntegrationsGithubUnlinkAllIssuesConfirmed, Em as PartnerIntegrationsGithubUnlinkIssueCanceled, Dm as PartnerIntegrationsGithubUnlinkIssueClicked, Om as PartnerIntegrationsGithubUnlinkIssueConfirmed, km as PartnerIntegrationsGithubViewLinkClicked, Am as PartnerIntegrationsJiraCommentsCollapsed, jm as PartnerIntegrationsJiraCommentsExpanded, Mm as PartnerIntegrationsJiraCreateIssueFailed, Nm as PartnerIntegrationsJiraCreateIssueSucceeded, Pm as PartnerIntegrationsJiraLinkIssueClicked, Fm as PartnerIntegrationsJiraOpenIssueClicked, Im as PartnerIntegrationsJiraOpenJiraClicked, Lm as PartnerIntegrationsJiraRemoveAllDanglingClicked, Rm as PartnerIntegrationsJiraRemoveDanglingIssueClicked, zm as PartnerIntegrationsJiraUnlinkAllIssuesCancelled, Bm as PartnerIntegrationsJiraUnlinkAllIssuesClicked, Vm as PartnerIntegrationsJiraUnlinkAllIssuesConfirmed, Hm as PartnerIntegrationsJiraUnlinkIssueCancelled, Um as PartnerIntegrationsJiraUnlinkIssueClicked, Wm as PartnerIntegrationsJiraUnlinkIssueConfirmed, Gm as PartnerIntegrationsKlaviyoMessagesReceived, Km as PartnerIntegrationsKlaviyoProfileFailed, qm as PartnerIntegrationsKlaviyoProfileReceived, Jm as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked, Ym as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed, Xm as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded, Zm as PartnerIntegrationsKlaviyoProfileUnsubscribeClicked, Qm as PartnerIntegrationsKlaviyoProfileUnsubscribeFailed, $m as PartnerIntegrationsKlaviyoProfileUnsubscribeSucceeded, eh as PartnerIntegrationsLinearCreateNewIssueCancelled, th as PartnerIntegrationsLinearCreateNewIssueClicked, nh as PartnerIntegrationsLinearCreateNewIssueConfirmed, rh as PartnerIntegrationsLinearLinkIssueClicked, ih as PartnerIntegrationsLinearOpenIssueClicked, ah as PartnerIntegrationsLinearOpenLinearClicked, oh as PartnerIntegrationsLinearUnlinkIssueClicked, sh as PartnerIntegrationsRechargeWidgetCustomerOverviewOpened, ch as PartnerIntegrationsRechargeWidgetOrderOpened, lh as PartnerIntegrationsRechargeWidgetOrdersListOpened, uh as PartnerIntegrationsRechargeWidgetProfileReceived, dh as PartnerIntegrationsRechargeWidgetSubscriptionCancelled, fh as PartnerIntegrationsRechargeWidgetSubscriptionOpened, ph as PartnerIntegrationsRechargeWidgetSubscriptionReactivated, mh as PartnerIntegrationsRechargeWidgetSubscriptionSkipped, hh as PartnerIntegrationsRechargeWidgetSubscriptionSwapped, gh as PartnerIntegrationsRechargeWidgetSubscriptionsListOpened, _h as PartnerIntegrationsRivoLoyaltyWidgetCustomerClicked, vh as PartnerIntegrationsRivoLoyaltyWidgetCustomerReceived, yh as PartnerIntegrationsRivoLoyaltyWidgetPointsAddFailed, bh as PartnerIntegrationsRivoLoyaltyWidgetPointsAddSucceeded, xh as PartnerIntegrationsRivoLoyaltyWidgetPointsRemoveFailed, Sh as PartnerIntegrationsRivoLoyaltyWidgetPointsRemoveSucceeded, Ch as PartnerIntegrationsSettingsCreateSubmitted, wh as PartnerIntegrationsSettingsOverviewCreated, Th as PartnerIntegrationsSettingsOverviewViewed, Eh as PartnerIntegrationsSettingsViewDeleteCanceled, Dh as PartnerIntegrationsSettingsViewDeleteConfirmed, Oh as PartnerIntegrationsSettingsViewDeleteRequested, kh as PartnerIntegrationsSettingsViewOAuthStarted, Ah as PartnerIntegrationsSettingsViewOAuthSucceeded, jh as PartnerIntegrationsSettingsViewSubmitted, Mh as PartnerIntegrationsShopifyWidgetCreateDraftOrderFailed, Nh as PartnerIntegrationsShopifyWidgetCreateDraftOrderSucceeded, Ph as PartnerIntegrationsShopifyWidgetCreateOrderFailed, Fh as PartnerIntegrationsShopifyWidgetCreateOrderSucceeded, Ih as PartnerIntegrationsShopifyWidgetDiscountCodeCreated, Lh as PartnerIntegrationsShopifyWidgetDuplicateOrderFailed, Rh as PartnerIntegrationsShopifyWidgetDuplicateOrderSucceeded, zh as PartnerIntegrationsShopifyWidgetOrderCancelled, Bh as PartnerIntegrationsShopifyWidgetOrderCollapseClosed, Vh as PartnerIntegrationsShopifyWidgetOrderCollapseOpened, Hh as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled, Uh as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened, Wh as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted, Gh as PartnerIntegrationsShopifyWidgetOrderRefundCanceled, Kh as PartnerIntegrationsShopifyWidgetOrderRefundConfirmed, qh as PartnerIntegrationsShopifyWidgetOrderRefundRequested, Jh as PartnerIntegrationsShopifyWidgetOrderTagsUpdated, Yh as PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked, Xh as PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked, Zh as PartnerIntegrationsShopifyWidgetProfileCreated, Qh as PartnerIntegrationsShopifyWidgetRefreshed, $h as PartnerIntegrationsShopifyWidgetRefundPartialOrderFailed, eg as PartnerIntegrationsShopifyWidgetRefundPartialOrderSucceeded, tg as PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked, ng as PartnerIntegrationsVoyadoWidgetChannelSubscriptionClicked, rg as PartnerIntegrationsVoyadoWidgetChannelSubscriptionFailed, ig as PartnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded, ag as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked, og as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed, sg as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded, cg as PartnerIntegrationsVoyadoWidgetMessageExternalLinkOpened, lg as PartnerIntegrationsVoyadoWidgetMessagesReceived, ug as PartnerIntegrationsVoyadoWidgetOrdersReceived, dg as PartnerIntegrationsVoyadoWidgetProfileReceived, fg as PartnerIntegrationsVoyadoWidgetTransactionsReceived, pg as PartnerIntegrationsWidgetCollapseClosed, mg as PartnerIntegrationsWidgetCollapseOpened, hg as PartnerIntegrationsWidgetLoyaltyLionAddPointsFailed, gg as PartnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded, _g as PartnerIntegrationsWidgetLoyaltyLionCustomerReceived, vg as PartnerIntegrationsWidgetLoyaltyLionRemovePointsFailed, yg as PartnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded, bg as PartnerIntegrationsWidgetVoyadoUpdatePointsFailed, xg as PartnerIntegrationsWidgetVoyadoUpdatePointsSucceeded, Sg as PhoneActionsMenuActionAddOutboundCallerIdClicked, Cg as PhoneActionsMenuActionChangeHoldMusicClicked, wg as PhoneActionsMenuOpened, Tg as PhoneAddOutboundCallerIdFormCancelled, Eg as PhoneAddOutboundCallerIdFormSubmitted, Dg as PhoneChangeHoldMusicFormCancelled, Og as PhoneChangeHoldMusicFormSubmitted, kg as PhoneCreateFlowFormCancelled, Ag as PhoneCreateFlowFormSubmitted, jg as PhoneFlowOptionsMenuOptionAuditLogClicked, Mg as PhoneFlowOptionsMenuOptionDeleteClicked, Ng as PhoneFlowOptionsMenuOptionDuplicateClicked, Pg as PhoneFlowOptionsMenuOptionEditClicked, Fg as PhoneFlowOptionsMenuOptionMoveToAnotherNumberClicked, Ig as PhoneFlowOptionsMenuOptionOpened, Lg as PhoneFlowOptionsMenuOptionRenameClicked, Rg as PhoneFormCancelled, zg as PhoneFormOpened, Bg as PhoneFormSubmitted, Vg as PhoneOptionsMenuOpened, Hg as PhoneOptionsMenuOptionCreateFlowClicked, Ug as PhoneOptionsMenuOptionEditClicked, Wg as PhoneOptionsMenuOptionRemoveNumberClicked, Gg as PhoneOptionsMenuOptionSetDefaultCallerIdClicked, Kg as PhoneOptionsMenuOptionSetupClicked, qg as PhoneRecordingDownloaded, Jg as PhoneRecordingPauseClicked, Yg as PhoneRecordingPlayClicked, Xg as PhoneRecordingPlaybackAbandoned, Zg as PhoneRecordingPlaybackEnded, Qg as PhoneSearchApplied, $g as PresenceListItemClicked, e_ as PresenceMediaOtherAgentUpdated, t_ as PresenceMediaUpdated, n_ as PresenceOtherAgentUpdated, r_ as PresenceUpdated, i_ as PushNotificationPlatformFormCancelled, a_ as PushNotificationPlatformFormOpened, o_ as PushNotificationPlatformFormSubmitted, s_ as QuickRepliesOpened, c_ as QuickReplyChosen, l_ as QuickReplyFeedbackForRecommendedRepliesClicked, u_ as QuickReplyFilterChosen, d_ as QuickReplyLanguageSelected, f_ as QuickReplyTemplateFavoriteToggled, p_ as RewindDismissed, m_ as RewindFeedbackClicked, h_ as RewindOpened, g_ as RewindShareToLinkedInClicked, __ as RewindSlideImageCopied, v_ as RewindSlideImageSaved, y_ as RewindSlideTextCopied, b_ as RewindSlideViewed, x_ as SavedSearchApplied, S_ as SavedSearchClosed, C_ as SavedSearchCreated, w_ as SavedSearchDeleted, T_ as SavedSearchUpdated, E_ as ScheduledConversationsCsvImportClicked, D_ as ScheduledConversationsCsvImported, O_ as SearchConversationPreviewClosed, k_ as SearchConversationPreviewGoToClicked, A_ as SearchConversationPreviewOpened, j_ as SearchFieldBlurred, M_ as SearchFieldCleared, N_ as SearchFieldFocused, P_ as SearchFieldSubmitted, F_ as SearchFilterConditionAdded, I_ as SearchFilterConditionRemoved, L_ as SearchFilterOperatorUpdated, R_ as SearchFilterStrategyUpdated, z_ as SearchFilterValueAdded, B_ as SearchFilterValueCleared, V_ as SearchFiltersApplied, H_ as SearchFiltersCleared, U_ as SearchFiltersClosed, W_ as SearchFiltersOpened, G_ as SearchFiltersValidationFailed, K_ as SearchSortingUpdated, q_ as SearchStrictToggled, J_ as SettingsAgentsAddAgentButtonClicked, Y_ as SettingsAgentsCustomWorkloadAssigned, X_ as SettingsAgentsCustomWorkloadCreated, Z_ as SettingsAgentsCustomWorkloadDeleted, Q_ as SettingsAgentsEditButtonClicked, $_ as SettingsAgentsTabClicked, ev as SettingsAudioDeleteCancelClicked, tv as SettingsAudioDeleteClicked, nv as SettingsAudioDeleteConfirmClicked, rv as SettingsAudioUsageFlowClicked, iv as SettingsAudioUsageLinkClicked, av as SettingsCommandsAssignKeybindings, ov as SettingsCommandsResetAllKeybindings, sv as SettingsCommandsResetKeybindings, cv as SettingsCommandsUnassignAllKeybindings, lv as SettingsCommandsUnassignKeybindings, uv as SettingsCustomAttributeActivated, dv as SettingsCustomAttributeAddNewAttributeClicked, fv as SettingsCustomAttributeArchived, pv as SettingsCustomAttributeCreated, mv as SettingsCustomAttributeDeactivated, hv as SettingsCustomAttributeReordered, gv as SettingsCustomAttributeUnarchived, _v as SettingsCustomAttributeUpdated, vv as SettingsCustomAwayStatusAddNewClicked, yv as SettingsCustomAwayStatusArchived, bv as SettingsCustomAwayStatusCreated, xv as SettingsCustomAwayStatusUnarchived, Sv as SettingsCustomAwayStatusUpdated, Cv as SettingsFormsEmbedUrlCopied, wv as SettingsFormsStylingAdded, Tv as SettingsIntegrationsApiTokensAddConfirm, Ev as SettingsIntegrationsApiTokensCopy, Dv as SettingsIntegrationsApiTokensDocumentationLinkIntegrationsApi, Ov as SettingsIntegrationsApiTokensRemove, kv as SettingsIntegrationsApiTokensRemoveCancel, Av as SettingsIntegrationsApiTokensRemoveConfirm, jv as SettingsIntegrationsApiTokensView, Mv as SettingsIntegrationsCardEditSave, Nv as SettingsIntegrationsCardEditTest, Pv as SettingsIntegrationsCardListingAddCard, Fv as SettingsIntegrationsCardReadDocumentation, Iv as SettingsIntegrationsCardTest, Lv as SettingsIntegrationsCardTestAddParameter, Rv as SettingsIntegrationsCardTestRemoveParameter, zv as SettingsIntegrationsCustomCardCreated, Bv as SettingsIntegrationsCustomCardEdited, Vv as SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed, Hv as SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded, Uv as SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut, Wv as SettingsIntegrationsCustomCardOauthProviderCreated, Gv as SettingsIntegrationsCustomCardOauthProviderUpdated, Kv as SettingsIntegrationsDataSyncBackfillStartedFailed, qv as SettingsIntegrationsDataSyncBackfillStartedSucceeded, Jv as SettingsIntegrationsDataSyncConfigurationEnabledFailed, Yv as SettingsIntegrationsDataSyncConfigurationEnabledSucceeded, Xv as SettingsIntegrationsDataSyncCreateConfigurationFailed, Zv as SettingsIntegrationsDataSyncCreateConfigurationSucceeded, Qv as SettingsIntegrationsDataSyncDeleteConfigurationFailed, $v as SettingsIntegrationsDataSyncDeleteConfigurationSucceeded, ey as SettingsIntegrationsDataSyncRetryBackfillingFailed, ty as SettingsIntegrationsDataSyncRetryBackfillingSucceeded, ny as SettingsIntegrationsDataSyncStartSyncingEventsSucceeded, ry as SettingsIntegrationsDataSyncTypeClicked, iy as SettingsIntegrationsDataSyncUpdateConfigurationFailed, ay as SettingsIntegrationsDataSyncUpdateConfigurationSucceeded, oy as SettingsIntegrationsItemClicked, sy as SettingsIntegrationsWebformEndpointsAddSave, cy as SettingsIntegrationsWebformEndpointsCopy, ly as SettingsIntegrationsWebformEndpointsReadDocumentationLink, uy as SettingsIntegrationsWebformEndpointsRemove, dy as SettingsIntegrationsWebformEndpointsRemoveCancel, fy as SettingsIntegrationsWebformEndpointsRemoveConfirm, py as SettingsIntegrationsWebhooksAdd, my as SettingsIntegrationsWebhooksAddConfirm, hy as SettingsIntegrationsWebhooksDocumentationLinkClicked, gy as SettingsIntegrationsWebhooksEdit, _y as SettingsIntegrationsWebhooksEditSave, vy as SettingsIntegrationsWebhooksEnabledOff, yy as SettingsIntegrationsWebhooksEnabledOn, by as SettingsIntegrationsWebhooksRemove, xy as SettingsIntegrationsWebhooksRemoveCancel, Sy as SettingsIntegrationsWebhooksRemoveConfirm, Cy as SettingsIntegrationsWebhooksView, wy as SettingsIntegrationsWebhooksViewCopySecret, Ty as SettingsIntegrationsWebhooksViewCopyUrl, Ey as SettingsIntegrationsWebhooksViewEdit, Dy as SettingsMenuItemClicked, Oy as SettingsOrganizationFormSubmitted, ky as SettingsOrganizationLogoChanged, Ay as SettingsProfileFormSubmitted, jy as SettingsQueueAdded, My as SettingsQueueAgentDeleted, Ny as SettingsQueueAgentSearchSubmitted, Py as SettingsQueueAgentSorted, Fy as SettingsQueueAlertsSaved, Iy as SettingsQueueSaved, Ly as SettingsQueueTeamsAddTeamButtonClicked, Ry as SettingsQueueTeamsAddTeamFormSubmitted, zy as SettingsQueueTeamsDeleteTeamButtonClicked, By as SettingsQueuesAddQueueClicked, Vy as SettingsQueuesArchiveQueueClicked, Hy as SettingsQueuesEditQueueClicked, Uy as SettingsQueuesUnarchiveQueueClicked, Wy as SettingsRolesCustomRoleCreated, Gy as SettingsRolesCustomRoleDeleted, Ky as SettingsRolesCustomRoleEdited, qy as SettingsSatisfactionFiltersChannelAdded, Jy as SettingsSatisfactionFiltersChannelRemoved, Yy as SettingsSatisfactionFiltersCreateViewed, Xy as SettingsSatisfactionFiltersCreated, Zy as SettingsSatisfactionFiltersEdited, Qy as SettingsSummarizationSaveChangesClicked, $y as SettingsSummarizationShowAutomaticallyClicked, eb as SettingsSummarizationShowOnDemandClicked, tb as SettingsSurveyAccentColorChanged, nb as SettingsSurveyBackToListClicked, rb as SettingsSurveyBackToSurveyClicked, ib as SettingsSurveyCreateFailed, ab as SettingsSurveyCreateModalOpened, ob as SettingsSurveyCreated, sb as SettingsSurveyDeleteCancelled, cb as SettingsSurveyDeleteConfirmed, lb as SettingsSurveyDeleteFailed, ub as SettingsSurveyDeleted, db as SettingsSurveyEditButtonClicked, fb as SettingsSurveyEditViewed, pb as SettingsSurveyEmailPreviewAreaClicked, mb as SettingsSurveyFontColorChanged, hb as SettingsSurveyHeaderImageTypeChanged, gb as SettingsSurveyIvrDetailsSaveFailed, _b as SettingsSurveyIvrDetailsSaved, vb as SettingsSurveyIvrDetailsViewed, yb as SettingsSurveyLanguageAdded, bb as SettingsSurveyLanguageDeleteCancelled, xb as SettingsSurveyLanguageDeleteConfirmed, Sb as SettingsSurveyLanguageDeleteFailed, Cb as SettingsSurveyLanguageDeleted, wb as SettingsSurveyLanguageDisabled, Tb as SettingsSurveyLanguageEditClicked, Eb as SettingsSurveyLanguageEnabled, Db as SettingsSurveyListViewed, Ob as SettingsSurveyMultiQuestionDetailsSaveFailed, kb as SettingsSurveyMultiQuestionDetailsSaved, Ab as SettingsSurveyMultiQuestionDetailsViewed, jb as SettingsSurveyMultiQuestionTabChanged, Mb as SettingsSurveyNameSaveFailed, Nb as SettingsSurveyNameSaved, Pb as SettingsSurveyPreviewModeChanged, Fb as SettingsSurveyQuestionAddClicked, Ib as SettingsSurveyQuestionAdded, Lb as SettingsSurveyQuestionDeleted, Rb as SettingsSurveyQuestionEditClicked, zb as SettingsSurveyQuestionEditorCancelled, Bb as SettingsSurveyQuestionReordered, Vb as SettingsSurveyQuestionUpdated, Hb as SettingsSurveyUnsavedChangesDialogShown, Ub as SettingsSurveyUnsavedChangesDiscarded, Wb as SettingsSurveyUnsavedChangesKept, Gb as SettingsTagsAddTagButtonClicked, Kb as SettingsTagsTagActivated, qb as SettingsTagsTagDeactivated, Jb as SettingsTeamAddTeamButtonClicked, Yb as SettingsTeamDetailsAddAgentsButtonClicked, Xb as SettingsTeamEditTeamButtonClicked, Zb as SettingsTeamModalFormSubmitted, Qb as SettingsTeamRemoveTeamButtonClicked, $b as SettingsTeamRemoveTeamConfirmed, ex as SettingsTemplatesAddTemplateButtonClicked, tx as SettingsTemplatesEditTemplateButtonClicked, nx as SettingsTemplatesModalFormSubmitted, rx as SettingsTemplatesRemoveTemplateButtonClicked, ix as SettingsTemplatesRemoveTemplateConfirmed, ax as SettingsTemplatesTabClicked, ox as SharedWorkerTabOrWindowChanged, sx as SharedWorkerTabOrWindowClosed, cx as SharedWorkerTabOrWindowOpened, lx as SidebarAddAgentButtonClicked, ux as SidebarCollapsed, dx as SidebarExpanded, fx as SidebarNavClicked, px as SignOutAborted, mx as SignOutConfirmed, hx as SimultaneousRingUpdated, gx as SlaPoliciesReordered, _x as SlaPolicyActivated, vx as SlaPolicyCreated, yx as SlaPolicyDeactivated, bx as SlaPolicyDeleted, xx as SlaPolicyUpdated, Sx as SmartConversationReplyButtonClicked, Cx as SubflowBackToMainFlowNodeReused, wx as SubflowBackToMainFlowNodeUsed, Tx as SubflowCreatedFromHighlightedNodes, Ex as SubflowCreatedFromScratch, Dx as SubflowReused, Ox as TagSelectCreateNewTagClicked, kx as TagsCreateModalColorChanged, Ax as TagsCreateModalFormSubmitted, jx as TagsCreateModalOpened, Mx as TeamAgentActionsMenuItemClicked, Nx as TeamAgentActionsMenuOpened, Px as TeamAgentCollapsed, Fx as TeamAgentExpanded, Ix as TeamFavoriteToggled, Lx as ThemeImported, Rx as ThemeShared, zx as ThemeUpdated, Bx as TopbarBeamerOpened, Vx as TopbarEmailOpened, Hx as TopbarNotificationsOpened, Ux as TopbarPhonesOpened, Wx as TopbarSearchQuickActionClicked, Gx as TopbarSupportOpened, Kx as UserModalFormSubmitted, qx as UserModalRoleChanged, Jx as UserModalUserTypeChanged, Yx as WebsocketActiveConnectionChanged, Xx as WebsocketCloseEventReceived, Zx as WebsocketConnectionClosed, Qx as WebsocketConnectionCreated, $x as WebsocketReconnectAttemptStarted, nS as ampli, rS as groupIdentify };

//# sourceMappingURL=index.js.map